import usePermission from '../../../config/permissions';
import React, { useEffect, useRef, useState } from 'react'
import { toast, ToastContainer } from 'react-toastify';
import { BASE_URL } from '../../../config/axios';
import axios from 'axios';
import { customSortByKey, CustomTooltip, getNumberSuffix, handleAllError, handleErrorToast, formatFieldName, downloadAsExcel } from '../../CustomFunctions';
import { AddwithBlueCircle, AddwithWhiteCircle, CrosswithGreyCircle, CrosswithRedCircle, DeleteDustbin, DropdownArrowOption, Eye, PreviousIcon, UpdatePencil, WarnYellow, InfoIcon, DownloadIcon, ReDo } from '../../AllSvg';
import { Modal } from 'react-bootstrap';
import Select from 'react-select';
import { formatDate, formattedDateNoYear } from '../../Date';
import { CSSForSelect, CSSForSelectSmallWidth, monthNames } from '../../CustomUtilities';
import { MultipleBulkApiResultSummaryModal } from '../../UserDetails/userDetails-comp/SalaryStructureComponents';
import Loader from '../../Loader';


const SettingRow = ({ setting, fieldName, label, fieldFor, fieldType, onUpdate, required, SUPER_ADMIN }) => {

    // const displayValue = fieldType === 'checkbox'
    //     ? (setting[fieldName] ? 'Enabled' : 'Disabled')
    //     : (setting[fieldName] || 'Not set');

    const displayValue = fieldType === 'checkbox'
        ? (setting[fieldName] ? 'Enabled' : 'Disabled')
        : (
            setting[fieldName] !== null &&
            setting[fieldName] !== undefined &&
            setting[fieldName] !== ''
        )
            ? setting[fieldName]
            : 'Not Set';

    return (
        <li>
            <div className="flex-row">
                <label className="form-labels font-weight500 announce-date">
                    {label}{required && <span className="required">*</span>} : {formatFieldName(displayValue)} {fieldFor || ''}
                </label>
                {SUPER_ADMIN &&
                    <>
                        <hr className="field-cont-hr" />
                        <EditSettingButton
                            setting={setting}
                            fieldName={fieldName}
                            label={label}
                            fieldType={fieldType}
                            onUpdate={onUpdate}
                            required={required}
                        />
                    </>
                }
            </div>
        </li>
    );
};

const PayrollCycleRow = ({
    setting,
    onUpdate,
    SUPER_ADMIN,
}) => {
    const [showModal, setShowModal] = useState(false);

    const displayValue =
        setting.payroll_start_date || setting.payroll_end_date
            ? `Day ${setting.payroll_start_date || "-"} → Day ${setting.payroll_end_date || "-"}`
            : "Not Set";

    return (
        <li>
            <div className="flex-row">
                <label className="form-labels font-weight500 announce-date">
                    Payroll Cycle : {displayValue}
                </label>

                {SUPER_ADMIN && (
                    <>
                        <hr className="field-cont-hr" />

                        <button
                            className="model-edit-button-ml"
                            onClick={() => setShowModal(true)}
                            style={{ width: "24px" }}
                        >
                            <UpdatePencil />
                        </button>

                        <PayrollCycleModal
                            show={showModal}
                            onHide={() => setShowModal(false)}
                            setting={setting}
                            onUpdate={onUpdate}
                        />
                    </>
                )}
            </div>
        </li>
    );
};

const PayrollCycleModal = ({
    show,
    onHide,
    setting,
    onUpdate
}) => {
    const [startDay, setStartDay] = useState(
        setting.payroll_start_date
    );

    const [endDay, setEndDay] = useState(
        setting.payroll_end_date
    );

    const [loading, setLoading] = useState(false);

    const days = Array.from(
        { length: 31 },
        (_, i) => i + 1
    );

    const handleClear = () => {
        setStartDay("");
        setEndDay("");
    };


    const handleSave = async () => {
        try {
            setLoading(true);

            // await onUpdate(startDay, endDay);
            await onUpdate(startDay || null, endDay || null);
            onHide();
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal
            show={show}
            onHide={onHide}
            dialogClassName="request-leave"
        >
            <Modal.Header closeButton>
                <Modal.Title>
                    Payroll Cycle
                </Modal.Title>
            </Modal.Header>

            <Modal.Body>

                <h6>Start Day</h6>

                <div className="expense-circle-outer">
                    {days.map(day => (
                        <button
                            key={day}
                            type="button"
                            className={`expsense-circle ${Number(startDay) === day
                                ? "expsense-circle-selected-payroll"
                                : "expsense-circle-general"
                                }`}
                            onClick={() =>
                                setStartDay(day)
                            }
                        >
                            {day}
                        </button>
                    ))}
                </div>

                <hr />

                <h6>End Day</h6>

                <div className="expense-circle-outer">
                    {days.map(day => (
                        <button
                            key={day}
                            type="button"
                            className={`expsense-circle ${Number(endDay) === day
                                ? "expsense-circle-selected-payroll"
                                : "expsense-circle-general"
                                }`}
                            onClick={() =>
                                setEndDay(day)
                            }
                        >
                            {day}
                        </button>
                    ))}
                </div>

                <div className="button-models">
                    <button
                        className="model-button model-button-cancel"
                        onClick={onHide}
                    >
                        Cancel
                    </button>
                    <button
                        className="model-button model-button-cancel"
                        onClick={handleClear}
                        disabled={loading}
                    >
                        Clear
                    </button>

                    <button
                        className="model-button model-button-leave"
                        onClick={handleSave}
                        disabled={loading}
                    >
                        {loading
                            ? "Saving..."
                            : "Save Changes"}
                    </button>
                </div>

            </Modal.Body>
        </Modal>
    );
};

const SettingListRow = ({ setting, fieldName, label, getSettingsData, SUPER_ADMIN }) => {
    const displayValue = (setting[fieldName]?.length > 0 ? '' : 'Not set');

    // Check if the field is an array and has data
    const isArrayField = Array.isArray(setting[fieldName]);
    const hasArrayData = isArrayField && setting[fieldName]?.length > 0;

    return (
        <li>
            <div className="flex-column">
                <div className="flex-row">
                    <label className="form-labels font-weight500 announce-date">
                        {label}: {displayValue}
                    </label>
                    {SUPER_ADMIN &&
                        <>
                            <hr className="field-cont-hr" />
                            {fieldName === 'portal_setting_leave_increment' &&
                                <EditLeaveAddSettingButton
                                    setting={setting}
                                    fieldName={fieldName}
                                    label={label}
                                    getSettingsData={getSettingsData}
                                />}

                            {fieldName === 'portal_setting_leave_encashment' &&
                                <EditLeaveEncashSettingButton
                                    setting={setting}
                                    fieldName={fieldName}
                                    label={label}
                                    getSettingsData={getSettingsData}
                                />}
                        </>
                    }

                </div>
            </div>
            <ul>
                {fieldName === 'portal_setting_leave_increment' &&
                    setting[fieldName]?.length > 0 && setting[fieldName]?.map((item, index) => (
                        <li key={index}>
                            <b>{item.leave_addition_amount} {item.leave_addition_type}</b> on <b>{item.leave_addition_date}{getDaySuffix(item.leave_addition_date)}</b> day of the month for <b>{item.employee_type}</b>  employees
                        </li>
                    ))
                }
                {fieldName === 'portal_setting_leave_encashment' &&
                    setting[fieldName]?.length > 0 && setting[fieldName]?.map((item, index) => (
                        <li key={index}>
                            <b>{item.leave_encashment_type}</b> on <b>{formattedDateNoYear(item.leave_encashment_date)}</b>
                        </li>
                    ))
                }
                {setting[fieldName]?.length === 0 && (
                    <li>No items added</li>
                )}
            </ul>
        </li>
    );
};

const DROPDOWN_OPTIONS = {
    weeklyoff_marking_date: [
        { value: 'Days', label: 'Days' },
        { value: 'Monthly', label: 'Monthly' },
        { value: 'Biweekly', label: 'Biweekly' },
        { value: 'Weekly', label: 'Weekly' },
        { value: 'Quarterly', label: 'Quarterly' },
        { value: 'Yearly', label: 'Yearly' }
    ],
    holiday_marking_date: [
        { value: 'Days', label: 'Days' },
        { value: 'Monthly', label: 'Monthly' },
        { value: 'Biweekly', label: 'Biweekly' },
        { value: 'Weekly', label: 'Weekly' },
        { value: 'Quarterly', label: 'Quarterly' },
        { value: 'Yearly', label: 'Yearly' }
    ],
    currency_symbol: [
        { value: '₹', label: 'Rupee (₹)' },
        { value: '$', label: 'Dollar ($)' },
        // { value: '€', label: 'Euro (€)' },
        // { value: '£', label: 'Pound (£)' }
    ],
    sandwich_holiday_rule: [
        { value: 'include_holiday_cover', label: 'Include Holiday Cover' },
        { value: 'exclude_holiday_cover', label: 'Exclude Holiday Cover' },
        { value: 'ignore_holiday', label: 'Ignore Holiday' }
    ],
    // sandwitch_rule: [
    //     { value: 'INCLUDE_HOLIDAY_COVER', label: 'Include Holiday Cover' },
    //     { value: 'EXCLUDE_HOLIDAY_COVER', label: 'Exclude Holiday Cover' },
    //     { value: 'IGNORE_HOLIDAY', label: 'Ignore Holiday' }
    // ],

    company_change_visibility: [
        { value: 'all', label: 'All' },
        { value: 'super_admin', label: 'Super Admin' },
        { value: 'admin', label: 'Admin' },
        { value: 'hr', label: 'HR' }
    ]
};

const getDaySuffix = (day) => {
    if (!day) return '';
    const j = day % 10;
    const k = day % 100;
    if (j === 1 && k !== 11) {
        return 'st';
    }
    if (j === 2 && k !== 12) {
        return 'nd';
    }
    if (j === 3 && k !== 13) {
        return 'rd';
    }
    return 'th';
};

// EditSettingButton component
const EditSettingButton = ({ setting, fieldName, label, fieldType, onUpdate, required }) => {
    const [showModal, setShowModal] = useState(false);
    const [value, setValue] = useState(setting[fieldName]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const handleOpen = () => {
        setValue(setting[fieldName]);
        setShowModal(true);
    };

    const handleClose = () => {
        setError('');
        setShowModal(false);
    };


    const validateForm = () => {
        if (required && !value && value !== false) {
            setError(`${label} is required!`);
            return false;
        }
        return true;
    };

    const handleSubmit = async () => {
        if (validateForm()) {
            try {
                setLoading(true);
                await onUpdate(fieldName, value);
                handleClose();
            } catch (error) {
                console.error("Error updating setting:", error);
            } finally {
                setLoading(false);
            }
        }
    };

    const handleInputChange = (newValue) => {
        console.log(newValue, "newvalue");

        setValue(newValue);
        if (required && (newValue || newValue === false)) {
            setError('');
        }
    };

    const renderInputField = () => {
        switch (fieldType) {
            case 'checkbox':
                return (
                    <div className="flex-row">
                        <label htmlFor="" className="form-labels  font-weight500    font-size-subheading">
                            {value ? 'Enabled' : 'Disabled'}
                        </label>
                        <hr style={{ marginTop: '10px' }} className="field-cont-hr" />
                        <div className="checkbox-toggle">
                            <input
                                type="checkbox"
                                checked={value || false}
                                onChange={(e) => handleInputChange(e.target.checked)}
                                id={`${fieldName}-toggle-setting`}
                            />
                            <label htmlFor={`${fieldName}-toggle-setting`}></label>
                        </div>
                    </div>
                );
            case 'number':
                return (
                    <>
                        <input
                            type="number"
                            className='form-input'
                            value={value || ''}
                            onChange={(e) => handleInputChange(e.target.value)}
                            min={0}
                            placeholder="Input a number"
                            onWheel={(e) => e.target.blur()}
                        />
                        {error && <span className="error-message">{error}</span>}
                    </>
                );
            case 'date':
                return (
                    <>
                        <input
                            type="date"
                            className='form-input'
                            value={value || ''}
                            onChange={(e) => handleInputChange(e.target.value)}
                        />
                        {error && <span className="error-message">{error}</span>}
                    </>
                );
            case 'dropdown':
                const options = DROPDOWN_OPTIONS[fieldName] || [];
                return (
                    <>
                        <select
                            className="form-input"
                            value={value || ''}
                            onChange={(e) => handleInputChange(e.target.value)}
                        >
                            <option value="">Select an option</option>
                            {options.map(option => (
                                <option key={option.value} value={option.value}>
                                    {option.label}
                                </option>
                            ))}
                        </select>
                        {error && <span className="error-message">{error}</span>}
                    </>
                );

            // case 'daypicker':
            //     const days = Array.from({ length: 31 }, (_, i) => i + 1);
            //     return (
            //         <div className="day-picker-wrapper">
            //             <div className="expense-circle-outer">
            //                 {days.map((day) => (
            //                     <button
            //                         type="button"
            //                         key={day}
            //                         className={`expsense-circle ${Number(value) === day
            //                             ? 'expsense-circle-selected-payroll'
            //                             : 'expsense-circle-general'
            //                             }`}
            //                         onClick={() => handleInputChange(day)}
            //                     >
            //                         {day}
            //                     </button>
            //                 ))}
            //             </div>
            //             {value && (
            //                 <p className="day-picker-selected-label">
            //                     Selected: <strong>Day {value}</strong> of every month
            //                 </p>
            //             )}
            //             {error && <span className="error-message">{error}</span>}
            //         </div>
            //     );

            case 'daypicker':
                const days = Array.from({ length: 31 }, (_, i) => i + 1);

                return (
                    <>
                        <div className="day-picker-wrapper">

                            <div className="expense-circle-outer">
                                {days.map((day) => (
                                    <button
                                        type="button"
                                        key={day}
                                        className={`expsense-circle ${Number(value) === day
                                            ? 'expsense-circle-selected-payroll'
                                            : 'expsense-circle-general'
                                            }`}
                                        onClick={() => handleInputChange(day)}
                                    >
                                        {day}
                                    </button>
                                ))}
                            </div>

                            <p className="day-picker-selected-label">
                                {value
                                    ? `Selected: Day ${value} of every month`
                                    : 'No day selected'}
                            </p>

                            {error && <span className="error-message">{error}</span>}
                        </div>
                    </>

                );

            default:
                return (
                    <>
                        <input
                            type="text"
                            className='form-input'
                            value={value || ''}
                            onChange={(e) => handleInputChange(e.target.value)}
                        />
                        {error && <span className="error-message">{error}</span>}
                    </>
                );
        }
    };

    return (
        <>
            <button
                className="model-edit-button-ml"
                onClick={handleOpen}
                title={`Edit ${label}`}
                style={{ width: '24px' }}
            >
                <UpdatePencil />
            </button>

            <Modal show={showModal} onHide={handleClose} dialogClassName="request-leave">
                <Modal.Header closeButton>
                    <Modal.Title>Edit {label}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="register-form">
                        <div className="form-flex-wrap">
                            <div className={fieldType === 'checkbox' ? 'flex-row' : 'flex-column'}>
                                {/* <label className="form-labels font-weight500">{label}{required && <span className="required">*</span>} :</label>
                                {renderInputField()} */}
                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        // marginBottom: "12px"
                                    }}
                                >
                                    <label className="form-labels font-weight500">
                                        {label}{required && <span className="required">*</span>} :
                                    </label>

                                    {(fieldName === "payroll_start_date" ||
                                        fieldName === "payroll_end_date") && (
                                            <span
                                                onClick={() => handleInputChange(null)}
                                                style={{
                                                    cursor: "pointer",
                                                    color: "#0d6efd",
                                                    fontSize: "13px",
                                                    background: "white",
                                                    boxShadow: "0 1px 2px rgba(0, 0, 0, 0.1)",
                                                    borderRadius: "8px",
                                                    padding: "4px 8px",
                                                }}
                                            >
                                                Clear
                                            </span>
                                        )}
                                </div>

                                {renderInputField()}
                            </div>
                        </div>
                        <div className="button-models">
                            <button
                                className="model-button model-button-cancel"
                                onClick={handleClose}
                            >
                                Cancel
                            </button>
                            <button
                                type="submit"
                                className="model-button model-button-leave"
                                onClick={handleSubmit}
                                disabled={loading}
                            >
                                {loading ? 'Saving...' : 'Save Changes'}
                            </button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
};

const EditLeaveAddSettingButton = ({ setting, label, getSettingsData }) => {
    const [showModal, setShowModal] = useState(false);
    const [loading, setLoading] = useState(false);

    const handleOpen = () => {
        setFormData(setting);
        setShowModal(true);
    };

    const handleClose = () => {
        setErrors({})
        setShowModal(false);
    };

    const [formData, setFormData] = useState({
        portal_setting_leave_increment:
            [
                {
                    leave_addition_date: null,
                    leave_addition_type: "",
                    leave_addition_amount: 0,
                    employee_type: "",
                    add_for_fixed_asset: true,
                    add_for_current_asset: true,
                },
            ]
    });

    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});
    const [isSubmitted, setIsSubmitted] = useState(false);

    const validateForm = () => {
        const newErrors = {};

        // Basic required fields
        const requiredFields = [];

        // Check basic required fields
        requiredFields.forEach((field) => {
            if (!formData[field]) {
                newErrors[field] = `${field.charAt(0).toUpperCase() + field.slice(1).replace(/_/g, ' ')} is required!`;
            }
        });

        // Validate leave increment settings
        formData.portal_setting_leave_increment.forEach((setting, index) => {
            if (!setting.leave_addition_date) {
                newErrors[`leave_addition_date_${index}`] = "Leave Addition Date is required!";
            }
            if (!setting.leave_addition_type) {
                newErrors[`leave_addition_type_${index}`] = "Leave Addition Type is required!";
            }
            if (setting.leave_addition_amount === null || setting.leave_addition_amount === undefined || setting.leave_addition_amount === "") {
                newErrors[`leave_addition_amount_${index}`] = "Leave Addition Amount is required!";
            }
            if (!setting.employee_type) {
                newErrors[`employee_type_${index}`] = "Employee Type is required!";
            }
        });

        setErrors(newErrors);
        setIsSubmitted(true);

        return Object.keys(newErrors).length === 0;
    };


    const handleAddIncrementSetting = () => {
        setFormData((prevFormData) => ({
            ...prevFormData,
            portal_setting_leave_increment: [
                ...prevFormData.portal_setting_leave_increment,
                {
                    leave_addition_date: null,
                    leave_addition_type: "",
                    leave_addition_amount: 0,
                    employee_type: "",
                    add_for_fixed_asset: true,
                    add_for_current_asset: true,
                },
            ],
        }));
    };

    const handleIncrementSettingInputChange = (index, e) => {
        const { name, value } = e.target;
        setFormData((prevFormData) => {
            const newOthers = [...prevFormData.portal_setting_leave_increment];
            newOthers[index] = {
                ...newOthers[index],
                [name]: value,
            };
            return {
                ...prevFormData,
                portal_setting_leave_increment: newOthers,
            };
        });

        if (value.trim()) {
            setErrors(prevErrors => {
                const newErrors = { ...prevErrors };
                delete newErrors[`${name}_${index}`];
                return newErrors;
            });
        }
    };

    const handleRemoveIncrementSetting = (index) => {
        setFormData((prevFormData) => {
            const newOthers = [...prevFormData.portal_setting_leave_increment];
            newOthers.splice(index, 1);
            return {
                ...prevFormData,
                portal_setting_leave_increment: newOthers,
            };
        });
        setErrors(prevErrors => {
            const newErrors = { ...prevErrors };
            ['leave_addition_date', 'leave_addition_type', 'leave_addition_amount', 'employee_type'].forEach(field => {

                delete newErrors[`${field}_${index}`];
            });
            return newErrors;
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (validateForm()) {
            setLoading(true);
            const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
            try {
                let res = await axios.put(`${BASE_URL}/wfm/portal_setting_leave_update/${formData.id}/`, formData.portal_setting_leave_increment);
                // portal_setting_leave_increment_update_with_logs/<str:pk>/

                if (res.status === 200 || res.status === 201) {
                    await getSettingsData();
                    handleClose();
                } else {
                    alert(res);
                }
            } catch (err) {
                handleAllError(err, loadingToastId)
            } finally {
                setLoading(false); //loading logic
                toast.dismiss(loadingToastId);
            }
        }
    };

    return (
        <>
            <button
                className="model-edit-button-ml"
                onClick={handleOpen}
                title={`Edit ${label}`}
                style={{ width: '24px' }}
            >
                <UpdatePencil />
            </button>

            <Modal show={showModal} onHide={handleClose} dialogClassName="five-sixth-modal">
                <Modal.Header closeButton>
                    <Modal.Title>Edit {label}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="">
                        <div className="form-flex-wrap">
                            <ol>
                                {formData.portal_setting_leave_increment?.map((increment, index) => (
                                    <li>
                                        <div >
                                            <div className="form-flex-wrap" key={index}>
                                                <div className="flex-column">
                                                    <div className="flex-row">
                                                        <div className="flex-column">
                                                            <label htmlFor={`leave_addition_date_${index}`} className="form-labels font-weight500 font-size-heading">
                                                                Leave Addition Day of Month
                                                            </label>
                                                        </div>
                                                        {(
                                                            <button type='button' title="Remove" className="align-center justify-center" onClick={() => handleRemoveIncrementSetting(index)}>
                                                                <CrosswithGreyCircle />
                                                            </button>
                                                        )}
                                                    </div>
                                                    <input
                                                        id={`leave_addition_date_${index}`}
                                                        type="number"
                                                        name="leave_addition_date"
                                                        placeholder="1-28"
                                                        min={1}
                                                        max={28}
                                                        onChange={(e) => handleIncrementSettingInputChange(index, e)}
                                                        value={increment.leave_addition_date || ""}
                                                        className="form-input"
                                                        onWheel={(e) => e.target.blur()}
                                                    />
                                                    {errors[`leave_addition_date_${index}`] && (
                                                        <span className="error-message">{errors[`leave_addition_date_${index}`]}</span>
                                                    )}
                                                </div>

                                                <div className="flex-column">
                                                    <label htmlFor={`leave_addition_type_${index}`} className="form-labels font-weight500 font-size-heading">
                                                        Leave Addition Type
                                                    </label>
                                                    <select
                                                        id={`leave_addition_type_${index}`}
                                                        name="leave_addition_type"
                                                        onChange={(e) => handleIncrementSettingInputChange(index, e)}
                                                        value={increment.leave_addition_type || ""}
                                                        className="form-input"
                                                    >
                                                        <option value="">Select Leave Type</option>
                                                        <option value="previous leave">Previous Leave</option>
                                                        <option value="casual leave">Casual Leave</option>
                                                        <option value="sick leave">Sick Leave</option>
                                                        {/* <option value="earn leave">Earn Leave</option>
                                                        <option value="short leave">Short Leave</option> */}
                                                    </select>
                                                    {errors[`leave_addition_type_${index}`] && (
                                                        <span className="error-message">{errors[`leave_addition_type_${index}`]}</span>
                                                    )}
                                                </div>

                                                <div className="flex-column">
                                                    <label htmlFor={`leave_addition_amount_${index}`} className="form-labels font-weight500 font-size-heading">
                                                        Leave Addition Amount
                                                    </label>
                                                    <input
                                                        id={`leave_addition_amount_${index}`}
                                                        type="number"
                                                        name="leave_addition_amount"
                                                        placeholder="0"
                                                        min={0}
                                                        onWheel={(e) => e.target.blur()}
                                                        onChange={(e) => handleIncrementSettingInputChange(index, e)}
                                                        value={increment.leave_addition_amount}
                                                        className="form-input"
                                                    />
                                                    {errors[`leave_addition_amount_${index}`] && (
                                                        <span className="error-message">{errors[`leave_addition_amount_${index}`]}</span>
                                                    )}
                                                </div>

                                                <div className="flex-column">
                                                    <label htmlFor={`employee_type_${index}`} className="form-labels font-weight500 font-size-heading">
                                                        Employee Type
                                                    </label>
                                                    <select
                                                        id={`employee_type_${index}`}
                                                        name="employee_type"
                                                        onChange={(e) => handleIncrementSettingInputChange(index, e)}
                                                        value={increment.employee_type || ""}
                                                        className="form-input"
                                                    >
                                                        <option value="">Select Employee Type</option>
                                                        <option value="permanent">Permanent</option>
                                                        <option value="temporary">Temporary</option>
                                                        <option value="probation">Probation</option>
                                                        <option value="termination">Termination</option>
                                                        <option value="resigned">Resigned</option>
                                                        <option value="absconding">Absconding</option>
                                                        <option value="healthissue">Health Issue</option>
                                                        <option value="intern">Intern</option>
                                                        <option value="trainee">Trainee</option>
                                                        <option value="transferred">Transferred</option>
                                                    </select>
                                                    {errors[`employee_type_${index}`] && (
                                                        <span className="error-message">{errors[`employee_type_${index}`]}</span>
                                                    )}
                                                </div>
                                            </div>
                                            <div className="form-flex-wrap" key={index}>
                                                <div className="flex-row">
                                                    <label htmlFor={`add_for_fixed_asset_${index}`} className="form-labels font-weight500 font-size-heading">
                                                        {increment.add_for_fixed_asset ? "Add" : "No"} Leave for Fixed Assets
                                                    </label>
                                                    <hr style={{ marginTop: '10px' }} className="field-cont-hr" />
                                                    <div className="checkbox-toggle">
                                                        <input
                                                            id={`add_for_fixed_asset_${index}`}
                                                            type="checkbox"
                                                            name="add_for_fixed_asset"
                                                            checked={increment.add_for_fixed_asset || false}
                                                            onChange={(e) =>
                                                                setFormData((prevFormData) => {
                                                                    const newOthers = [...prevFormData.portal_setting_leave_increment];
                                                                    newOthers[index] = {
                                                                        ...newOthers[index],
                                                                        add_for_fixed_asset: e.target.checked,
                                                                    };
                                                                    return {
                                                                        ...prevFormData,
                                                                        portal_setting_leave_increment: newOthers,
                                                                    };
                                                                })
                                                            }
                                                        />
                                                        <label htmlFor={`add_for_fixed_asset_${index}`}></label>
                                                    </div>
                                                </div>

                                                <div className="flex-row">
                                                    <label htmlFor={`add_for_current_asset_${index}`} className="form-labels font-weight500 font-size-heading">
                                                        {increment.add_for_current_asset ? "Add" : "No"} Leave for Current Assets
                                                    </label>
                                                    <hr style={{ marginTop: '10px' }} className="field-cont-hr" />
                                                    <div className="checkbox-toggle">
                                                        <input
                                                            id={`add_for_current_asset_${index}`}
                                                            type="checkbox"
                                                            name="add_for_current_asset"
                                                            checked={increment.add_for_current_asset || false}
                                                            onChange={(e) =>
                                                                setFormData((prevFormData) => {
                                                                    const newOthers = [...prevFormData.portal_setting_leave_increment];
                                                                    newOthers[index] = {
                                                                        ...newOthers[index],
                                                                        add_for_current_asset: e.target.checked,
                                                                    };
                                                                    return {
                                                                        ...prevFormData,
                                                                        portal_setting_leave_increment: newOthers,
                                                                    };
                                                                })
                                                            }
                                                        />
                                                        <label htmlFor={`add_for_current_asset_${index}`}></label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                ))}
                            </ol>
                        </div>
                        <div className="jd-heading-outer heading-bg-color-white">
                            <div>
                                <div className="jd-heading-bottom-bold"></div>
                                <div className="jd-heading-bottom-light"></div>
                            </div>
                            <div className="jd-heading-outer-flex">
                                <h2 className="jd-heading-main font-weight600  font-size-heading">
                                    {/* Leave Increments{" "} */}
                                </h2>
                                <button type='button' title="Add Document" className="jd-heading-main font-weight600 -right-button" onClick={handleAddIncrementSetting}>
                                    <AddwithBlueCircle />
                                    Add Leaves
                                </button>
                            </div>
                        </div>
                        <div className="button-models">
                            <button
                                className="model-button model-button-cancel"
                                onClick={handleClose}
                            >
                                Cancel
                            </button>
                            <button
                                type="submit"
                                className="model-button model-button-leave"
                                onClick={handleSubmit}
                                disabled={loading}
                            >
                                {loading ? 'Saving...' : 'Save Changes'}
                            </button>
                        </div>
                        <p className="error-message font-size-text">
                            {isSubmitted && Object.keys(errors).length > 0 && (
                                Object.keys(errors).length > 5 ? (
                                    <h5 className="text-center">Please fill all mandatory fields!</h5>
                                ) : (

                                    <h6 className="text-center">
                                        {Object.keys(errors).map((field) =>
                                            field.charAt(0).toUpperCase() + field.slice(1)
                                        ).join(', ') + ' are required!'}
                                    </h6>
                                )
                            )}
                        </p>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
};

const EditLeaveEncashSettingButton = ({ setting, label, getSettingsData }) => {
    const [showModal, setShowModal] = useState(false);
    const [loading, setLoading] = useState(false);

    const handleOpen = () => {
        setFormData(setting);
        setShowModal(true);
    };

    const handleClose = () => {
        setErrors({})
        setShowModal(false);
    };

    const [formData, setFormData] = useState({
        portal_setting_leave_encashment:
            [
                {
                    leave_encashment_type: "",
                    leave_encashment_date: null,
                },
            ]
    });

    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});
    const [isSubmitted, setIsSubmitted] = useState(false);

    const validateForm = () => {
        const newErrors = {};

        // Basic required fields
        const requiredFields = [];

        // Check basic required fields
        requiredFields.forEach((field) => {
            if (!formData[field]) {
                newErrors[field] = `${field.charAt(0).toUpperCase() + field.slice(1).replace(/_/g, ' ')} is required!`;
            }
        });


        // Validate leave encashment settings
        formData.portal_setting_leave_encashment.forEach((setting, index) => {
            if (!setting.leave_encashment_date) {
                newErrors[`leave_encashment_date_${index}`] = "Leave Encashment Date is required!";
            }
            if (!setting.leave_encashment_type) {
                newErrors[`leave_encashment_type_${index}`] = "Leave Encashment Type is required!";
            }
        });

        setErrors(newErrors);
        setIsSubmitted(true);

        return Object.keys(newErrors).length === 0;
    };


    const handleAddEncashmentSetting = () => {
        setFormData((prevFormData) => ({
            ...prevFormData,
            portal_setting_leave_encashment: [
                ...prevFormData.portal_setting_leave_encashment,
                {
                    leave_encashment_type: "",
                    leave_encashment_date: null,
                },
            ],
        }));
    };

    const handleEncashmentSettingInputChange = (index, e) => {
        const { name, value } = e.target;
        setFormData((prevFormData) => {
            const newOthers = [...prevFormData.portal_setting_leave_encashment];
            newOthers[index] = {
                ...newOthers[index],
                [name]: value,
            };
            return {
                ...prevFormData,
                portal_setting_leave_encashment: newOthers,
            };
        });

        if (value.trim()) {
            setErrors(prevErrors => {
                const newErrors = { ...prevErrors };
                delete newErrors[`${name}_${index}`];
                return newErrors;
            });
        }
    };

    const handleRemoveEncashmentSetting = (index) => {
        setFormData((prevFormData) => {
            const newOthers = [...prevFormData.portal_setting_leave_encashment];
            newOthers.splice(index, 1);
            return {
                ...prevFormData,
                portal_setting_leave_encashment: newOthers,
            };
        });
        setErrors(prevErrors => {
            const newErrors = { ...prevErrors };
            ['leave_encashment_date', 'leave_encashment_type'].forEach(field => {
                delete newErrors[`${field}_${index}`];
            });
            return newErrors;
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (validateForm()) {
            setLoading(true);
            const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
            try {
                let res = await axios.put(`${BASE_URL}/wfm/portal_setting_leave_encashment_update/${formData.id}/`, formData.portal_setting_leave_encashment);
                // portal_setting_leave_encashment_update_with_logs/<str:pk>/

                if (res.status === 200 || res.status === 201) {
                    await getSettingsData();
                    handleClose();
                } else {
                    alert(res);
                }
            } catch (err) {
                handleAllError(err, loadingToastId)
            } finally {
                setLoading(false); //loading logic
                toast.dismiss(loadingToastId);
            }
        }
    };



    return (
        <>
            <button
                className="model-edit-button-ml"
                onClick={handleOpen}
                title={`Edit ${label}`}
                style={{ width: '24px' }}
            >
                <UpdatePencil />
            </button>

            <Modal show={showModal} onHide={handleClose} dialogClassName="five-sixth-modal">
                <Modal.Header closeButton>
                    <Modal.Title>Edit {label}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="">
                        <div className="form-flex-wrap">
                            <ol>
                                {formData.portal_setting_leave_encashment?.map((increment, index) => (
                                    <li>
                                        <div className="form-flex-wrap" key={index}>
                                            <div className="flex-column">
                                                <div className="expense-req">
                                                    <div className="flex-column">
                                                        <label htmlFor={`leave_encashment_date_${index}`} className="form-labels font-weight500 font-size-heading">
                                                            Leave Encashment Date
                                                        </label>
                                                    </div>
                                                    <button type='button' title="Remove" className="align-center justify-center" onClick={() => handleRemoveEncashmentSetting(index)}>
                                                        <CrosswithGreyCircle />
                                                    </button>
                                                </div>
                                                <input
                                                    id={`leave_encashment_date_${index}`}
                                                    type="date"
                                                    name="leave_encashment_date"
                                                    onChange={(e) => handleEncashmentSettingInputChange(index, e)}
                                                    value={increment.leave_encashment_date || ""}
                                                    className="form-input"
                                                    onWheel={(e) => e.target.blur()}
                                                />
                                                {errors[`leave_encashment_date_${index}`] && (
                                                    <span className="error-message">{errors[`leave_encashment_date_${index}`]}</span>
                                                )}
                                            </div>

                                            <div className="flex-column">
                                                <label htmlFor={`leave_encashment_type_${index}`} className="form-labels font-weight500 font-size-heading">
                                                    Leave Encashment Type
                                                </label>
                                                <select
                                                    id={`leave_encashment_type_${index}`}
                                                    name="leave_encashment_type"
                                                    onChange={(e) => handleEncashmentSettingInputChange(index, e)}
                                                    value={increment.leave_encashment_type || ""}
                                                    className="form-input"
                                                >
                                                    <option value="">Select Leave Type</option>
                                                    <option value="previous leave">Previous Leave</option>
                                                    <option value="casual leave">Casual Leave</option>
                                                    <option value="sick leave">Sick Leave</option>
                                                    <option value="earn leave">Earn Leave</option>
                                                    <option value="short leave">Short Leave</option>
                                                </select>
                                                {errors[`leave_encashment_type_${index}`] && (
                                                    <span className="error-message">{errors[`leave_encashment_type_${index}`]}</span>
                                                )}
                                            </div>
                                        </div>
                                    </li>
                                ))}
                            </ol>
                        </div>
                        <div className="jd-heading-outer heading-bg-color-white">
                            <div>
                                <div className="jd-heading-bottom-bold"></div>
                                <div className="jd-heading-bottom-light"></div>
                            </div>
                            <div className="jd-heading-outer-flex">
                                <h2 className="jd-heading-main font-weight600  font-size-heading">
                                </h2>
                                <button type='button' title="Add Document" className="jd-heading-main font-weight600 -right-button" onClick={handleAddEncashmentSetting}>
                                    <AddwithBlueCircle />
                                    Add Rules
                                </button>
                            </div>
                        </div>
                        <div className="button-models">
                            <button
                                className="model-button model-button-cancel"
                                onClick={handleClose}
                            >
                                Cancel
                            </button>
                            <button
                                type="submit"
                                className="model-button model-button-leave"
                                onClick={handleSubmit}
                                disabled={loading}
                            >
                                {loading ? 'Saving...' : 'Save Changes'}
                            </button>
                        </div>
                        <p className="error-message font-size-text">
                            {isSubmitted && Object.keys(errors).length > 0 && (
                                Object.keys(errors).length > 5 ? (
                                    <h5 className="text-center">Please fill all mandatory fields!</h5>
                                ) : (

                                    <h6 className="text-center">
                                        {Object.keys(errors).map((field) =>
                                            field.charAt(0).toUpperCase() + field.slice(1)
                                        ).join(', ') + ' are required!'}
                                    </h6>
                                )
                            )}
                        </p>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
};


const RunManualLeaveEncashment = ({ portalSettings, getDataAPI, company }) => {
    const [show, setShow] = useState(false);
    const [showResults, setShowResults] = useState(false);
    const [apiResults, setApiResults] = useState(null);
    const [buffer1, setBuffering1] = useState(false);
    const [buffer2, setBuffering2] = useState(false);
    const isConfirmedRef = useRef(false);
    const [loading, setLoading] = useState(false);

    const { SUPER_ADMIN, PERMISSION_AUTHORITY, SUB_COMPANIES } = usePermission();
    const [toggleCompany, setToggleCompany] = useState(company || sessionStorage.getItem('company_id'));
    const [active, setActive] = useState('active');
    const [empListForLeaveEncashment, setEmpListForLeaveEncashment] = useState([]);
    const [selectedEmployees, setSelectedEmployees] = useState([]);
    const [showEmployeeSelection, setShowEmployeeSelection] = useState(false);

    // Get leave types from portal settings
    const getLeaveTypesFromSettings = () => {
        const leaveEncashmentSettings = portalSettings?.portal_setting_leave_encashment || [];
        const leaveTypes = {
            casual_leave: false,
            sick_leave: false,
            earn_leave: false,
            short_leave: false,
            previous_leave: false
        };

        leaveEncashmentSettings.forEach(setting => {
            const leaveType = setting.leave_encashment_type?.toLowerCase().replace(/\s/g, '_');
            if (leaveType === 'casual_leave') leaveTypes.casual_leave = true;
            if (leaveType === 'sick_leave') leaveTypes.sick_leave = true;
            if (leaveType === 'earn_leave') leaveTypes.earn_leave = true;
            if (leaveType === 'short_leave') leaveTypes.short_leave = true;
            if (leaveType === 'previous_leave') leaveTypes.previous_leave = true;
        });

        return leaveTypes;
    };

    const [selectedLeaveTypes, setSelectedLeaveTypes] = useState(getLeaveTypesFromSettings());

    // Update selected leave types when portalSettings changes
    useEffect(() => {
        setSelectedLeaveTypes(getLeaveTypesFromSettings());
    }, [portalSettings]);

    const handleShow = () => {
        setShow(true);
    };

    const handleClose = () => {
        setData({
            dry_run: false,
            updated_by: sessionStorage.getItem('emp_code'),
            employees: [],
        });
        setSelectedEmployees([]);
        setShowEmployeeSelection(false);
        setShow(false);
    };

    const handleCloseResults = () => {
        setShowResults(false);
    };

    const handleComplete = () => {
        setShowResults(false);
        if (getDataAPI) getDataAPI();
        handleClose();
    };

    const handleRetry = () => {
        setShowResults(false);
        setTimeout(() => {
            handleSubmit();
        }, 500);
    };

    // Updated API call to use OurCompanyUserDetailsWithLeaveDetailBySubCompanyAPI
    const getEmpListForLeaveEncashment = async () => {
        setBuffering2(true);
        try {
            // Using the new API endpoint
            const res = await axios.get(
                `${BASE_URL}/wfm/ourcompanyuserdetails-withleaves/${toggleCompany}/${active}/`
            );
            const sortedList = customSortByKey(res.data, "emp_code");
            setEmpListForLeaveEncashment(sortedList);
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering2(false);
        }
    };

    const confirmToast = (message, onYes) => {
        const toastId = "confirm-toast-leave-encashment";
        if (toast.isActive(toastId)) return;

        toast.info(
            ({ closeToast }) => (
                <div style={{ textAlign: "center", padding: "8px 4px" }}>
                    <p style={{ marginBottom: "10px" }}>{message}</p>
                    <div style={{ display: "flex", gap: "10px", justifyContent: "center" }}>
                        <button
                            className="model-button model-button-cancel"
                            onClick={() => {
                                toast.dismiss(toastId);
                            }}
                        >
                            No
                        </button>
                        <button
                            className="model-button model-button-leave"
                            onClick={() => {
                                toast.dismiss(toastId);
                                onYes();
                            }}
                        >
                            Yes
                        </button>
                    </div>
                </div>
            ),
            {
                toastId,
                autoClose: false,
                closeOnClick: false,
                draggable: false,
                closeButton: false,
            }
        );
    };

    // Updated submit API for resetting leaves
    const proceedLeaveEncashment = async () => {
        const loadingToastId = toast.loading("Loading: Please wait...");
        try {
            // Prepare leave types list based on portal settings
            const leaveTypes = [];
            if (selectedLeaveTypes.casual_leave) leaveTypes.push("casual_leave");
            if (selectedLeaveTypes.sick_leave) leaveTypes.push("sick_leave");
            if (selectedLeaveTypes.earn_leave) leaveTypes.push("earn_leave");
            if (selectedLeaveTypes.short_leave) leaveTypes.push("short_leave");
            if (selectedLeaveTypes.previous_leave) leaveTypes.push("previous_leave");

            if (leaveTypes.length === 0) {
                toast.error("No leave types configured for encashment in portal settings!");
                return;
            }

            const payload = {
                emp_code: selectedEmployees.map(emp => emp.emp_code),
                leave_type: leaveTypes,
                dry_run: data.dry_run,
                updated_by: data.updated_by
            };

            const response = await axios.post(
                `${BASE_URL}/wfm/manual-leavesreset-by-employeeandleavetypes-withresponse/`,
                // manual-leavesreset-by-employeeandleavetypes-withresponse-logs/
                payload
            );

            if (response.status === 200 || response.status === 201 || response.status === 207) {
                const result = response.data;
                setApiResults(result);
                setShowResults(true);
                toast.success(result.message || "Leave reset completed successfully!");
                // if (getDataAPI) await getDataAPI();
            }
        } catch (error) {
            console.error("Error resetting leaves:", error);

            let formattedResult = {
                failed: [],
                successful: [],
                skipped: [],
                message: "Error occurred while resetting leaves",
                dry_run: data.dry_run,
            };

            if (error.response?.data) {
                const errData = error.response.data;
                formattedResult = {
                    ...formattedResult,
                    ...errData
                };
            }

            setApiResults(formattedResult);
            setShowResults(true);

            toast.error(formattedResult.message || "Leave reset failed", { autoClose: 8000 });
        } finally {
            setLoading(false);
            toast.dismiss(loadingToastId);
            isConfirmedRef.current = false;
        }
    };

    const [data, setData] = useState({
        dry_run: false,
        updated_by: sessionStorage.getItem('emp_code'),
        employees: []
    });

    const handleSubmit = async () => {
        if (loading) return;

        if (!selectedEmployees || selectedEmployees.length === 0) {
            toast.error("No employees selected for Leave Reset!");
            return;
        }

        // Check if any leave type is selected from settings
        const hasLeaveTypeSelected = Object.values(selectedLeaveTypes).some(value => value === true);
        if (!hasLeaveTypeSelected) {
            toast.error("No leave types configured for encashment in portal settings!");
            return;
        }

        // Check if any selected employee has leaves to reset
        const employeesWithLeaves = selectedEmployees.filter(emp => {
            return (
                (selectedLeaveTypes.casual_leave && emp.casual_leave > 0) ||
                (selectedLeaveTypes.sick_leave && emp.sick_leave > 0) ||
                (selectedLeaveTypes.earn_leave && emp.earn_leave > 0) ||
                (selectedLeaveTypes.short_leave && emp.short_leave > 0) ||
                (selectedLeaveTypes.previous_leave && emp.leavebalance > 0)
            );
        });

        if (employeesWithLeaves.length === 0 && !isConfirmedRef.current) {
            confirmToast(
                `Selected employees have no leaves to reset for the configured leave types. Do you want to continue?`,
                async () => {
                    isConfirmedRef.current = true;
                    setLoading(true);
                    await proceedLeaveEncashment();
                }
            );
            return;
        }

        // Show confirmation if dry run is not enabled
        if (!data.dry_run && !isConfirmedRef.current) {
            const leaveTypeNames = Object.entries(selectedLeaveTypes)
                .filter(([_, value]) => value)
                .map(([key]) => key.replace(/_/g, ' '))
                .join(', ');

            confirmToast(
                `Are you sure you want to reset ${leaveTypeNames} for ${selectedEmployees.length} employee(s)? This action cannot be undone.`,
                async () => {
                    isConfirmedRef.current = true;
                    setLoading(true);
                    await proceedLeaveEncashment();
                }
            );
            return;
        }

        setLoading(true);
        proceedLeaveEncashment();
    };

    const toggleEmployee = (employee) => {
        setSelectedEmployees(prev =>
            prev.some(emp => emp.emp_code === employee.emp_code)
                ? prev.filter(emp => emp.emp_code !== employee.emp_code)
                : [...prev, employee]
        );
    };

    const toggleSelectAll = () => {
        setSelectedEmployees(prev =>
            prev.length === empListForLeaveEncashment.length ? [] : [...empListForLeaveEncashment]
        );
    };

    // Auto-select all employees when list loads
    useEffect(() => {
        if (show) {
            getEmpListForLeaveEncashment();
        }
    }, [show, toggleCompany, active]);

    useEffect(() => {
        if (empListForLeaveEncashment.length > 0) {
            setSelectedEmployees([...empListForLeaveEncashment]);
        }
    }, [empListForLeaveEncashment]);

    const isAllSelected = selectedEmployees.length === empListForLeaveEncashment.length && empListForLeaveEncashment.length > 0;

    const employeeOptions = empListForLeaveEncashment.map(emp => ({
        value: emp.emp_code,
        label: `${emp.emp_code} - ${emp.name}`,
    }));

    const { updated_by, message } = apiResults || {};
    const restData = {
        updatedBy: updated_by || '',
        message: message || '',
    };

    // Get leave type display name
    const getLeaveTypeDisplayName = (leaveType) => {
        switch (leaveType) {
            case 'casual_leave':
                return 'Casual Leave';
            case 'sick_leave':
                return 'Sick Leave';
            case 'earn_leave':
                return 'Earn Leave';
            case 'short_leave':
                return 'Short Leave';
            case 'previous_leave':
                return 'Previous Leave';
            default:
                return leaveType.replace(/_/g, ' ');
        }
    };

    // Check if employee has any leaves to reset based on selected types
    const hasLeavesToReset = (emp) => {
        return (
            (selectedLeaveTypes.casual_leave && emp.casual_leave > 0) ||
            (selectedLeaveTypes.sick_leave && emp.sick_leave > 0) ||
            (selectedLeaveTypes.earn_leave && emp.earn_leave > 0) ||
            (selectedLeaveTypes.short_leave && emp.short_leave > 0) ||
            (selectedLeaveTypes.previous_leave && emp.leavebalance > 0)
        );
    };

    // Get list of active leave types for display
    const activeLeaveTypes = Object.entries(selectedLeaveTypes)
        .filter(([_, isActive]) => isActive)
        .map(([type]) => type);

    const tableRef = useRef(null);
    const handleDownloadSelectedEmployeeList = () => {
        downloadAsExcel(tableRef, "users", `Employee Leaves Before Reset List`);
    };

    return (
        <>
            <button
                className="upload-svg"
                title="Reset Employee Leaves"
                onClick={handleShow}
            >
                <ReDo color={'white'} /> Leave Balance
            </button>

            <Modal show={show} onHide={handleClose} dialogClassName="ourcompany-model" size="xl">
                <Modal.Header className="task-Tab-heading font-weight500 font-size-heading">
                    <Modal.Title>
                        Reset Employee Leaves of "{sessionStorage.getItem('company')}"
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="form-flex-wrap">
                        {SUPER_ADMIN ? (
                            <div className="flex-column">
                                <label className="form-labels font-weight500 font-size-subheading">
                                    For Sub Company<span className="required">*</span>
                                </label>
                                <select
                                    id="sub_company"
                                    name="sub_company"
                                    style={{ marginBottom: "8px", cursor: 'not-allowed' }}
                                    value={toggleCompany}
                                    // onChange={(e) => setToggleCompany(e.target.value)}
                                    className='form-input'
                                    disabled

                                >
                                    <option value="">Select Company</option>
                                    {SUB_COMPANIES.map(company => (
                                        <option key={company.id} value={company.id}>{company.title}</option>
                                    ))}
                                </select>
                            </div>
                        ) : null}
                        <div className="flex-column">
                            <label className="form-labels font-weight500 font-size-subheading">
                                Status<span className="required">*</span>
                            </label>
                            <select
                                className='form-input'
                                value={active}
                                onChange={(e) => setActive(e.target.value)}
                            >
                                <option value="null">All</option>
                                <option value="active">Active</option>
                                <option value="inactive">In Active</option>
                            </select>
                        </div>
                    </div>

                    <div className="form-flex-wrap" style={{ backgroundColor: "#f8f9fa", borderRadius: "8px", marginBottom: "9px" }}>
                        <div className="form-column" style={{ padding: "15px" }}>
                            {PERMISSION_AUTHORITY && (
                                <div className="flex-row justify-between">
                                    <div className="flex-row align-end">
                                        <div className="checkbox-toggle">
                                            <input
                                                type="checkbox"
                                                id="employee_selection_toggle"
                                                checked={showEmployeeSelection}
                                                onChange={(e) => setShowEmployeeSelection(e.target.checked)}
                                            />
                                            <label htmlFor="employee_selection_toggle"></label>
                                        </div>
                                        <hr className="field-cont-hr" />
                                        <label htmlFor="employee_selection_toggle" className="form-labels" style={{ cursor: "pointer" }}>
                                            Enable Employee Selection
                                        </label>
                                    </div>
                                </div>
                            )}
                        </div>
                        <div className="form-column" style={{ padding: "15px" }}>
                            {SUPER_ADMIN && (
                                <div className="flex-row justify-between">
                                    <div className="flex-row align-end">
                                        <div className="checkbox-toggle">
                                            <input
                                                type="checkbox"
                                                id="dry_run"
                                                checked={data.dry_run}
                                                onChange={(e) => setData({ ...data, dry_run: e.target.checked })}
                                            />
                                            <label htmlFor="dry_run"></label>
                                        </div>
                                        <hr className="field-cont-hr" />
                                        <label htmlFor="dry_run" className="form-labels" style={{ cursor: "pointer" }}>
                                            Dry-run Mode (validate only, no database changes)
                                        </label>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>

                    {/* Leave Types Information from Portal Settings */}
                    <div className="form-flex-wrap" style={{ backgroundColor: "#e3f2fd", borderRadius: "8px", marginBottom: "15px", padding: "15px" }}>
                        <div className="flex-column w-full">
                            <div className="flex-row w-full justify-between">
                                <div>
                                    <label className="form-labels font-weight500 font-size-subheading" style={{ marginBottom: "10px", color: "#1976d2" }}>
                                        <strong>Leave Encashment Configuration (from Portal Settings)</strong>
                                    </label>
                                </div>
                                {activeLeaveTypes.length > 0 ? (
                                    <div className="flex-row gap-3 flex-wrap">
                                        {activeLeaveTypes.map(leaveType => (
                                            <div key={leaveType} className="flex-row align-end" style={{ backgroundColor: "#fff", padding: "5px 10px", borderRadius: "12px", border: "1px solid #1976d2" }}>
                                                {/* <div className="checkbox-toggle">
                                                <input
                                                    type="checkbox"
                                                    id={`${leaveType}_info`}
                                                    checked={true}
                                                    readOnly
                                                    disabled
                                                />
                                                <label htmlFor={`${leaveType}_info`}></label>
                                            </div> */}
                                                {/* <hr className="field-cont-hr" /> */}
                                                <label style={{ cursor: "default", color: "#1976d2", fontWeight: "500" }}>
                                                    {getLeaveTypeDisplayName(leaveType)}
                                                </label>
                                            </div>
                                        ))}
                                    </div>
                                ) : (
                                    <div className="notice-badge color-badge-warning">
                                        No leave types configured for encashment in portal settings.
                                    </div>
                                )}
                            </div>
                            <div className="font-size-text mt-2 text-secondary-color">
                                <small>These leave types will be reset to ZERO for selected employees as per portal settings.</small>
                            </div>
                        </div>
                    </div>

                    {showEmployeeSelection && (
                        <>
                            <div className="flex-column" style={{ cursor: 'not-allowed' }}>
                                <label className="form-labels font-weight500 font-size-subheading">
                                    Select Employees<span className="required">*</span>
                                </label>
                                {buffer2 ? (
                                    <div className="form-loader">
                                        <div className="bar-loader"></div>
                                    </div>
                                ) : (
                                    <Select
                                        options={employeeOptions}
                                        isMulti
                                        value={employeeOptions.filter(opt =>
                                            selectedEmployees.some(emp => emp.emp_code === opt.value)
                                        )}
                                        isDisabled={true}
                                        onChange={() => { }}
                                        styles={{
                                            control: (provided) => ({
                                                ...provided,
                                                width: '98%',
                                                minHeight: '50px',
                                                borderRadius: '10px',
                                                border: '1px solid #e3e3e3',
                                                margin: '10px 0px 20px 0px',
                                                color: '#4a4a4a',
                                                backgroundColor: '#f7f8fa',
                                                padding: '0px 10px',
                                            }),
                                            placeholder: (provided) => ({ ...provided, color: '#4a4a4a' }),
                                            menu: (provided) => ({ ...provided, borderRadius: '10px', marginTop: '0' }),
                                            input: (provided) => ({ ...provided, color: '#4a4a4a' }),
                                            singleValue: (provided) => ({ ...provided, color: '#4a4a4a' }),
                                        }}
                                    />
                                )}
                            </div>

                        </>
                    )}
                    {!buffer2 && <div className='flex-row justify-between'>
                        <div>
                            <label className="form-labels font-weight500 font-size-subheading">
                                Selected Employees : {selectedEmployees.length}
                            </label>
                        </div>
                        <div className="btn-cont">
                            {(selectedEmployees.length > 0) && !buffer2 &&
                                <button className=" model-button-print" title="Download Employee List in Excel Format" onClick={handleDownloadSelectedEmployeeList}>
                                    <DownloadIcon />
                                </button>
                            }
                        </div>
                    </div>}
                    <div className="table-container scroll-container-table" style={{ marginBottom: '20px' }}>
                        <table ref={tableRef} className="table-css" style={{ overflow: 'auto' }}>
                            <thead className="table-heading">
                                <tr className="custom-table-head-tr scroll-fix-table-heading">
                                    {showEmployeeSelection && (
                                        <th className="table-heading align-center">
                                            <label className="checkbox-click" style={{ height: '16px' }}>
                                                <input
                                                    type="checkbox"
                                                    checked={isAllSelected}
                                                    disabled={empListForLeaveEncashment.length === 0}
                                                    onChange={toggleSelectAll}
                                                />
                                                <div className="checkmark-medium"></div>
                                            </label>
                                        </th>
                                    )}
                                    <th className="table-heading align-center">S.No.</th>
                                    <th className="table-heading align-center">Emp Code</th>
                                    <th className="table-heading align-center">Name</th>
                                    <th className="table-heading align-center">Employee Status</th>
                                    {/* <th className="table-heading align-center">Company</th> */}
                                    {selectedLeaveTypes.previous_leave && (
                                        <th className="table-heading align-center">Previous Leave</th>
                                    )}
                                    {selectedLeaveTypes.casual_leave && (
                                        <th className="table-heading align-center">Casual Leave</th>
                                    )}
                                    {selectedLeaveTypes.sick_leave && (
                                        <th className="table-heading align-center">Sick Leave</th>
                                    )}
                                    {selectedLeaveTypes.earn_leave && (
                                        <th className="table-heading align-center">Earn Leave</th>
                                    )}
                                    {selectedLeaveTypes.short_leave && (
                                        <th className="table-heading align-center">Short Leave</th>
                                    )}
                                    <th className="table-heading align-center">Remarks</th>
                                </tr>
                            </thead>
                            {
                                !buffer2 &&
                                <tbody className="align-center">
                                    {empListForLeaveEncashment.map((emp, index) => {
                                        const isSelected = selectedEmployees.some(
                                            e => e.emp_code === emp.emp_code
                                        );
                                        const hasLeaves = hasLeavesToReset(emp);
                                        const isDisabled = !hasLeaves;

                                        return (
                                            <tr
                                                key={emp.emp_code}
                                                className={`custom-table-head-td
                                                ${isSelected ? "row-selected" : ""} 
                                                ${isDisabled ? "row-disabled" : ""}
                                            `}
                                                onClick={() => {
                                                    if (showEmployeeSelection && !isDisabled) toggleEmployee(emp);
                                                }}
                                                title={
                                                    isDisabled
                                                        ? "No leaves to reset for configured leave types."
                                                        : ""
                                                }
                                                style={{ cursor: showEmployeeSelection && !isDisabled ? "pointer" : "default" }}
                                            >
                                                {showEmployeeSelection && (
                                                    <td className="align-center">
                                                        {!isDisabled && (
                                                            <label className="checkbox-click" onClick={(e) => e.stopPropagation()}>
                                                                <input
                                                                    type="checkbox"
                                                                    checked={isSelected}
                                                                    onChange={() => toggleEmployee(emp)}
                                                                    className="form-checkbox-nm"
                                                                />
                                                                <div className="checkmark-medium"></div>
                                                            </label>
                                                        )}
                                                    </td>
                                                )}
                                                <td className="align-center">
                                                    {index + 1}
                                                </td>
                                                <td className="align-center">
                                                    {emp.emp_code}
                                                </td>
                                                <td className="align-center">
                                                    {emp.name}
                                                </td>
                                                <td className={`text-capitalize align-center ${emp.employee_status === "active" ? 'text-success-color' : 'text-danger-color'}`}>
                                                    {emp.employee_status}
                                                </td>
                                                {/* <td className="align-center">
                                                    {emp.division_name || '-'}
                                                </td> */}
                                                {selectedLeaveTypes.previous_leave && (
                                                    <td className="align-center">
                                                        <span className={`font-weight600 ${emp.leavebalance > 0 ? 'text-warning-color' : 'text-secondary-color'}`}>
                                                            {emp.leavebalance || 0}
                                                        </span>
                                                    </td>
                                                )}
                                                {selectedLeaveTypes.casual_leave && (
                                                    <td className="align-center">
                                                        <span className={`font-weight600 ${emp.casual_leave > 0 ? 'text-warning-color' : 'text-secondary-color'}`}>
                                                            {emp.casual_leave || 0}
                                                        </span>
                                                    </td>
                                                )}
                                                {selectedLeaveTypes.sick_leave && (
                                                    <td className="align-center">
                                                        <span className={`font-weight600 ${emp.sick_leave > 0 ? 'text-warning-color' : 'text-secondary-color'}`}>
                                                            {emp.sick_leave || 0}
                                                        </span>
                                                    </td>
                                                )}
                                                {selectedLeaveTypes.earn_leave && (
                                                    <td className="align-center">
                                                        <span className={`font-weight600 ${emp.earn_leave > 0 ? 'text-warning-color' : 'text-secondary-color'}`}>
                                                            {emp.earn_leave || 0}
                                                        </span>
                                                    </td>
                                                )}
                                                {selectedLeaveTypes.short_leave && (
                                                    <td className="align-center">
                                                        <span className={`font-weight600 ${emp.short_leave > 0 ? 'text-warning-color' : 'text-secondary-color'}`}>
                                                            {emp.short_leave || 0}
                                                        </span>
                                                    </td>
                                                )}
                                                <td className="align-center">
                                                    <div className="font-size-text mt-1 text-secondary-color">
                                                        {hasLeaves
                                                            ? "Has leaves to reset"
                                                            : 'No leaves to reset for configured types'}
                                                    </div>
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>}
                        </table>
                        {buffer2 &&
                            <Loader container={true} />
                        }
                    </div>
                    <div className='notice-badge color-badge-warning font-size-subheading mt-2'>
                        <strong>Important Notes:</strong><br />
                        1. This action will reset the configured leave types to ZERO for the selected employees.<br />
                        2. Configured leave types are based on Portal Settings → Leaves Encashment.<br />
                        3. Once reset, the leave balances cannot be recovered.<br />
                        4. The reset will affect the selected employees' leave records permanently.<br />
                        5. Use Dry-run mode to preview the changes before actual execution.<br />
                        {data.dry_run && <><br />6. <strong>DRY-RUN MODE:</strong> No database changes will be made.</>}
                    </div>

                    <div className="button-models">
                        <button
                            className="model-button model-button-cancel font-weight500"
                            onClick={handleClose}
                            disabled={loading}
                        >
                            Cancel
                        </button>
                        <button
                            type="submit"
                            className="model-button font-weight500 model-button-leave font-size-heading"
                            onClick={handleSubmit}
                            disabled={loading || activeLeaveTypes.length === 0}
                        >
                            {loading ? "Processing..." : "Reset Configured Leaves"}
                        </button>
                    </div>
                </Modal.Body>
                <ToastContainer position="top-center" autoClose={5000} hideProgressBar={false} newestOnTop closeOnClick rtl={false} draggable pauseOnHover />
            </Modal >

            <MultipleBulkApiResultSummaryModal
                show={showResults}
                handleClose={handleCloseResults}
                handleComplete={handleComplete}
                handleRetry={handleRetry}
                resultsList={apiResults?.results || apiResults}
                isDryRun={data.dry_run}
                operationType="LEAVE_RESET"
                config={{
                    operationTypes: {
                        LEAVE_RESET: 'LEAVE_RESET',
                    },
                    fieldMappings: {
                        // Add leave reset specific mappings
                        reset_count: {
                            label: 'Reset',
                            display: true,
                            color: 'warning'
                        },
                        previous_leave_reset: {
                            label: 'Previous Leave',
                            display: selectedLeaveTypes.previous_leave,
                            color: 'info'
                        },
                        casual_leave_reset: {
                            label: 'Casual Leave',
                            display: selectedLeaveTypes.casual_leave,
                            color: 'info'
                        },
                        sick_leave_reset: {
                            label: 'Sick Leave',
                            display: selectedLeaveTypes.sick_leave,
                            color: 'info'
                        },
                        earn_leave_reset: {
                            label: 'Earn Leave',
                            display: selectedLeaveTypes.earn_leave,
                            color: 'info'
                        },
                        short_leave_reset: {
                            label: 'Short Leave',
                            display: selectedLeaveTypes.short_leave,
                            color: 'info'
                        },
                    }
                }}
            />
        </>
    );
};

const SandwichRuleExplanation = ({ customStyle, settings }) => {
    const [openModal, setOpenModal] = useState(false)
    const sandwichHoliday = settings?.sandwich_holiday;
    const rule = settings?.sandwich_holiday_rule;
    const sandwichEnabled = settings?.sandwich_rule_enabled;
    const isDefaultActive =
        sandwichEnabled === true && !sandwichHoliday;

    const isActiveRule = (type) => rule === type;

    const renderRule = (title, ruleKey, rowPairs = []) => {


        const ruleEnabled = settings?.sandwich_rule_enabled === true;
        const holidayEnabled = settings?.sandwich_holiday === true;
        const hasHolidayRule = !!settings?.sandwich_holiday_rule;

        const isActive =
            !ruleKey
                ? ruleEnabled && (!holidayEnabled || !hasHolidayRule)
                : settings?.sandwich_holiday_rule === ruleKey;



        return (
            <div className={`sandwich-options-rule-block ${isActive ? "active-rule" : ""}`} style={{ padding: '5px', borderRadius: '5px' }}>
                <div className="font-weight600">{title}</div>
                <div className="sandwich-options-patterns">
                    {rowPairs.map((pair, i) => (
                        <React.Fragment key={i}>
                            <div className="sandwich-options-pattern-wrapper">
                                <div className="sandwich-options-row">
                                    {pair.top.map((cell, j) => (
                                        <span key={`top-${i}-${j}`} className={`sandwich-options-cell ${getCellClass(cell)}`}>
                                            {cell}
                                        </span>
                                    ))}
                                </div>
                                <div className="sandwich-options-arrow">↓</div>
                                <div className="sandwich-options-row">
                                    {pair.bottom.map((cell, j) => (
                                        <span key={`bottom-${i}-${j}`} className={`sandwich-options-cell ${getCellClass(cell)}`}>
                                            {cell}
                                        </span>
                                    ))}
                                </div>
                            </div>

                            {/* ✅ Add vertical line between pattern blocks (but not after the last one) */}
                            {i < rowPairs.length - 1 && <div className='justify-center'>
                                {i < rowPairs.length - 1 && <hr style={{ marginTop: '10px' }} className="field-cont-hr" />}
                                {i < rowPairs.length - 1 && <hr className="field-cont-hr" />}
                            </div>}
                        </React.Fragment>
                    ))}
                </div>
            </div>
        )
    }
    if (!sandwichEnabled) return null;



    const getCellClass = (cell) => {
        switch (cell) {
            case 'A': return 'absent';
            case 'H': return 'holiday';
            case 'W': return 'weekend';
            default: return '';
        }
    };

    // const tooltipContent = (
    //     <div className="sandwich-options-tooltip">
    //         <h4 className="sandwich-options-heading">Sandwich Rule Types</h4>
    //         <hr className='line' />



    //         {renderRule("Default Sandwich Rule :", [
    //             { top: ['A', 'W', 'W', 'A'], bottom: ['A', 'A', 'A', 'A'] }
    //         ])}

    //         <hr className='line' />
    //         <ol className="sandwich-rule-list">
    //             <li>
    //                 {renderRule("Include Holiday Cover (IHC) :", [
    //                     { top: ['A', 'H', 'A'], bottom: ['A', 'A', 'A'] },
    //                     { top: ['A', 'H', 'W', 'W', 'A'], bottom: ['A', 'A', 'A', 'A', 'A'] },
    //                 ])}
    //             </li>
    //             <hr className='line' />
    //             <li>
    //                 {renderRule("Exclude Holiday Cover (EHC) :", [
    //                     { top: ['A', 'H', 'A'], bottom: ['A', 'H', 'A'] },
    //                     { top: ['A', 'H', 'W', 'W', 'A'], bottom: ['A', 'H', 'W', 'W', 'A'] },
    //                 ])}
    //             </li>
    //             <hr className='line' />
    //             <li>
    //                 {renderRule("Ignore Holiday :", [
    //                     { top: ['A', 'H', 'A'], bottom: ['A', 'H', 'A'] },
    //                     { top: ['A', 'H', 'W', 'W', 'A'], bottom: ['A', 'H', 'A', 'A', 'A'] },
    //                 ])}
    //             </li>
    //         </ol>
    //         <hr className='line' />
    //         <div className="sandwich-options-legend justify-center">
    //             <span className="legend-item"><span className="sandwich-options-cell small absent">A</span> - Absent</span>
    //             <span className="legend-item"><span className="sandwich-options-cell small holiday">H</span> - Holiday</span>
    //             <span className="legend-item"><span className="sandwich-options-cell small weekend">W</span> - Weekly Off</span>
    //         </div>
    //     </div>
    // );

    const tooltipContent = (
        <div className="sandwich-options-tooltip" >
            <h4 className="sandwich-options-heading">Sandwich Rule Types</h4>
            <hr className="line" style={{ margin: '0px' }} />

            {/* Always show Default rule */}
            {renderRule("Default Sandwich Rule :", "default", [
                { top: ['A', 'W', 'W', 'A'], bottom: ['A', 'A', 'A', 'A'] }
            ])}


            {(sandwichHoliday === true || !settings) && (
                <>
                    <hr className="line" style={{
                        border: "none",
                        height: "2px",
                        backgroundColor: "#000",
                        margin: "10px 0"
                    }} />
                    <div className="font-weight600">Holiday Rule Options :</div>
                    {/* <h5 className='text-center'>Holiday Options</h5> */}
                    <div className='desc-container'>
                        <ol className="sandwich-rule-list">
                            <li>
                                {renderRule("Include Holiday Cover (IHC) :", "include_holiday_cover", [
                                    { top: ['A', 'H', 'A'], bottom: ['A', 'A', 'A'] },
                                    { top: ['A', 'H', 'W', 'W', 'A'], bottom: ['A', 'A', 'A', 'A', 'A'] },
                                ])}
                            </li>
                            <hr className="line" style={{ margin: '0px' }} />
                            <li>
                                {renderRule("Exclude Holiday Cover (EHC) :", "exclude_holiday_cover", [
                                    { top: ['A', 'H', 'A'], bottom: ['A', 'H', 'A'] },
                                    { top: ['A', 'H', 'W', 'W', 'A'], bottom: ['A', 'H', 'W', 'W', 'A'] },
                                ])}
                            </li>
                            <hr className="line" style={{ margin: '0px' }} />
                            <li>
                                {renderRule("Ignore Holiday :", "ignore_holiday", [
                                    { top: ['A', 'H', 'A'], bottom: ['A', 'H', 'A'] },
                                    { top: ['A', 'H', 'W', 'W', 'A'], bottom: ['A', 'H', 'A', 'A', 'A'] },
                                ])}
                            </li>
                        </ol>
                    </div>
                </>
            )}

            <hr className="line" />
            <div className="sandwich-options-legend justify-center">
                <span className="legend-item"><span className="sandwich-options-cell small absent">A</span> - Absent</span>
                <span className="legend-item"><span className="sandwich-options-cell small holiday">H</span> - Holiday</span>
                <span className="legend-item"><span className="sandwich-options-cell small weekend">W</span> - Weekly Off</span>
            </div>
        </div>
    );



    return (
        <>
            <CustomTooltip position="right" tooltipContent={tooltipContent} >
                <button className='' style={{ cursor: 'pointer' }}>
                    <InfoIcon />
                </button>
            </CustomTooltip>
        </>
    );
};


const SetupAllSettingsButton = ({ getSettingsData }) => {
    const [showModal, setShowModal] = useState(false);
    const [loading, setLoading] = useState(false);

    const handleOpen = () => {
        setShowModal(true);
    };

    const handleClose = () => {
        setFormData({
            sub_company: sessionStorage.getItem('company_id'),
            leave_apply_past_limit: "",
            leave_apply_future_limit: "",
            leave_approval_limit: "",
            od_apply_past_limit: "",
            od_apply_future_limit: "",
            od_approval_limit: "",
            arrear_apply_start_limit: "",
            arrear_apply_end_limit: "",
            weeklyoff_marking_date: "",
            holiday_marking_date: "",
            probation_conversion_auto_month: "",
            currency_symbol: "",
            sandwich_rule_enabled: null,
            // sandwitch_rule: "",
            sandwich_holiday_rule: "",
            company_change_visibility: "super_admin",
            show_full_employee_code: null,
            arrear_apply_auto: false,
            salary_slip_visible: null,
            compoff_on_od: null,
            compoff_od_days_limit: "",
            direct_emp_creation: null,
            emp_details_edit: null,
            imprest_project_req: null,
            expense_submit_limit: null,
            expense_submit_limit_days: "",
            payroll_start_date: "",
            payroll_end_date: "",
            portal_setting_leave_increment: [
                {
                    leave_addition_date: null,
                    leave_addition_type: "",
                    leave_addition_amount: "",
                    employee_type: "",
                    add_for_fixed_asset: true,
                    add_for_current_asset: true,
                },
            ],
            portal_setting_leave_encashment: [
                {
                    leave_encashment_type: "",
                    leave_encashment_date: null,
                },
            ],
        })
        setErrors({})
        setShowModal(false);
    };
    const { SUPER_ADMIN } = usePermission();

    const [formData, setFormData] = useState({
        sub_company: sessionStorage.getItem('company_id'),
        leave_apply_past_limit: "",
        leave_apply_future_limit: "",
        leave_approval_limit: "",
        od_apply_past_limit: "",
        od_apply_future_limit: "",
        od_approval_limit: "",
        arrear_apply_start_limit: "",
        arrear_apply_end_limit: "",
        weeklyoff_marking_date: "",
        holiday_marking_date: "",
        probation_conversion_auto_month: "",
        currency_symbol: "",
        sandwich_rule_enabled: null,
        // sandwitch_rule: "",
        sandwich_holiday_rule: "",
        company_change_visibility: "super_admin",
        show_full_employee_code: null,
        arrear_apply_auto: false,
        salary_slip_visible: null,
        compoff_on_od: null,
        direct_emp_creation: null,
        emp_details_edit: null,
        imprest_project_req: null,
        expense_submit_limit: null,
        expense_submit_limit_days: "",
        compoff_auto_apply: true,
        shortleave_auto_apply: true,
        eligible_for_shortleave_credit: true,
        payroll_start_date: "",
        payroll_end_date: "",
        portal_setting_leave_increment: [
            {
                leave_addition_date: null,
                leave_addition_type: "",
                leave_addition_amount: "",
                employee_type: "",
                add_for_fixed_asset: true,
                add_for_current_asset: true,
            },
        ],
        portal_setting_leave_encashment: [
            {
                leave_encashment_type: "",
                leave_encashment_date: null,
            },
        ],
    });


    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});
    const [isSubmitted, setIsSubmitted] = useState(false);

    const validateForm = () => {
        const newErrors = {};

        // Basic required fields
        const requiredFields = [
            'weeklyoff_marking_date',
            'holiday_marking_date',
            'probation_conversion_auto_month',
            'currency_symbol',
            'company_change_visibility'
        ];

        // Check basic required fields
        requiredFields.forEach((field) => {
            if (!formData[field]) {
                newErrors[field] = `${field.charAt(0).toUpperCase() + field.slice(1).replace(/_/g, ' ')} is required!`;
            }
        });

        // Conditional validation for sandwich rule
        if (formData.sandwich_rule_enabled && !formData.sandwich_holiday_rule) {
            newErrors.sandwich_holiday_rule = "Sandwich Rule Type is required when Sandwich Rule is enabled!";
        }

        if (formData.compoff_on_od && !formData.compoff_od_days_limit) {
            newErrors.compoff_od_days_limit = "Days limit for Compoff on OutDuty is required when Compoff on OD is enabled!";
        }

        if (formData.expense_submit_limit && !formData.expense_submit_limit_days) {
            newErrors.expense_submit_limit_days = "Days limit for Expense Submition is required when Expense Submit Limit is enabled!";
        }

        // Payroll Start Date Validation
        if (
            formData.payroll_start_date !== null &&
            (Number(formData.payroll_start_date) < 1 ||
                Number(formData.payroll_start_date) > 31)
        ) {
            newErrors.payroll_start_date =
                "Payroll Cycle Start Day must be between 1 and 31";
        }

        // Payroll End Date Validation
        if (
            formData.payroll_end_date !== null &&
            (Number(formData.payroll_end_date) < 1 ||
                Number(formData.payroll_end_date) > 31)
        ) {
            newErrors.payroll_end_date =
                "Payroll Cycle End Day must be between 1 and 31";
        }

        // Validate leave increment settings
        formData.portal_setting_leave_increment.forEach((setting, index) => {
            if (!setting.leave_addition_date) {
                newErrors[`leave_addition_date_${index}`] = "Leave Addition Date is required!";
            }
            if (!setting.leave_addition_type) {
                newErrors[`leave_addition_type_${index}`] = "Leave Addition Type is required!";
            }
            if (setting.leave_addition_amount === null || setting.leave_addition_amount === undefined || setting.leave_addition_amount === "") {
                newErrors[`leave_addition_amount_${index}`] = "Leave Addition Amount is required!";
            }
            if (!setting.employee_type) {
                newErrors[`employee_type_${index}`] = "Employee Type is required!";
            }
        });

        // Validate leave encashment settings
        formData.portal_setting_leave_encashment.forEach((setting, index) => {
            if (!setting.leave_encashment_date) {
                newErrors[`leave_encashment_date_${index}`] = "Leave Encashment Date is required!";
            }
            if (!setting.leave_encashment_type) {
                newErrors[`leave_encashment_type_${index}`] = "Leave Encashment Type is required!";
            }
        });

        setErrors(newErrors);
        setIsSubmitted(true);

        return Object.keys(newErrors).length === 0;
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setInputState({
            ...inputState,
            [name]: value.trim() ? "green" : "",
        });

        setFormData({
            ...formData,
            [name]: value,
        });

        if (value.trim()) {
            setErrors((prevErrors) => {
                const updatedErrors = { ...prevErrors };
                delete updatedErrors[name];
                return updatedErrors;
            });
        }
    };

    const handleDateChange = (e) => {
        const { name, value } = e.target;

        // Allow only digits
        if (!/^\d*$/.test(value)) {
            setErrors((prev) => ({
                ...prev,
                [name]: "Value must be positive only",
            }));
            return;
        }

        let updatedValue = value;

        //  If user types 0 → convert to null
        if (value === "0") {
            updatedValue = null;
        }

        // Prevent values greater than 31 (ignore null case)
        if (
            updatedValue !== null &&
            updatedValue !== "" &&
            (Number(updatedValue) < 1 || Number(updatedValue) > 31)
        ) {
            setErrors((prev) => ({
                ...prev,
                [name]: "Value must be between 1 and 31",
            }));
            return;
        }

        setInputState({
            ...inputState,
            [name]: updatedValue ? "green" : "",
        });

        setFormData({
            ...formData,
            [name]: updatedValue,
        });

        // Remove error if valid
        setErrors((prevErrors) => {
            const updatedErrors = { ...prevErrors };

            if (
                updatedValue === null ||
                updatedValue === "" ||
                (Number(updatedValue) >= 1 && Number(updatedValue) <= 31)
            ) {
                delete updatedErrors[name];
            }

            return updatedErrors;
        });
    };

    const handleAddIncrementSetting = () => {
        setFormData((prevFormData) => ({
            ...prevFormData,
            portal_setting_leave_increment: [
                ...prevFormData.portal_setting_leave_increment,
                {
                    leave_addition_date: null,
                    leave_addition_type: "",
                    leave_addition_amount: "",
                    employee_type: "",
                    add_for_fixed_asset: true,
                    add_for_current_asset: true,
                },
            ],
        }));
    };

    const handleIncrementSettingInputChange = (index, e) => {
        const { name, value } = e.target;
        setFormData((prevFormData) => {
            const newOthers = [...prevFormData.portal_setting_leave_increment];
            newOthers[index] = {
                ...newOthers[index],
                [name]: value,
            };
            return {
                ...prevFormData,
                portal_setting_leave_increment: newOthers,
            };
        });

        if (value.trim()) {
            setErrors(prevErrors => {
                const newErrors = { ...prevErrors };
                delete newErrors[`${name}_${index}`];
                return newErrors;
            });
        }
    };

    const handleRemoveIncrementSetting = (index) => {
        setFormData((prevFormData) => {
            const newOthers = [...prevFormData.portal_setting_leave_increment];
            newOthers.splice(index, 1);
            return {
                ...prevFormData,
                portal_setting_leave_increment: newOthers,
            };
        });

        setErrors(prevErrors => {
            const newErrors = { ...prevErrors };
            ['leave_addition_date', 'leave_addition_type', 'leave_addition_amount', 'employee_type'].forEach(field => {
                delete newErrors[`${field}_${index}`];
            });
            return newErrors;
        });
    };

    const handleAddEncashmentSetting = () => {
        setFormData((prevFormData) => ({
            ...prevFormData,
            portal_setting_leave_encashment: [
                ...prevFormData.portal_setting_leave_encashment,
                {
                    leave_encashment_type: "",
                    leave_encashment_date: null,
                },
            ],
        }));
    };

    const handleEncashmentSettingInputChange = (index, e) => {
        const { name, value } = e.target;
        setFormData((prevFormData) => {
            const newOthers = [...prevFormData.portal_setting_leave_encashment];
            newOthers[index] = {
                ...newOthers[index],
                [name]: value,
            };
            return {
                ...prevFormData,
                portal_setting_leave_encashment: newOthers,
            };
        });

        if (value.trim()) {
            setErrors(prevErrors => {
                const newErrors = { ...prevErrors };
                delete newErrors[`${name}_${index}`];
                return newErrors;
            });
        }
    };

    const handleRemoveEncashmentSetting = (index) => {
        setFormData((prevFormData) => {
            const newOthers = [...prevFormData.portal_setting_leave_encashment];
            newOthers.splice(index, 1);
            return {
                ...prevFormData,
                portal_setting_leave_encashment: newOthers,
            };
        });

        setErrors(prevErrors => {
            const newErrors = { ...prevErrors };
            ['leave_encashment_date', 'leave_encashment_type'].forEach(field => {
                delete newErrors[`${field}_${index}`];
            });
            return newErrors;
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (validateForm()) {
            setLoading(true); //loading logic
            const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
            try {
                let res = await axios.post(`${BASE_URL}/wfm/portal_settings/`, formData);
                // portal_settings_create_with_logs/

                if (res.status === 200 || res.status === 201) {
                    await getSettingsData();
                    handleClose();
                } else {
                    alert(res);
                }
            } catch (err) {
                handleAllError(err, loadingToastId)
            } finally {
                setLoading(false); //loading logic
                toast.dismiss(loadingToastId);
            }
        }
    };


    return (
        <>
            <button
                onClick={handleOpen}
                title={`Edit All`}
                className="model-button model-button-submit"
            >
                Setup All Settings
            </button>
            <Modal show={showModal} onHide={handleClose} dialogClassName="five-sixth-modal">
                <Modal.Header closeButton>
                    <Modal.Title>Setup Settings for "{sessionStorage.getItem('company')}"</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="register-form">
                        <div className="form-flex-wrap">

                            {/* Leave Settings */}
                            <div title="Leave Apply Limit(Past)" className="flex-column">
                                <label htmlFor="leave_apply_past_limit" className="form-labels font-weight500 font-size-heading">
                                    Leave Apply Limit (Past)
                                </label>
                                <input
                                    id="leave_apply_past_limit"
                                    type="number"
                                    name="leave_apply_past_limit"
                                    placeholder="Enter Leave Apply Limit (Past)"
                                    value={formData.leave_apply_past_limit}
                                    min={0}
                                    onWheel={(e) => e.target.blur()}
                                    onChange={handleInputChange}
                                    className={`form-input ${errors.leave_apply_past_limit ? "error" : inputState.leave_apply_past_limit ? "success" : ""}`}
                                />
                                {errors.leave_apply_past_limit && (
                                    <span className="error-message">{errors.leave_apply_past_limit}</span>
                                )}
                            </div>

                            <div title="Leave Apply Limit(Future)" className="flex-column">
                                <label htmlFor="leave_apply_future_limit" className="form-labels font-weight500 font-size-heading">
                                    Leave Apply Limit (Future)
                                </label>
                                <input
                                    id="leave_apply_future_limit"
                                    type="number"
                                    name="leave_apply_future_limit"
                                    placeholder="Enter Leave Apply Limit (Future)"
                                    value={formData.leave_apply_future_limit}
                                    min={0}
                                    onWheel={(e) => e.target.blur()}
                                    onChange={handleInputChange}
                                    className={`form-input ${errors.leave_apply_future_limit ? "error" : inputState.leave_apply_future_limit ? "success" : ""}`}
                                />
                                {errors.leave_apply_future_limit && (
                                    <span className="error-message">{errors.leave_apply_future_limit}</span>
                                )}
                            </div>

                            <div title="Leave Approval Limit" className="flex-column">
                                <label htmlFor="leave_approval_limit" className="form-labels font-weight500 font-size-heading">
                                    Leave Approval Limit (Days)
                                </label>
                                <input
                                    id="leave_approval_limit"
                                    type="number"
                                    name="leave_approval_limit"
                                    placeholder="Enter Leave Approval Limit"
                                    value={formData.leave_approval_limit}
                                    min={0}
                                    onWheel={(e) => e.target.blur()}
                                    onChange={handleInputChange}
                                    className={`form-input ${errors.leave_approval_limit ? "error" : inputState.leave_approval_limit ? "success" : ""}`}
                                />
                                {errors.leave_approval_limit && (
                                    <span className="error-message">{errors.leave_approval_limit}</span>
                                )}
                            </div>

                            {/* OD Settings */}
                            <div title="OD Apply Limit(Past)" className="flex-column">
                                <label htmlFor="od_apply_past_limit" className="form-labels font-weight500 font-size-heading">
                                    OD Apply Limit (Past)
                                </label>
                                <input
                                    id="od_apply_past_limit"
                                    type="number"
                                    name="od_apply_past_limit"
                                    placeholder="Enter OD Apply Limit (Past)"
                                    value={formData.od_apply_past_limit}
                                    min={0}
                                    onWheel={(e) => e.target.blur()}
                                    onChange={handleInputChange}
                                    className={`form-input ${errors.od_apply_past_limit ? "error" : inputState.od_apply_past_limit ? "success" : ""}`}
                                />
                                {errors.od_apply_past_limit && (
                                    <span className="error-message">{errors.od_apply_past_limit}</span>
                                )}
                            </div>

                            <div title="OD Apply Limit(Future)" className="flex-column">
                                <label htmlFor="od_apply_future_limit" className="form-labels font-weight500 font-size-heading">
                                    OD Apply Limit (Future)
                                </label>
                                <input
                                    id="od_apply_future_limit"
                                    type="number"
                                    name="od_apply_future_limit"
                                    placeholder="Enter OD Apply Limit (Future)"
                                    value={formData.od_apply_future_limit}
                                    min={0}
                                    onWheel={(e) => e.target.blur()}
                                    onChange={handleInputChange}
                                    className={`form-input ${errors.od_apply_future_limit ? "error" : inputState.od_apply_future_limit ? "success" : ""}`}
                                />
                                {errors.od_apply_future_limit && (
                                    <span className="error-message">{errors.od_apply_future_limit}</span>
                                )}
                            </div>

                            <div title="OD Approval Limit" className="flex-column">
                                <label htmlFor="od_approval_limit" className="form-labels font-weight500 font-size-heading">
                                    OD Approval Limit (Days)
                                </label>
                                <input
                                    id="od_approval_limit"
                                    type="number"
                                    name="od_approval_limit"
                                    placeholder="Enter OD Approval Limit"
                                    value={formData.od_approval_limit}
                                    min={0}
                                    onWheel={(e) => e.target.blur()}
                                    onChange={handleInputChange}
                                    className={`form-input ${errors.od_approval_limit ? "error" : inputState.od_approval_limit ? "success" : ""}`}
                                />
                                {errors.od_approval_limit && (
                                    <span className="error-message">{errors.od_approval_limit}</span>
                                )}
                            </div>


                            <div title="Payroll Cycle Start Day" className="flex-column">
                                <label
                                    htmlFor="payroll_start_date"
                                    className="form-labels font-weight500 font-size-heading"
                                >
                                    Payroll Cycle Start Day
                                </label>

                                <input
                                    id="payroll_start_date"
                                    type="text"
                                    inputMode="numeric"
                                    name="payroll_start_date"
                                    placeholder="Enter Payroll Cycle Start Day"
                                    value={formData.payroll_start_date}
                                    maxLength={2}
                                    onWheel={(e) => e.target.blur()}
                                    onChange={handleDateChange}
                                    className={`form-input ${errors.payroll_start_date
                                        ? "error"
                                        : inputState.payroll_start_date
                                            ? "success"
                                            : ""
                                        }`}
                                />

                                {errors.payroll_start_date && (
                                    <span className="error-message">
                                        {errors.payroll_start_date}
                                    </span>
                                )}
                            </div>


                            <div title="Payroll Cycle End Day" className="flex-column">
                                <label
                                    htmlFor="payroll_end_date"
                                    className="form-labels font-weight500 font-size-heading"
                                >
                                    Payroll Cycle End Day
                                </label>

                                <input
                                    id="payroll_end_date"
                                    type="text"
                                    inputMode="numeric"
                                    name="payroll_end_date"
                                    placeholder="Enter Payroll Cycle End Day"
                                    value={formData.payroll_end_date}
                                    maxLength={2}
                                    onWheel={(e) => e.target.blur()}
                                    onChange={handleDateChange}
                                    className={`form-input ${errors.payroll_end_date
                                        ? "error"
                                        : inputState.payroll_end_date
                                            ? "success"
                                            : ""
                                        }`}
                                />

                                {errors.payroll_end_date && (
                                    <span className="error-message">
                                        {errors.payroll_end_date}
                                    </span>
                                )}
                            </div>

                            {/* Arrear Settings */}
                            <div title="Arrear Apply Start Limit" className="flex-column">
                                <label htmlFor="arrear_apply_start_limit" className="form-labels font-weight500 font-size-heading">
                                    Arrear Apply Start Limit
                                </label>
                                <input
                                    id="arrear_apply_start_limit"
                                    type="number"
                                    name="arrear_apply_start_limit"
                                    placeholder="Enter Arrear Apply Start Limit"
                                    value={formData.arrear_apply_start_limit}
                                    min={0}
                                    onWheel={(e) => e.target.blur()}
                                    onChange={handleInputChange}
                                    className={`form-input ${errors.arrear_apply_start_limit ? "error" : inputState.arrear_apply_start_limit ? "success" : ""}`}
                                />
                                {errors.arrear_apply_start_limit && (
                                    <span className="error-message">{errors.arrear_apply_start_limit}</span>
                                )}
                            </div>

                            <div title="Arrear Apply End Limit" className="flex-column">
                                <label htmlFor="arrear_apply_end_limit" className="form-labels font-weight500 font-size-heading">
                                    Arrear Apply End Limit
                                </label>
                                <input
                                    id="arrear_apply_end_limit"
                                    type="number"
                                    name="arrear_apply_end_limit"
                                    placeholder="Enter Arrear Apply End Limit"
                                    value={formData.arrear_apply_end_limit}
                                    min={0}
                                    onWheel={(e) => e.target.blur()}
                                    onChange={handleInputChange}
                                    className={`form-input ${errors.arrear_apply_end_limit ? "error" : inputState.arrear_apply_end_limit ? "success" : ""}`}
                                />
                                {errors.arrear_apply_end_limit && (
                                    <span className="error-message">{errors.arrear_apply_end_limit}</span>
                                )}
                            </div>

                            {/* Date Settings */}
                            <div title="Weeklyoff Marking Date" className="flex-column">
                                <label htmlFor="weeklyoff_marking_date" className="form-labels font-weight500 font-size-heading">
                                    Weeklyoff Marking Date<span className="required">*</span>
                                </label>
                                <select
                                    id="weeklyoff_marking_date"
                                    name="weeklyoff_marking_date"
                                    onChange={handleInputChange}
                                    value={formData.weeklyoff_marking_date}
                                    className={`form-input ${errors.weeklyoff_marking_date ? "error" : inputState.weeklyoff_marking_date ? "success" : ""}`}
                                >
                                    <option value="">Select Frequency</option>
                                    {DROPDOWN_OPTIONS["holiday_marking_date"].map(option => (
                                        <option key={option.value} value={option.value}>
                                            {option.label}
                                        </option>
                                    ))}
                                </select>
                                {errors.weeklyoff_marking_date && (
                                    <span className="error-message">{errors.weeklyoff_marking_date}</span>
                                )}
                            </div>

                            <div title="Holiday Marking Date" className="flex-column">
                                <label htmlFor="holiday_marking_date" className="form-labels font-weight500 font-size-heading">
                                    Holiday Marking Date<span className="required">*</span>
                                </label>
                                <select
                                    id="holiday_marking_date"
                                    name="holiday_marking_date"
                                    onChange={handleInputChange}
                                    value={formData.holiday_marking_date}
                                    className={`form-input ${errors.holiday_marking_date ? "error" : inputState.holiday_marking_date ? "success" : ""}`}
                                >
                                    <option value="">Select Frequency</option>
                                    {DROPDOWN_OPTIONS["holiday_marking_date"].map(option => (
                                        <option key={option.value} value={option.value}>
                                            {option.label}
                                        </option>
                                    ))}
                                </select>
                                {errors.holiday_marking_date && (
                                    <span className="error-message">{errors.holiday_marking_date}</span>
                                )}
                            </div>

                            {/* Other Settings */}
                            <div title="Probation Conversion Auto Month" className="flex-column">
                                <label htmlFor="probation_conversion_auto_month" className="form-labels font-weight500 font-size-heading">
                                    Probation Conversion (Months)<span className="required">*</span>
                                </label>
                                <input
                                    id="probation_conversion_auto_month"
                                    type="number"
                                    name="probation_conversion_auto_month"
                                    placeholder="Enter Probation Conversion Months"
                                    value={formData.probation_conversion_auto_month}
                                    min={0}
                                    onWheel={(e) => e.target.blur()}
                                    onChange={handleInputChange}
                                    className={`form-input ${errors.probation_conversion_auto_month ? "error" : inputState.probation_conversion_auto_month ? "success" : ""}`}
                                />
                                {errors.probation_conversion_auto_month && (
                                    <span className="error-message">{errors.probation_conversion_auto_month}</span>
                                )}
                            </div>

                            <div title="Currency Symbol" className="flex-column">
                                <label htmlFor="currency_symbol" className="form-labels font-weight500 font-size-heading">
                                    Currency Symbol<span className="required">*</span>
                                </label>
                                <select
                                    id="currency_symbol"
                                    name="currency_symbol"
                                    onChange={handleInputChange}
                                    value={formData.currency_symbol}
                                    className={`form-input ${errors.currency_symbol ? "error" : inputState.currency_symbol ? "success" : ""}`}
                                >
                                    <option value="">No Symbol</option>
                                    {DROPDOWN_OPTIONS["currency_symbol"].map(option => (
                                        <option key={option.value} value={option.value}>
                                            {option.label}
                                        </option>
                                    ))}
                                </select>
                                {errors.currency_symbol && (
                                    <span className="error-message">{errors.currency_symbol}</span>
                                )}
                            </div>

                            <div title="Sandwich Rule Type" className="flex-column">
                                <div className="flex-row">

                                    <label htmlFor="sandwich_holiday_rule" className="form-labels font-weight500 font-size-heading">
                                        Sandwich Rule {" "}
                                        <label htmlFor="" className="form-labels  font-weight500    font-size-subheading">
                                            {formData.sandwich_rule_enabled ? 'Enabled' : 'Disabled'}
                                        </label>
                                        {" "}
                                        Type:{formData.sandwich_rule_enabled && <span className="required">*</span>}
                                    </label>
                                    <hr style={{ marginTop: '10px' }} className="field-cont-hr" />
                                    <div className="checkbox-toggle">
                                        <input
                                            id="sandwich_rule_enabled"
                                            name="sandwich_rule_enabled"
                                            type="checkbox"
                                            checked={formData.sandwich_rule_enabled || false}
                                            // onChange={(e) => setFormData({ ...formData, sandwich_rule_enabled: e.target.checked })}
                                            onChange={(e) => {
                                                setFormData({ ...formData, sandwich_rule_enabled: e.target.checked });
                                                setErrors(prevErrors => {
                                                    const newErrors = { ...prevErrors };
                                                    delete newErrors.sandwich_holiday_rule;
                                                    return newErrors;
                                                });
                                            }}
                                        />
                                        <label htmlFor='sandwich_rule_enabled'></label>
                                    </div>
                                    <hr style={{ marginTop: '10px' }} className="field-cont-hr" />
                                    <SandwichRuleExplanation settings={formData} />
                                </div>

                                <select
                                    id="sandwich_holiday_rule"
                                    name="sandwich_holiday_rule"
                                    onChange={handleInputChange}
                                    value={formData.sandwich_holiday_rule}
                                    className={`form-input ${errors.sandwich_holiday_rule ? "error" : inputState.sandwich_holiday_rule ? "success" : ""}`}
                                >
                                    <option value="">Select Rule Type</option>
                                    {DROPDOWN_OPTIONS["sandwich_holiday_rule"].map(option => (
                                        <option key={option.value} value={option.value}>
                                            {option.label}
                                        </option>
                                    ))}
                                </select>
                                {errors.sandwich_holiday_rule && (
                                    <span className="error-message">{errors.sandwich_holiday_rule}</span>
                                )}
                            </div>

                            <div title="Comp Off for WeeklyOff OD" className="flex-column">
                                <div className="flex-row">
                                    <label htmlFor="compoff_on_od" className="form-labels font-weight500 font-size-heading">
                                        Compoff on OD {" "}
                                        <label htmlFor="" className="form-labels  font-weight500    font-size-subheading">
                                            {formData.compoff_on_od ? 'Enabled' : 'Disabled'}
                                        </label>
                                        {" "}
                                        Type:{formData.compoff_on_od && <span className="required">*</span>}
                                    </label>
                                    <hr style={{ marginTop: '10px' }} className="field-cont-hr" />
                                    <div className="checkbox-toggle">
                                        <input
                                            id="compoff_on_od"
                                            name="compoff_on_od"
                                            type="checkbox"
                                            checked={formData.compoff_on_od || false}
                                            // onChange={(e) => setFormData({ ...formData, compoff_on_od: e.target.checked })}
                                            onChange={(e) => {
                                                setFormData({ ...formData, compoff_on_od: e.target.checked });
                                                setErrors(prevErrors => {
                                                    const newErrors = { ...prevErrors };
                                                    delete newErrors.compoff_od_days_limit;
                                                    return newErrors;
                                                });
                                            }}
                                        />
                                        <label htmlFor='compoff_on_od'></label>
                                    </div>
                                </div>
                                <input
                                    id="compoff_od_days_limit"
                                    type="number"
                                    name="compoff_od_days_limit"
                                    placeholder="Enter Max OD limit for Comp Off"
                                    value={formData.compoff_od_days_limit}
                                    min={0}
                                    onWheel={(e) => e.target.blur()}
                                    onChange={handleInputChange}
                                    className={`form-input ${errors.compoff_od_days_limit ? "error" : inputState.compoff_od_days_limit ? "success" : ""}`}
                                />
                                {errors.compoff_od_days_limit && (
                                    <span className="error-message">{errors.compoff_od_days_limit}</span>
                                )}
                            </div>

                            <div title="Expense Submit Limit" className="flex-column">
                                <div className="flex-row">
                                    <label htmlFor="expense_submit_limit" className="form-labels font-weight500 font-size-heading">
                                        Expense Submit Limit {" "}
                                        <label htmlFor="" className="form-labels  font-weight500    font-size-subheading">
                                            {formData.expense_submit_limit ? 'Enabled' : 'Disabled'}
                                        </label>
                                        {" "}
                                        (Days):{formData.expense_submit_limit && <span className="required">*</span>}
                                    </label>
                                    <hr style={{ marginTop: '10px' }} className="field-cont-hr" />
                                    <div className="checkbox-toggle">
                                        <input
                                            id="expense_submit_limit"
                                            name="expense_submit_limit"
                                            type="checkbox"
                                            checked={formData.expense_submit_limit || false}
                                            onChange={(e) => {
                                                setFormData({ ...formData, expense_submit_limit: e.target.checked });
                                                setErrors(prevErrors => {
                                                    const newErrors = { ...prevErrors };
                                                    delete newErrors.expense_submit_limit_days;
                                                    return newErrors;
                                                });
                                            }}
                                        />
                                        <label htmlFor='expense_submit_limit'></label>
                                    </div>
                                </div>
                                <input
                                    id="expense_submit_limit_days"
                                    type="number"
                                    name="expense_submit_limit_days"
                                    placeholder="Enter Expense Submit Limit"
                                    value={formData.expense_submit_limit_days}
                                    min={0}
                                    onWheel={(e) => e.target.blur()}
                                    onChange={handleInputChange}
                                    className={`form-input ${errors.expense_submit_limit_days ? "error" : inputState.expense_submit_limit_days ? "success" : ""}`}
                                />
                                {errors.expense_submit_limit_days && (
                                    <span className="error-message">{errors.expense_submit_limit_days}</span>
                                )}
                            </div>

                            {SUPER_ADMIN && <div title="Company DropDown Visibility" className="flex-column">
                                <label htmlFor="company_change_visibility" className="form-labels font-weight500 font-size-heading">
                                    Company DropDown Visibility<span className="required">*</span>
                                </label>
                                <select
                                    id="company_change_visibility"
                                    name="company_change_visibility"
                                    onChange={handleInputChange}
                                    value={formData.company_change_visibility}
                                    className={`form-input ${errors.company_change_visibility ? "error" : inputState.company_change_visibility ? "success" : ""}`}
                                >
                                    <option value="">Select Role</option>
                                    {DROPDOWN_OPTIONS["company_change_visibility"].map(option => (
                                        <option key={option.value} value={option.value}>
                                            {option.label}
                                        </option>
                                    ))}
                                </select>
                                {errors.company_change_visibility && (
                                    <span className="error-message">{errors.company_change_visibility}</span>
                                )}
                            </div>}
                        </div>

                        <div className="jd-heading-outer heading-bg-color-white">
                            <div className="jd-heading-outer-flex">
                                <h2 className="jd-heading-main font-weight600  font-size-heading">
                                    Prefferences{" "}
                                </h2>
                            </div>
                            <div>
                                <div className="jd-heading-bottom-bold"></div>
                                <div className="jd-heading-bottom-light"></div>
                            </div>
                        </div>

                        <div className="form-flex-wrap">
                            <div title="Show Full Employee Code" className="flex-row">
                                <label htmlFor="show_full_employee_code" className="form-labels font-weight500 font-size-heading">
                                    Show Full Employee Code
                                </label>
                                <hr style={{ marginTop: '10px' }} className="field-cont-hr" />
                                <div className="checkbox-toggle">
                                    <input
                                        id="show_full_employee_code"
                                        type="checkbox"
                                        name="show_full_employee_code"
                                        checked={formData.show_full_employee_code || false}
                                        onChange={(e) => setFormData({ ...formData, show_full_employee_code: e.target.checked })}
                                    />
                                    <label htmlFor="show_full_employee_code"></label>
                                </div>
                            </div>

                            <div title="Arrear Apply Auto" className="flex-row">
                                <label htmlFor="arrear_apply_auto" className="form-labels font-weight500 font-size-heading">
                                    Enable Auto Arrear Apply
                                </label>
                                <hr style={{ marginTop: '10px' }} className="field-cont-hr" />
                                <div className="checkbox-toggle">
                                    <input
                                        id="arrear_apply_auto"
                                        type="checkbox"
                                        name="arrear_apply_auto"
                                        checked={formData.arrear_apply_auto || false}
                                        onChange={(e) => setFormData({ ...formData, arrear_apply_auto: e.target.checked })}
                                    />
                                    <label htmlFor="arrear_apply_auto"></label>
                                </div>
                            </div>

                            <div title="Show Salary Slip" className="flex-row">
                                <label htmlFor="salary_slip_visible" className="form-labels font-weight500 font-size-heading">
                                    Show Salary Slip
                                </label>
                                <hr style={{ marginTop: '10px' }} className="field-cont-hr" />
                                <div className="checkbox-toggle">
                                    <input
                                        id="salary_slip_visible"
                                        type="checkbox"
                                        name="salary_slip_visible"
                                        checked={formData.salary_slip_visible || false}
                                        onChange={(e) => setFormData({ ...formData, salary_slip_visible: e.target.checked })}
                                    />
                                    <label htmlFor="salary_slip_visible"></label>
                                </div>
                            </div>

                            {/* <div title="Comp Off for WeeklyOff OD" className="flex-row">
                                <label htmlFor="compoff_on_od" className="form-labels font-weight500 font-size-heading">
                                    Comp Off for WeeklyOff OD
                                </label>
                                <hr style={{ marginTop: '10px' }} className="field-cont-hr" />
                                <div className="checkbox-toggle">
                                    <input
                                        id="compoff_on_od"
                                        type="checkbox"
                                        name="compoff_on_od"
                                        checked={formData.compoff_on_od || false}
                                        onChange={(e) => setFormData({ ...formData, compoff_on_od: e.target.checked })}
                                    />
                                    <label htmlFor="compoff_on_od"></label>
                                </div>
                            </div> */}

                            <div title="Allow Direct Employee Add Option" className="flex-row">
                                <label htmlFor="direct_emp_creation" className="form-labels font-weight500 font-size-heading">
                                    Allow Direct Employee Add Option
                                </label>
                                <hr style={{ marginTop: '10px' }} className="field-cont-hr" />
                                <div className="checkbox-toggle">
                                    <input
                                        id="direct_emp_creation"
                                        type="checkbox"
                                        name="direct_emp_creation"
                                        checked={formData.direct_emp_creation || false}
                                        onChange={(e) => setFormData({ ...formData, direct_emp_creation: e.target.checked })}
                                    />
                                    <label htmlFor="direct_emp_creation"></label>
                                </div>
                            </div>

                            <div title="Allow Employee to Edit Details" className="flex-row">
                                <label htmlFor="emp_details_edit" className="form-labels font-weight500 font-size-heading">
                                    Allow Employee to Edit Details
                                </label>
                                <hr style={{ marginTop: '10px' }} className="field-cont-hr" />
                                <div className="checkbox-toggle">
                                    <input
                                        id="emp_details_edit"
                                        type="checkbox"
                                        name="emp_details_edit"
                                        checked={formData.emp_details_edit || false}
                                        onChange={(e) => setFormData({ ...formData, emp_details_edit: e.target.checked })}
                                    />
                                    <label htmlFor="emp_details_edit"></label>
                                </div>
                            </div>

                            <div title="Allow Direct OD Approval Option" className="flex-row">
                                <label htmlFor="od_final_bypass" className="form-labels font-weight500 font-size-heading">
                                    Allow Direct OD Approval Option
                                </label>
                                <hr style={{ marginTop: '10px' }} className="field-cont-hr" />
                                <div className="checkbox-toggle">
                                    <input
                                        id="od_final_bypass"
                                        type="checkbox"
                                        name="od_final_bypass"
                                        checked={formData.od_final_bypass || false}
                                        onChange={(e) => setFormData({ ...formData, od_final_bypass: e.target.checked })}
                                    />
                                    <label htmlFor="od_final_bypass"></label>
                                </div>
                            </div>

                            <div title="Allow Direct Leave Approval Option" className="flex-row">
                                <label htmlFor="leave_final_bypass" className="form-labels font-weight500 font-size-heading">
                                    Allow Direct Leave Approval Option
                                </label>
                                <hr style={{ marginTop: '10px' }} className="field-cont-hr" />
                                <div className="checkbox-toggle">
                                    <input
                                        id="leave_final_bypass"
                                        type="checkbox"
                                        name="leave_final_bypass"
                                        checked={formData.leave_final_bypass || false}
                                        onChange={(e) => setFormData({ ...formData, leave_final_bypass: e.target.checked })}
                                    />
                                    <label htmlFor="leave_final_bypass"></label>
                                </div>
                            </div>

                            <div title="Project Details in Imprest Mandatory" className="flex-row">
                                <label htmlFor="imprest_project_req" className="form-labels font-weight500 font-size-heading">
                                    Project Details in Imprest Mandatory
                                </label>
                                <hr style={{ marginTop: '10px' }} className="field-cont-hr" />
                                <div className="checkbox-toggle">
                                    <input
                                        id="imprest_project_req"
                                        type="checkbox"
                                        name="imprest_project_req"
                                        checked={formData.imprest_project_req || false}
                                        onChange={(e) => setFormData({ ...formData, imprest_project_req: e.target.checked })}
                                    />
                                    <label htmlFor="imprest_project_req"></label>
                                </div>
                            </div>

                            <div title="Allow Tax Calculations for existing Pay Slips" className="flex-row">
                                <label htmlFor="allow_tds_save_if_salary_slip_exists" className="form-labels font-weight500 font-size-heading">
                                    Allow Tax Calculations for existing Pay Slips
                                </label>
                                <hr style={{ marginTop: '10px' }} className="field-cont-hr" />
                                <div className="checkbox-toggle">
                                    <input
                                        id="allow_tds_save_if_salary_slip_exists"
                                        type="checkbox"
                                        name="allow_tds_save_if_salary_slip_exists"
                                        checked={formData.allow_tds_save_if_salary_slip_exists || false}
                                        onChange={(e) => setFormData({ ...formData, allow_tds_save_if_salary_slip_exists: e.target.checked })}
                                    />
                                    <label htmlFor="allow_tds_save_if_salary_slip_exists"></label>
                                </div>
                            </div>

                            <div title="Tax Calculations Mandatory for Payrun" className="flex-row">
                                <label htmlFor="allow_payslip_without_tds" className="form-labels font-weight500 font-size-heading">
                                    Tax Calculations Mandatory for Payrun
                                </label>
                                <hr style={{ marginTop: '10px' }} className="field-cont-hr" />
                                <div className="checkbox-toggle">
                                    <input
                                        id="allow_payslip_without_tds"
                                        type="checkbox"
                                        name="allow_payslip_without_tds"
                                        checked={formData.allow_payslip_without_tds || false}
                                        onChange={(e) => setFormData({ ...formData, allow_payslip_without_tds: e.target.checked })}
                                    />
                                    <label htmlFor="allow_payslip_without_tds"></label>
                                </div>
                            </div>


                            <div title="Short leave apply enabled" className="flex-row">
                                <label htmlFor="eligible_for_shortleave_credit" className="form-labels font-weight500 font-size-heading">
                                    Short leave enabled
                                </label>
                                <hr style={{ marginTop: '10px' }} className="field-cont-hr" />
                                <div className="checkbox-toggle">
                                    <input
                                        id="eligible_for_shortleave_credit"
                                        type="checkbox"
                                        name="eligible_for_shortleave_credit"
                                        checked={formData.eligible_for_shortleave_credit || false}
                                        onChange={(e) => setFormData({ ...formData, eligible_for_shortleave_credit: e.target.checked })}
                                    />
                                    <label htmlFor="eligible_for_shortleave_credit"></label>
                                </div>
                            </div>

                            <div title="Comp Off auto apply" className="flex-row">
                                <label htmlFor="compoff_auto_apply" className="form-labels font-weight500 font-size-heading">
                                    Comp Off auto apply
                                </label>
                                <hr style={{ marginTop: '10px' }} className="field-cont-hr" />
                                <div className="checkbox-toggle">
                                    <input
                                        id="compoff_auto_apply"
                                        type="checkbox"
                                        name="compoff_auto_apply"
                                        checked={formData.compoff_auto_apply || false}
                                        onChange={(e) => setFormData({ ...formData, compoff_auto_apply: e.target.checked })}
                                    />
                                    <label htmlFor="compoff_auto_apply"></label>
                                </div>
                            </div>


                            {formData.eligible_for_shortleave_credit && (
                                <div title="Short leave auto apply" className="flex-row">
                                    <label htmlFor="shortleave_auto_apply" className="form-labels font-weight500 font-size-heading">
                                        Short leave auto apply {formData.shortleave_auto_apply ? "" : ": Disabled"}
                                    </label>
                                    <hr style={{ marginTop: '10px' }} className="field-cont-hr" />
                                    <div className="checkbox-toggle">
                                        <input
                                            id="shortleave_auto_apply"
                                            type="checkbox"
                                            name="shortleave_auto_apply"
                                            checked={formData.shortleave_auto_apply || false}
                                            onChange={(e) => setFormData({ ...formData, shortleave_auto_apply: e.target.checked })}
                                        />
                                        <label htmlFor="shortleave_auto_apply"></label>
                                    </div>
                                </div>
                            )}

                        </div>

                        <div className="jd-heading-outer heading-bg-color-white">
                            <div className="jd-heading-outer-flex">
                                <h2 className="jd-heading-main font-weight600  font-size-heading">
                                    Leave Increments{" "}
                                </h2>
                                <button type='button' title="Add Document" className="jd-heading-main font-weight600 -right-button" onClick={handleAddIncrementSetting}>
                                    <AddwithBlueCircle />
                                    Add Leaves
                                </button>
                            </div>
                            <div>
                                <div className="jd-heading-bottom-bold"></div>
                                <div className="jd-heading-bottom-light"></div>
                            </div>
                        </div>

                        <div className="form-flex-wrap">
                            <ol>
                                {formData.portal_setting_leave_increment?.map((increment, index) => (
                                    <li>
                                        <div >
                                            <div className="form-flex-wrap" key={index}>
                                                <div className="flex-column">
                                                    <div className="flex-row">
                                                        <div className="flex-column">
                                                            <label htmlFor={`leave_addition_date_${index}`} className="form-labels font-weight500 font-size-heading">
                                                                Leave Addition Day of Month<span className="required">*</span>
                                                            </label>
                                                        </div>
                                                        {(
                                                            <button type='button' title="Remove" className="align-center justify-center" onClick={() => handleRemoveIncrementSetting(index)}>
                                                                <CrosswithGreyCircle />
                                                            </button>
                                                        )}
                                                    </div>
                                                    <input
                                                        id={`leave_addition_date_${index}`}
                                                        type="number"
                                                        name="leave_addition_date"
                                                        placeholder="1-28"
                                                        min={1}
                                                        max={28}
                                                        onChange={(e) => handleIncrementSettingInputChange(index, e)}
                                                        value={increment.leave_addition_date || ""}
                                                        className="form-input"
                                                        onWheel={(e) => e.target.blur()}
                                                    />
                                                    {errors[`leave_addition_date_${index}`] && (
                                                        <span className="error-message">{errors[`leave_addition_date_${index}`]}</span>
                                                    )}
                                                </div>

                                                <div className="flex-column">
                                                    <label htmlFor={`leave_addition_type_${index}`} className="form-labels font-weight500 font-size-heading">
                                                        Leave Addition Type<span className="required">*</span>
                                                    </label>
                                                    <select
                                                        id={`leave_addition_type_${index}`}
                                                        name="leave_addition_type"
                                                        onChange={(e) => handleIncrementSettingInputChange(index, e)}
                                                        value={increment.leave_addition_type || ""}
                                                        className="form-input"
                                                    >
                                                        <option value="">Select Leave Type</option>
                                                        <option value="previous leave">Previous Leave</option>
                                                        <option value="casual leave">Casual Leave</option>
                                                        <option value="sick leave">Sick Leave</option>
                                                        {/* <option value="earn leave">Earn Leave</option> */}
                                                        {/* <option value="short leave">Short Leave</option> */}
                                                    </select>
                                                    {errors[`leave_addition_type_${index}`] && (
                                                        <span className="error-message">{errors[`leave_addition_type_${index}`]}</span>
                                                    )}
                                                </div>

                                                <div className="flex-column">
                                                    <label htmlFor={`leave_addition_amount_${index}`} className="form-labels font-weight500 font-size-heading">
                                                        Leave Addition Amount<span className="required">*</span>
                                                    </label>
                                                    <input
                                                        id={`leave_addition_amount_${index}`}
                                                        type="number"
                                                        name="leave_addition_amount"
                                                        placeholder="0"
                                                        min={0}
                                                        onWheel={(e) => e.target.blur()}
                                                        onChange={(e) => handleIncrementSettingInputChange(index, e)}
                                                        value={increment.leave_addition_amount}
                                                        className="form-input"
                                                    />
                                                    {errors[`leave_addition_amount_${index}`] && (
                                                        <span className="error-message">{errors[`leave_addition_amount_${index}`]}</span>
                                                    )}
                                                </div>

                                                <div className="flex-column">
                                                    <label htmlFor={`employee_type_${index}`} className="form-labels font-weight500 font-size-heading">
                                                        Employee Type<span className="required">*</span>
                                                    </label>
                                                    <select
                                                        id={`employee_type_${index}`}
                                                        name="employee_type"
                                                        onChange={(e) => handleIncrementSettingInputChange(index, e)}
                                                        value={increment.employee_type || ""}
                                                        className="form-input"
                                                    >
                                                        <option value="">Select Employee Type</option>
                                                        <option value="permanent">Permanent</option>
                                                        <option value="temporary">Temporary</option>
                                                        <option value="probation">Probation</option>
                                                        <option value="termination">Termination</option>
                                                        <option value="resigned">Resigned</option>
                                                        <option value="absconding">Absconding</option>
                                                        <option value="healthissue">Health Issue</option>
                                                        <option value="intern">Intern</option>
                                                        <option value="trainee">Trainee</option>
                                                        <option value="transferred">Transferred</option>
                                                    </select>
                                                    {errors[`employee_type_${index}`] && (
                                                        <span className="error-message">{errors[`employee_type_${index}`]}</span>
                                                    )}
                                                </div>
                                            </div>
                                            <div className="form-flex-wrap" key={index}>
                                                <div className="flex-row">
                                                    <label htmlFor={`add_for_fixed_asset_${index}`} className="form-labels font-weight500 font-size-heading">
                                                        {increment.add_for_fixed_asset ? "Add" : "No"} Leave for Fixed Assets
                                                    </label>
                                                    <hr style={{ marginTop: '10px' }} className="field-cont-hr" />
                                                    <div className="checkbox-toggle">
                                                        <input
                                                            id={`add_for_fixed_asset_${index}`}
                                                            type="checkbox"
                                                            name="add_for_fixed_asset"
                                                            checked={increment.add_for_fixed_asset || false}
                                                            onChange={(e) =>
                                                                setFormData((prevFormData) => {
                                                                    const newOthers = [...prevFormData.portal_setting_leave_increment];
                                                                    newOthers[index] = {
                                                                        ...newOthers[index],
                                                                        add_for_fixed_asset: e.target.checked,
                                                                    };
                                                                    return {
                                                                        ...prevFormData,
                                                                        portal_setting_leave_increment: newOthers,
                                                                    };
                                                                })
                                                            }
                                                        />
                                                        <label htmlFor={`add_for_fixed_asset_${index}`}></label>
                                                    </div>
                                                </div>

                                                <div className="flex-row">
                                                    <label htmlFor={`add_for_current_asset_${index}`} className="form-labels font-weight500 font-size-heading">
                                                        {increment.add_for_current_asset ? "Add" : "No"} Leave for Current Assets
                                                    </label>
                                                    <hr style={{ marginTop: '10px' }} className="field-cont-hr" />
                                                    <div className="checkbox-toggle">
                                                        <input
                                                            id={`add_for_current_asset_${index}`}
                                                            type="checkbox"
                                                            name="add_for_current_asset"
                                                            checked={increment.add_for_current_asset || false}
                                                            onChange={(e) =>
                                                                setFormData((prevFormData) => {
                                                                    const newOthers = [...prevFormData.portal_setting_leave_increment];
                                                                    newOthers[index] = {
                                                                        ...newOthers[index],
                                                                        add_for_current_asset: e.target.checked,
                                                                    };
                                                                    return {
                                                                        ...prevFormData,
                                                                        portal_setting_leave_increment: newOthers,
                                                                    };
                                                                })
                                                            }
                                                        />
                                                        <label htmlFor={`add_for_current_asset_${index}`}></label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                ))}
                            </ol>
                        </div>

                        <div className="jd-heading-outer heading-bg-color-white">
                            <div className="jd-heading-outer-flex">
                                <h2 className="jd-heading-main font-weight600  font-size-heading">
                                    Leave Encashment{" "}
                                </h2>
                                <button type='button' title="Add Document" className="jd-heading-main font-weight600 -right-button" onClick={handleAddEncashmentSetting}>
                                    <AddwithBlueCircle />
                                    Add Rules
                                </button>
                            </div>
                            <div>
                                <div className="jd-heading-bottom-bold"></div>
                                <div className="jd-heading-bottom-light"></div>
                            </div>
                        </div>

                        <div className="form-flex-wrap">
                            <ol>
                                {formData.portal_setting_leave_encashment?.map((increment, index) => (
                                    <li>
                                        <div className="form-flex-wrap" key={index}>
                                            <div className="flex-column">
                                                <div className="flex-row">
                                                    <div className="flex-column">
                                                        <label htmlFor={`leave_encashment_date_${index}`} className="form-labels font-weight500 font-size-heading">
                                                            Leave Encashment Date<span className="required">*</span>
                                                        </label>
                                                    </div>
                                                    {(
                                                        <button type='button' title="Remove" className="align-center justify-center" onClick={() => handleRemoveEncashmentSetting(index)}>
                                                            <CrosswithGreyCircle />
                                                        </button>
                                                    )}
                                                </div>
                                                <input
                                                    id={`leave_encashment_date_${index}`}
                                                    type="date"
                                                    name="leave_encashment_date"
                                                    onChange={(e) => handleEncashmentSettingInputChange(index, e)}
                                                    value={increment.leave_encashment_date || ""}
                                                    className="form-input"
                                                    onWheel={(e) => e.target.blur()}
                                                />
                                                {errors[`leave_encashment_date_${index}`] && (
                                                    <span className="error-message">{errors[`leave_encashment_date_${index}`]}</span>
                                                )}
                                            </div>

                                            <div className="flex-column">
                                                <label htmlFor={`leave_encashment_type_${index}`} className="form-labels font-weight500 font-size-heading">
                                                    Leave Encashment Type<span className="required">*</span>
                                                </label>
                                                <select
                                                    id={`leave_encashment_type_${index}`}
                                                    name="leave_encashment_type"
                                                    onChange={(e) => handleEncashmentSettingInputChange(index, e)}
                                                    value={increment.leave_encashment_type || ""}
                                                    className="form-input"
                                                >
                                                    <option value="">Select Leave Type</option>
                                                    <option value="previous leave">Previous Leave</option>
                                                    <option value="casual leave">Casual Leave</option>
                                                    <option value="sick leave">Sick Leave</option>
                                                    <option value="earn leave">Earn Leave</option>
                                                    <option value="short leave">Short Leave</option>
                                                </select>
                                                {errors[`leave_encashment_type_${index}`] && (
                                                    <span className="error-message">{errors[`leave_encashment_type_${index}`]}</span>
                                                )}
                                            </div>
                                        </div>
                                    </li>
                                ))}
                            </ol>
                        </div>


                        <div className="button-models">
                            <button
                                className="model-button model-button-cancel"
                                onClick={handleClose}
                            >
                                Cancel
                            </button>
                            <button
                                type="submit"
                                className="model-button model-button-leave"
                                onClick={handleSubmit}
                                disabled={loading}
                            >
                                {loading ? 'Saving...' : 'Save Settings'}
                            </button>
                        </div>

                        <p className="error-message font-size-text">
                            {isSubmitted && Object.keys(errors).length > 0 && (
                                Object.keys(errors).length > 5 ? (
                                    <h5 className="text-center">Please fill all mandatory fields!</h5>
                                ) : (

                                    <h6 className="text-center">
                                        {Object.keys(errors).map((field) =>
                                            field.charAt(0).toUpperCase() + field.slice(1)
                                        ).join(', ') + ' are required!'}
                                    </h6>
                                )
                            )}
                        </p>
                    </div>
                </Modal.Body>
            </Modal >
        </>
    );
};

const EditAllSettingButton = ({ setting, getSettingsData, SUPER_ADMIN }) => {
    const [showModal, setShowModal] = useState(false);
    const [loading, setLoading] = useState(false);

    const handleOpen = () => {
        setFormData(setting)
        setShowModal(true);
    };

    const handleClose = () => {
        setErrors({})
        setShowModal(false);
    };

    const [formData, setFormData] = useState({
        sub_company: sessionStorage.getItem('company_id'),
        leave_apply_past_limit: "",
        leave_apply_future_limit: "",
        leave_approval_limit: "",
        od_apply_past_limit: "",
        od_apply_future_limit: "",
        od_approval_limit: "",
        arrear_apply_start_limit: "",
        arrear_apply_end_limit: "",
        weeklyoff_marking_date: "",
        holiday_marking_date: "",
        probation_conversion_auto_month: "",
        currency_symbol: "",
        sandwich_rule_enabled: null,
        sandwich_holiday_rule: "",
        company_change_visibility: "super_admin",
        show_full_employee_code: null,
        arrear_apply_auto: false,
        salary_slip_visible: null,
        compoff_on_od: null,
        compoff_od_days_limit: "",
        direct_emp_creation: null,
        emp_details_edit: null,
        imprest_project_req: null,
        expense_submit_limit: null,
        expense_submit_limit_days: "",
        compoff_auto_apply: "",
        shortleave_auto_apply: "",
        eligible_for_shortleave_credit: "",
        payroll_start_date: "",
        payroll_end_date: "",
        portal_setting_leave_increment: [
            {
                leave_addition_date: null,
                leave_addition_type: "",
                leave_addition_amount: "",
                employee_type: "",
                add_for_fixed_asset: true,
                add_for_current_asset: true,
            },
        ],
        portal_setting_leave_encashment: [
            {
                leave_encashment_type: "",
                leave_encashment_date: null,
            },
        ],
    });


    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});
    const [isSubmitted, setIsSubmitted] = useState(false);


    const validateForm = () => {
        const newErrors = {};

        // Basic required fields
        const requiredFields = [
            'weeklyoff_marking_date',
            'holiday_marking_date',
            'probation_conversion_auto_month',
            'currency_symbol',
            'company_change_visibility'
        ];

        // Check basic required fields
        requiredFields.forEach((field) => {
            if (!formData[field]) {
                newErrors[field] = `${field.charAt(0).toUpperCase() + field.slice(1).replace(/_/g, ' ')} is required!`;
            }
        });

        // Conditional validation for sandwich rule
        if (formData.sandwich_rule_enabled && !formData.sandwich_holiday_rule) {
            newErrors.sandwich_holiday_rule = "Sandwich Rule Type is required when Sandwich Rule is enabled!";
        }

        if (formData.compoff_on_od && !formData.compoff_od_days_limit) {
            newErrors.compoff_od_days_limit = "Days limit for Compoff on OutDuty is required when Compoff on OD is enabled!";
        }

        if (formData.expense_submit_limit && !formData.expense_submit_limit_days) {
            newErrors.expense_submit_limit_days = "Days limit for Expense Submition is required when Expense Submit Limit is enabled!";
        }

        // Payroll Start Date Validation
        if (
            // !formData.payroll_start_date ||
            formData.payroll_start_date !== null &&
            (Number(formData.payroll_start_date) < 1 ||
                Number(formData.payroll_start_date) > 31)
        ) {

            newErrors.payroll_start_date =
                "Payroll Cycle Start Day must be between 1 and 31";
        }

        // Payroll End Date Validation
        if (
            formData.payroll_end_date !== null &&
            (Number(formData.payroll_end_date) < 1 ||
                Number(formData.payroll_end_date) > 31)
        ) {
            newErrors.payroll_end_date =
                "Payroll Cycle End Day must be between 1 and 31";
        }

        // Validate leave increment settings
        formData.portal_setting_leave_increment.forEach((setting, index) => {
            if (!setting.leave_addition_date) {
                newErrors[`leave_addition_date_${index}`] = "Leave Addition Date is required!";
            }
            if (!setting.leave_addition_type) {
                newErrors[`leave_addition_type_${index}`] = "Leave Addition Type is required!";
            }
            if (setting.leave_addition_amount === null || setting.leave_addition_amount === undefined || setting.leave_addition_amount === "") {
                newErrors[`leave_addition_amount_${index}`] = "Leave Addition Amount is required!";
            }
            if (!setting.employee_type) {
                newErrors[`employee_type_${index}`] = "Employee Type is required!";
            }
        });

        // Validate leave encashment settings
        formData.portal_setting_leave_encashment.forEach((setting, index) => {
            if (!setting.leave_encashment_date) {
                newErrors[`leave_encashment_date_${index}`] = "Leave Encashment Date is required!";
            }
            if (!setting.leave_encashment_type) {
                newErrors[`leave_encashment_type_${index}`] = "Leave Encashment Type is required!";
            }
        });

        setErrors(newErrors);
        setIsSubmitted(true);

        return Object.keys(newErrors).length === 0;
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setInputState({
            ...inputState,
            [name]: value.trim() ? "green" : "",
        });

        setFormData({
            ...formData,
            [name]: value,
        });

        if (value.trim()) {
            setErrors((prevErrors) => {
                const updatedErrors = { ...prevErrors };
                delete updatedErrors[name];
                return updatedErrors;
            });
        }
    };

    // const handleDateChange = (e) => {
    //     const { name, value } = e.target;

    //     // Allow only digits
    //     if (!/^\d*$/.test(value)) {
    //         return;
    //     }

    //     // Prevent values greater than 31
    //     if (value && (Number(value) < 1 || Number(value) > 31)) {
    //         setErrors((prev) => ({
    //             ...prev,
    //             [name]: "Value must be between 1 and 31",
    //         }));
    //         return;
    //     }
    //     setInputState({
    //         ...inputState,
    //         [name]: value.trim() ? "green" : "",
    //     });

    //     setFormData({
    //         ...formData,
    //         [name]: value,
    //     });

    //     // Remove error if valid
    //     setErrors((prevErrors) => {
    //         const updatedErrors = { ...prevErrors };

    //         if (
    //             value === "" ||
    //             (Number(value) >= 1 && Number(value) <= 31)
    //         ) {
    //             delete updatedErrors[name];
    //         }

    //         return updatedErrors;
    //     });
    // };

    const handleDateChange = (e) => {
        const { name, value } = e.target;

        // Allow only digits
        if (!/^\d*$/.test(value)) {
            setErrors((prev) => ({
                ...prev,
                [name]: "Value must be positive only",
            }));
            return;
        }

        let updatedValue = value;

        //  If user types 0 → convert to null
        if (value === "0") {
            updatedValue = null;
        }

        // Prevent values greater than 31 (ignore null case)
        if (
            updatedValue !== null &&
            updatedValue !== "" &&
            (Number(updatedValue) < 1 || Number(updatedValue) > 31)
        ) {
            setErrors((prev) => ({
                ...prev,
                [name]: "Value must be between 1 and 31",
            }));
            return;
        }

        setInputState({
            ...inputState,
            [name]: updatedValue ? "green" : "",
        });

        setFormData({
            ...formData,
            [name]: updatedValue,
        });

        // Remove error if valid
        setErrors((prevErrors) => {
            const updatedErrors = { ...prevErrors };

            if (
                updatedValue === null ||
                updatedValue === "" ||
                (Number(updatedValue) >= 1 && Number(updatedValue) <= 31)
            ) {
                delete updatedErrors[name];
            }

            return updatedErrors;
        });
    };

    const handleAddIncrementSetting = () => {
        setFormData((prevFormData) => ({
            ...prevFormData,
            portal_setting_leave_increment: [
                ...prevFormData.portal_setting_leave_increment,
                {
                    leave_addition_date: null,
                    leave_addition_type: "",
                    leave_addition_amount: "",
                    employee_type: "",
                    add_for_fixed_asset: true,
                    add_for_current_asset: true,
                },
            ],
        }));
    };

    const handleIncrementSettingInputChange = (index, e) => {
        const { name, value } = e.target;
        setFormData((prevFormData) => {
            const newOthers = [...prevFormData.portal_setting_leave_increment];
            newOthers[index] = {
                ...newOthers[index],
                [name]: value,
            };
            return {
                ...prevFormData,
                portal_setting_leave_increment: newOthers,
            };
        });

        if (value.trim()) {
            setErrors(prevErrors => {
                const newErrors = { ...prevErrors };
                delete newErrors[`${name}_${index}`];
                return newErrors;
            });
        }
    };

    const handleRemoveIncrementSetting = (index) => {
        setFormData((prevFormData) => {
            const newOthers = [...prevFormData.portal_setting_leave_increment];
            newOthers.splice(index, 1);
            return {
                ...prevFormData,
                portal_setting_leave_increment: newOthers,
            };
        });

        setErrors(prevErrors => {
            const newErrors = { ...prevErrors };
            ['leave_addition_date', 'leave_addition_type', 'leave_addition_amount', 'employee_type'].forEach(field => {
                delete newErrors[`${field}_${index}`];
            });
            return newErrors;
        });
    };

    const handleAddEncashmentSetting = () => {
        setFormData((prevFormData) => ({
            ...prevFormData,
            portal_setting_leave_encashment: [
                ...prevFormData.portal_setting_leave_encashment,
                {
                    leave_encashment_type: "",
                    leave_encashment_date: null,
                },
            ],
        }));
    };

    const handleEncashmentSettingInputChange = (index, e) => {
        const { name, value } = e.target;
        setFormData((prevFormData) => {
            const newOthers = [...prevFormData.portal_setting_leave_encashment];
            newOthers[index] = {
                ...newOthers[index],
                [name]: value,
            };
            return {
                ...prevFormData,
                portal_setting_leave_encashment: newOthers,
            };
        });

        if (value.trim()) {
            setErrors(prevErrors => {
                const newErrors = { ...prevErrors };
                delete newErrors[`${name}_${index}`];
                return newErrors;
            });
        }
    };

    const handleRemoveEncashmentSetting = (index) => {
        setFormData((prevFormData) => {
            const newOthers = [...prevFormData.portal_setting_leave_encashment];
            newOthers.splice(index, 1);
            return {
                ...prevFormData,
                portal_setting_leave_encashment: newOthers,
            };
        });

        setErrors(prevErrors => {
            const newErrors = { ...prevErrors };
            ['leave_encashment_date', 'leave_encashment_type'].forEach(field => {
                delete newErrors[`${field}_${index}`];
            });
            return newErrors;
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (validateForm()) {
            setLoading(true); //loading logic
            const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
            try {
                let res = await axios.put(`${BASE_URL}/wfm/portal_settings_all_update/${formData.id}/`, formData);
                // portal_settings_all_update_with_logs/<str:pk>

                if (res.status === 200 || res.status === 201) {
                    await getSettingsData();
                    handleClose();
                } else {
                    alert(res);
                }
            } catch (err) {
                handleAllError(err, loadingToastId)
            } finally {
                setLoading(false); //loading logic
                toast.dismiss(loadingToastId);
            }
        }
    };

    return (
        <>
            <button
                onClick={handleOpen}
                title={`Edit All`}
                className="model-button model-button-submit"
            >
                Edit All
            </button>
            <Modal show={showModal} onHide={handleClose} dialogClassName="five-sixth-modal">
                <Modal.Header closeButton>
                    <Modal.Title>Edit Settings for "{setting?.sub_company_title}"</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="register-form">
                        <div className="form-flex-wrap">

                            {/* Leave Settings */}
                            <div title="Leave Apply Limit(Past)" className="flex-column">
                                <label htmlFor="leave_apply_past_limit" className="form-labels font-weight500 font-size-heading">
                                    Leave Apply Limit (Past)
                                </label>
                                <input
                                    id="leave_apply_past_limit"
                                    type="number"
                                    name="leave_apply_past_limit"
                                    placeholder="Enter Leave Apply Limit (Past)"
                                    value={formData.leave_apply_past_limit}
                                    min={0}
                                    onWheel={(e) => e.target.blur()}
                                    onChange={handleInputChange}
                                    className={`form-input ${errors.leave_apply_past_limit ? "error" : inputState.leave_apply_past_limit ? "success" : ""}`}
                                />
                                {errors.leave_apply_past_limit && (
                                    <span className="error-message">{errors.leave_apply_past_limit}</span>
                                )}
                            </div>

                            <div title="Leave Apply Limit(Future)" className="flex-column">
                                <label htmlFor="leave_apply_future_limit" className="form-labels font-weight500 font-size-heading">
                                    Leave Apply Limit (Future)
                                </label>
                                <input
                                    id="leave_apply_future_limit"
                                    type="number"
                                    name="leave_apply_future_limit"
                                    placeholder="Enter Leave Apply Limit (Future)"
                                    value={formData.leave_apply_future_limit}
                                    min={0}
                                    onWheel={(e) => e.target.blur()}
                                    onChange={handleInputChange}
                                    className={`form-input ${errors.leave_apply_future_limit ? "error" : inputState.leave_apply_future_limit ? "success" : ""}`}
                                />
                                {errors.leave_apply_future_limit && (
                                    <span className="error-message">{errors.leave_apply_future_limit}</span>
                                )}
                            </div>

                            <div title="Leave Approval Limit" className="flex-column">
                                <label htmlFor="leave_approval_limit" className="form-labels font-weight500 font-size-heading">
                                    Leave Approval Limit (Days)
                                </label>
                                <input
                                    id="leave_approval_limit"
                                    type="number"
                                    name="leave_approval_limit"
                                    placeholder="Enter Leave Approval Limit"
                                    value={formData.leave_approval_limit}
                                    min={0}
                                    onWheel={(e) => e.target.blur()}
                                    onChange={handleInputChange}
                                    className={`form-input ${errors.leave_approval_limit ? "error" : inputState.leave_approval_limit ? "success" : ""}`}
                                />
                                {errors.leave_approval_limit && (
                                    <span className="error-message">{errors.leave_approval_limit}</span>
                                )}
                            </div>

                            {/* OD Settings */}
                            <div title="OD Apply Limit(Past)" className="flex-column">
                                <label htmlFor="od_apply_past_limit" className="form-labels font-weight500 font-size-heading">
                                    OD Apply Limit (Past)
                                </label>
                                <input
                                    id="od_apply_past_limit"
                                    type="number"
                                    name="od_apply_past_limit"
                                    placeholder="Enter OD Apply Limit (Past)"
                                    value={formData.od_apply_past_limit}
                                    min={0}
                                    onWheel={(e) => e.target.blur()}
                                    onChange={handleInputChange}
                                    className={`form-input ${errors.od_apply_past_limit ? "error" : inputState.od_apply_past_limit ? "success" : ""}`}
                                />
                                {errors.od_apply_past_limit && (
                                    <span className="error-message">{errors.od_apply_past_limit}</span>
                                )}
                            </div>

                            <div title="OD Apply Limit(Future)" className="flex-column">
                                <label htmlFor="od_apply_future_limit" className="form-labels font-weight500 font-size-heading">
                                    OD Apply Limit (Future)
                                </label>
                                <input
                                    id="od_apply_future_limit"
                                    type="number"
                                    name="od_apply_future_limit"
                                    placeholder="Enter OD Apply Limit (Future)"
                                    value={formData.od_apply_future_limit}
                                    min={0}
                                    onWheel={(e) => e.target.blur()}
                                    onChange={handleInputChange}
                                    className={`form-input ${errors.od_apply_future_limit ? "error" : inputState.od_apply_future_limit ? "success" : ""}`}
                                />
                                {errors.od_apply_future_limit && (
                                    <span className="error-message">{errors.od_apply_future_limit}</span>
                                )}
                            </div>

                            <div title="OD Approval Limit" className="flex-column">
                                <label htmlFor="od_approval_limit" className="form-labels font-weight500 font-size-heading">
                                    OD Approval Limit (Days)
                                </label>
                                <input
                                    id="od_approval_limit"
                                    type="number"
                                    name="od_approval_limit"
                                    placeholder="Enter OD Approval Limit"
                                    value={formData.od_approval_limit}
                                    min={0}
                                    onWheel={(e) => e.target.blur()}
                                    onChange={handleInputChange}
                                    className={`form-input ${errors.od_approval_limit ? "error" : inputState.od_approval_limit ? "success" : ""}`}
                                />
                                {errors.od_approval_limit && (
                                    <span className="error-message">{errors.od_approval_limit}</span>
                                )}
                            </div>



                            <div title="Payroll Cycle Start Day" className="flex-column">
                                <label
                                    htmlFor="payroll_start_date"
                                    className="form-labels font-weight500 font-size-heading"
                                >
                                    Payroll Cycle Start Day
                                </label>

                                <input
                                    id="payroll_start_date"
                                    type="text"
                                    inputMode="numeric"
                                    name="payroll_start_date"
                                    placeholder="Enter Payroll Cycle Start Day"
                                    value={formData.payroll_start_date}
                                    maxLength={2}
                                    onWheel={(e) => e.target.blur()}
                                    onChange={handleDateChange}
                                    className={`form-input ${errors.payroll_start_date
                                        ? "error"
                                        : inputState.payroll_start_date
                                            ? "success"
                                            : ""
                                        }`}
                                />

                                {errors.payroll_start_date && (
                                    <span className="error-message">
                                        {errors.payroll_start_date}
                                    </span>
                                )}
                            </div>


                            <div title="Payroll Cycle End Day" className="flex-column">
                                <label
                                    htmlFor="payroll_end_date"
                                    className="form-labels font-weight500 font-size-heading"
                                >
                                    Payroll Cycle End Day
                                </label>

                                <input
                                    id="payroll_end_date"
                                    type="text"
                                    inputMode="numeric"
                                    name="payroll_end_date"
                                    placeholder="Enter Payroll Cycle End Day"
                                    value={formData.payroll_end_date}
                                    maxLength={2}
                                    onWheel={(e) => e.target.blur()}
                                    onChange={handleDateChange}
                                    className={`form-input ${errors.payroll_end_date
                                        ? "error"
                                        : inputState.payroll_end_date
                                            ? "success"
                                            : ""
                                        }`}
                                />

                                {errors.payroll_end_date && (
                                    <span className="error-message">
                                        {errors.payroll_end_date}
                                    </span>
                                )}
                            </div>


                            {/* Arrear Settings */}
                            <div title="Arrear Apply Start Limit" className="flex-column">
                                <label htmlFor="arrear_apply_start_limit" className="form-labels font-weight500 font-size-heading">
                                    Arrear Apply Start Limit
                                </label>
                                <input
                                    id="arrear_apply_start_limit"
                                    type="number"
                                    name="arrear_apply_start_limit"
                                    placeholder="Enter Arrear Apply Start Limit"
                                    value={formData.arrear_apply_start_limit}
                                    min={0}
                                    onWheel={(e) => e.target.blur()}
                                    onChange={handleInputChange}
                                    className={`form-input ${errors.arrear_apply_start_limit ? "error" : inputState.arrear_apply_start_limit ? "success" : ""}`}
                                />
                                {errors.arrear_apply_start_limit && (
                                    <span className="error-message">{errors.arrear_apply_start_limit}</span>
                                )}
                            </div>

                            <div title="Arrear Apply End Limit" className="flex-column">
                                <label htmlFor="arrear_apply_end_limit" className="form-labels font-weight500 font-size-heading">
                                    Arrear Apply End Limit
                                </label>
                                <input
                                    id="arrear_apply_end_limit"
                                    type="number"
                                    name="arrear_apply_end_limit"
                                    placeholder="Enter Arrear Apply End Limit"
                                    value={formData.arrear_apply_end_limit}
                                    min={0}
                                    onWheel={(e) => e.target.blur()}
                                    onChange={handleInputChange}
                                    className={`form-input ${errors.arrear_apply_end_limit ? "error" : inputState.arrear_apply_end_limit ? "success" : ""}`}
                                />
                                {errors.arrear_apply_end_limit && (
                                    <span className="error-message">{errors.arrear_apply_end_limit}</span>
                                )}
                            </div>

                            {/* Date Settings */}
                            <div title="Weeklyoff Marking Date" className="flex-column">
                                <label htmlFor="weeklyoff_marking_date" className="form-labels font-weight500 font-size-heading">
                                    Weeklyoff Marking Date<span className="required">*</span>
                                </label>
                                <select
                                    id="weeklyoff_marking_date"
                                    name="weeklyoff_marking_date"
                                    onChange={handleInputChange}
                                    value={formData.weeklyoff_marking_date}
                                    className={`form-input ${errors.weeklyoff_marking_date ? "error" : inputState.weeklyoff_marking_date ? "success" : ""}`}
                                >
                                    <option value="">Select Frequency</option>
                                    {DROPDOWN_OPTIONS["holiday_marking_date"].map(option => (
                                        <option key={option.value} value={option.value}>
                                            {option.label}
                                        </option>
                                    ))}
                                </select>
                                {errors.weeklyoff_marking_date && (
                                    <span className="error-message">{errors.weeklyoff_marking_date}</span>
                                )}
                            </div>

                            <div title="Holiday Marking Date" className="flex-column">
                                <label htmlFor="holiday_marking_date" className="form-labels font-weight500 font-size-heading">
                                    Holiday Marking Date<span className="required">*</span>
                                </label>
                                <select
                                    id="holiday_marking_date"
                                    name="holiday_marking_date"
                                    onChange={handleInputChange}
                                    value={formData.holiday_marking_date}
                                    className={`form-input ${errors.holiday_marking_date ? "error" : inputState.holiday_marking_date ? "success" : ""}`}
                                >
                                    <option value="">Select Frequency</option>
                                    {DROPDOWN_OPTIONS["holiday_marking_date"].map(option => (
                                        <option key={option.value} value={option.value}>
                                            {option.label}
                                        </option>
                                    ))}
                                </select>
                                {errors.holiday_marking_date && (
                                    <span className="error-message">{errors.holiday_marking_date}</span>
                                )}
                            </div>

                            {/* Other Settings */}
                            <div title="Probation Conversion Auto Month" className="flex-column">
                                <label htmlFor="probation_conversion_auto_month" className="form-labels font-weight500 font-size-heading">
                                    Probation Conversion (Months)<span className="required">*</span>
                                </label>
                                <input
                                    id="probation_conversion_auto_month"
                                    type="number"
                                    name="probation_conversion_auto_month"
                                    placeholder="Enter Probation Conversion Months"
                                    value={formData.probation_conversion_auto_month}
                                    min={0}
                                    onWheel={(e) => e.target.blur()}
                                    onChange={handleInputChange}
                                    className={`form-input ${errors.probation_conversion_auto_month ? "error" : inputState.probation_conversion_auto_month ? "success" : ""}`}
                                />
                                {errors.probation_conversion_auto_month && (
                                    <span className="error-message">{errors.probation_conversion_auto_month}</span>
                                )}
                            </div>

                            <div title="Currency Symbol" className="flex-column">
                                <label htmlFor="currency_symbol" className="form-labels font-weight500 font-size-heading">
                                    Currency Symbol<span className="required">*</span>
                                </label>
                                <select
                                    id="currency_symbol"
                                    name="currency_symbol"
                                    onChange={handleInputChange}
                                    value={formData.currency_symbol}
                                    className={`form-input ${errors.currency_symbol ? "error" : inputState.currency_symbol ? "success" : ""}`}
                                >
                                    <option value="">No Symbol</option>
                                    {DROPDOWN_OPTIONS["currency_symbol"].map(option => (
                                        <option key={option.value} value={option.value}>
                                            {option.label}
                                        </option>
                                    ))}
                                </select>
                                {errors.currency_symbol && (
                                    <span className="error-message">{errors.currency_symbol}</span>
                                )}
                            </div>

                            <div title="Sandwich Rule Type" className="flex-column">
                                <div className="flex-row">

                                    <label htmlFor="sandwich_holiday_rule" className="form-labels font-weight500 font-size-heading">
                                        Sandwich Rule {" "}
                                        <label htmlFor="" className="form-labels  font-weight500    font-size-subheading">
                                            {formData.sandwich_rule_enabled ? 'Enabled' : 'Disabled'}
                                        </label>
                                        {" "}
                                        Type:{formData.sandwich_rule_enabled && <span className="required">*</span>}
                                    </label>
                                    <hr style={{ marginTop: '10px' }} className="field-cont-hr" />
                                    <div className="checkbox-toggle">
                                        <input
                                            id="sandwich_rule_enabled"
                                            name="sandwich_rule_enabled"
                                            type="checkbox"
                                            checked={formData.sandwich_rule_enabled || false}
                                            // onChange={(e) => setFormData({ ...formData, sandwich_rule_enabled: e.target.checked })}
                                            onChange={(e) => {
                                                setFormData({ ...formData, sandwich_rule_enabled: e.target.checked });
                                                setErrors(prevErrors => {
                                                    const newErrors = { ...prevErrors };
                                                    delete newErrors.sandwich_holiday_rule;
                                                    return newErrors;
                                                });
                                            }}
                                        />
                                        <label htmlFor='sandwich_rule_enabled'></label>
                                    </div>
                                    <hr style={{ marginTop: '10px' }} className="field-cont-hr" />
                                    <SandwichRuleExplanation settings={formData} />
                                </div>

                                <select
                                    id="sandwich_holiday_rule"
                                    name="sandwich_holiday_rule"
                                    onChange={handleInputChange}
                                    value={formData.sandwich_holiday_rule}
                                    className={`form-input ${errors.sandwich_holiday_rule ? "error" : inputState.sandwich_holiday_rule ? "success" : ""}`}
                                >
                                    <option value="">Select Rule Type</option>
                                    {DROPDOWN_OPTIONS["sandwich_holiday_rule"].map(option => (
                                        <option key={option.value} value={option.value}>
                                            {option.label}
                                        </option>
                                    ))}
                                </select>
                                {errors.sandwich_holiday_rule && (
                                    <span className="error-message">{errors.sandwich_holiday_rule}</span>
                                )}
                            </div>

                            <div title="Comp Off for WeeklyOff OD" className="flex-column">
                                <div className="flex-row">
                                    <label htmlFor="compoff_on_od" className="form-labels font-weight500 font-size-heading">
                                        Compoff on OD {" "}
                                        <label htmlFor="" className="form-labels  font-weight500    font-size-subheading">
                                            {formData.compoff_on_od ? 'Enabled' : 'Disabled'}
                                        </label>
                                        {" "}
                                        Type:{formData.compoff_on_od && <span className="required">*</span>}
                                    </label>
                                    <hr style={{ marginTop: '10px' }} className="field-cont-hr" />
                                    <div className="checkbox-toggle">
                                        <input
                                            id="compoff_on_od"
                                            name="compoff_on_od"
                                            type="checkbox"
                                            checked={formData.compoff_on_od || false}
                                            // onChange={(e) => setFormData({ ...formData, compoff_on_od: e.target.checked })}
                                            onChange={(e) => {
                                                setFormData({ ...formData, compoff_on_od: e.target.checked });
                                                setErrors(prevErrors => {
                                                    const newErrors = { ...prevErrors };
                                                    delete newErrors.compoff_od_days_limit;
                                                    return newErrors;
                                                });
                                            }}
                                        />
                                        <label htmlFor='compoff_on_od'></label>
                                    </div>
                                </div>
                                <input
                                    id="compoff_od_days_limit"
                                    type="number"
                                    name="compoff_od_days_limit"
                                    placeholder="Enter Max OD limit for Comp Off"
                                    value={formData.compoff_od_days_limit}
                                    min={0}
                                    onWheel={(e) => e.target.blur()}
                                    onChange={handleInputChange}
                                    className={`form-input ${errors.compoff_od_days_limit ? "error" : inputState.compoff_od_days_limit ? "success" : ""}`}
                                />
                                {errors.compoff_od_days_limit && (
                                    <span className="error-message">{errors.compoff_od_days_limit}</span>
                                )}
                            </div>

                            <div title="Expense Submit Limit" className="flex-column">
                                <div className="flex-row">
                                    <label htmlFor="expense_submit_limit" className="form-labels font-weight500 font-size-heading">
                                        Expense Submit Limit {" "}
                                        <label htmlFor="" className="form-labels  font-weight500    font-size-subheading">
                                            {formData.expense_submit_limit ? 'Enabled' : 'Disabled'}
                                        </label>
                                        {" "}
                                        (Days):{formData.expense_submit_limit && <span className="required">*</span>}
                                    </label>
                                    <hr style={{ marginTop: '10px' }} className="field-cont-hr" />
                                    <div className="checkbox-toggle">
                                        <input
                                            id="expense_submit_limit"
                                            name="expense_submit_limit"
                                            type="checkbox"
                                            checked={formData.expense_submit_limit || false}
                                            onChange={(e) => {
                                                setFormData({ ...formData, expense_submit_limit: e.target.checked });
                                                setErrors(prevErrors => {
                                                    const newErrors = { ...prevErrors };
                                                    delete newErrors.expense_submit_limit_days;
                                                    return newErrors;
                                                });
                                            }}
                                        />
                                        <label htmlFor='expense_submit_limit'></label>
                                    </div>
                                </div>
                                <input
                                    id="expense_submit_limit_days"
                                    type="number"
                                    name="expense_submit_limit_days"
                                    placeholder="Enter Expense Submit Limit"
                                    value={formData.expense_submit_limit_days}
                                    min={0}
                                    onWheel={(e) => e.target.blur()}
                                    onChange={handleInputChange}
                                    className={`form-input ${errors.expense_submit_limit_days ? "error" : inputState.expense_submit_limit_days ? "success" : ""}`}
                                />
                                {errors.expense_submit_limit_days && (
                                    <span className="error-message">{errors.expense_submit_limit_days}</span>
                                )}
                            </div>

                            {SUPER_ADMIN && <div title="Company DropDown Visibility" className="flex-column">
                                <label htmlFor="company_change_visibility" className="form-labels font-weight500 font-size-heading">
                                    Company DropDown Visibility<span className="required">*</span>
                                </label>
                                <select
                                    id="company_change_visibility"
                                    name="company_change_visibility"
                                    onChange={handleInputChange}
                                    value={formData.company_change_visibility}
                                    className={`form-input ${errors.company_change_visibility ? "error" : inputState.company_change_visibility ? "success" : ""}`}
                                >
                                    <option value="">Select Role</option>
                                    {DROPDOWN_OPTIONS["company_change_visibility"].map(option => (
                                        <option key={option.value} value={option.value}>
                                            {option.label}
                                        </option>
                                    ))}
                                </select>
                                {errors.company_change_visibility && (
                                    <span className="error-message">{errors.company_change_visibility}</span>
                                )}
                            </div>}
                        </div>

                        <div className="jd-heading-outer heading-bg-color-white">
                            <div className="jd-heading-outer-flex">
                                <h2 className="jd-heading-main font-weight600  font-size-heading">
                                    Prefferences{" "}
                                </h2>
                            </div>
                            <div>
                                <div className="jd-heading-bottom-bold"></div>
                                <div className="jd-heading-bottom-light"></div>
                            </div>
                        </div>

                        <div className="form-flex-wrap">
                            <div title="Show Full Employee Code" className="flex-row">
                                <label htmlFor="show_full_employee_code" className="form-labels font-weight500 font-size-heading">
                                    Show Full Employee Code
                                </label>
                                <hr style={{ marginTop: '10px' }} className="field-cont-hr" />
                                <div className="checkbox-toggle">
                                    <input
                                        id="show_full_employee_code"
                                        type="checkbox"
                                        name="show_full_employee_code"
                                        checked={formData.show_full_employee_code || false}
                                        onChange={(e) => setFormData({ ...formData, show_full_employee_code: e.target.checked })}
                                    />
                                    <label htmlFor="show_full_employee_code"></label>
                                </div>
                            </div>

                            <div title="Arrear Apply Auto" className="flex-row">
                                <label htmlFor="arrear_apply_auto" className="form-labels font-weight500 font-size-heading">
                                    Enable Auto Arrear Apply
                                </label>
                                <hr style={{ marginTop: '10px' }} className="field-cont-hr" />
                                <div className="checkbox-toggle">
                                    <input
                                        id="arrear_apply_auto"
                                        type="checkbox"
                                        name="arrear_apply_auto"
                                        checked={formData.arrear_apply_auto || false}
                                        onChange={(e) => setFormData({ ...formData, arrear_apply_auto: e.target.checked })}
                                    />
                                    <label htmlFor="arrear_apply_auto"></label>
                                </div>
                            </div>

                            <div title="Show Salary Slip" className="flex-row">
                                <label htmlFor="salary_slip_visible" className="form-labels font-weight500 font-size-heading">
                                    Show Salary Slip
                                </label>
                                <hr style={{ marginTop: '10px' }} className="field-cont-hr" />
                                <div className="checkbox-toggle">
                                    <input
                                        id="salary_slip_visible"
                                        type="checkbox"
                                        name="salary_slip_visible"
                                        checked={formData.salary_slip_visible || false}
                                        onChange={(e) => setFormData({ ...formData, salary_slip_visible: e.target.checked })}
                                    />
                                    <label htmlFor="salary_slip_visible"></label>
                                </div>
                            </div>

                            <div title="Comp Off for WeeklyOff OD" className="flex-row">
                                <label htmlFor="compoff_on_od" className="form-labels font-weight500 font-size-heading">
                                    Comp Off for WeeklyOff OD
                                </label>
                                <hr style={{ marginTop: '10px' }} className="field-cont-hr" />
                                <div className="checkbox-toggle">
                                    <input
                                        id="compoff_on_od"
                                        type="checkbox"
                                        name="compoff_on_od"
                                        checked={formData.compoff_on_od || false}
                                        onChange={(e) => setFormData({ ...formData, compoff_on_od: e.target.checked })}
                                    />
                                    <label htmlFor="compoff_on_od"></label>
                                </div>
                            </div>

                            <div title="Allow Direct Employee Add Option" className="flex-row">
                                <label htmlFor="direct_emp_creation" className="form-labels font-weight500 font-size-heading">
                                    Allow Direct Employee Add Option
                                </label>
                                <hr style={{ marginTop: '10px' }} className="field-cont-hr" />
                                <div className="checkbox-toggle">
                                    <input
                                        id="direct_emp_creation"
                                        type="checkbox"
                                        name="direct_emp_creation"
                                        checked={formData.direct_emp_creation || false}
                                        onChange={(e) => setFormData({ ...formData, direct_emp_creation: e.target.checked })}
                                    />
                                    <label htmlFor="direct_emp_creation"></label>
                                </div>
                            </div>

                            <div title="Allow Employee to Edit Details" className="flex-row">
                                <label htmlFor="emp_details_edit" className="form-labels font-weight500 font-size-heading">
                                    Allow Employee to Edit Details
                                </label>
                                <hr style={{ marginTop: '10px' }} className="field-cont-hr" />
                                <div className="checkbox-toggle">
                                    <input
                                        id="emp_details_edit"
                                        type="checkbox"
                                        name="emp_details_edit"
                                        checked={formData.emp_details_edit || false}
                                        onChange={(e) => setFormData({ ...formData, emp_details_edit: e.target.checked })}
                                    />
                                    <label htmlFor="emp_details_edit"></label>
                                </div>
                            </div>

                            <div title="Allow Direct OD Approval Option" className="flex-row">
                                <label htmlFor="od_final_bypass" className="form-labels font-weight500 font-size-heading">
                                    Allow Direct OD Approval Option
                                </label>
                                <hr style={{ marginTop: '10px' }} className="field-cont-hr" />
                                <div className="checkbox-toggle">
                                    <input
                                        id="od_final_bypass"
                                        type="checkbox"
                                        name="od_final_bypass"
                                        checked={formData.od_final_bypass || false}
                                        onChange={(e) => setFormData({ ...formData, od_final_bypass: e.target.checked })}
                                    />
                                    <label htmlFor="od_final_bypass"></label>
                                </div>
                            </div>

                            <div title="Allow Direct Leave Approval Option" className="flex-row">
                                <label htmlFor="leave_final_bypass" className="form-labels font-weight500 font-size-heading">
                                    Allow Direct Leave Approval Option
                                </label>
                                <hr style={{ marginTop: '10px' }} className="field-cont-hr" />
                                <div className="checkbox-toggle">
                                    <input
                                        id="leave_final_bypass"
                                        type="checkbox"
                                        name="leave_final_bypass"
                                        checked={formData.leave_final_bypass || false}
                                        onChange={(e) => setFormData({ ...formData, leave_final_bypass: e.target.checked })}
                                    />
                                    <label htmlFor="leave_final_bypass"></label>
                                </div>
                            </div>

                            <div title="Project Details in Imprest Mandatory" className="flex-row">
                                <label htmlFor="imprest_project_req" className="form-labels font-weight500 font-size-heading">
                                    Project Details in Imprest Mandatory
                                </label>
                                <hr style={{ marginTop: '10px' }} className="field-cont-hr" />
                                <div className="checkbox-toggle">
                                    <input
                                        id="imprest_project_req"
                                        type="checkbox"
                                        name="imprest_project_req"
                                        checked={formData.imprest_project_req || false}
                                        onChange={(e) => setFormData({ ...formData, imprest_project_req: e.target.checked })}
                                    />
                                    <label htmlFor="imprest_project_req"></label>
                                </div>
                            </div>

                            <div title="Allow Tax Calculations for existing Pay Slips" className="flex-row">
                                <label htmlFor="allow_tds_save_if_salary_slip_exists" className="form-labels font-weight500 font-size-heading">
                                    Allow Tax Calculations for existing Pay Slips
                                </label>
                                <hr style={{ marginTop: '10px' }} className="field-cont-hr" />
                                <div className="checkbox-toggle">
                                    <input
                                        id="allow_tds_save_if_salary_slip_exists"
                                        type="checkbox"
                                        name="allow_tds_save_if_salary_slip_exists"
                                        checked={formData.allow_tds_save_if_salary_slip_exists || false}
                                        onChange={(e) => setFormData({ ...formData, allow_tds_save_if_salary_slip_exists: e.target.checked })}
                                    />
                                    <label htmlFor="allow_tds_save_if_salary_slip_exists"></label>
                                </div>
                            </div>

                            <div title="Tax Calculations Mandatory for Payrun" className="flex-row">
                                <label htmlFor="allow_payslip_without_tds" className="form-labels font-weight500 font-size-heading">
                                    Tax Calculations Mandatory for Payrun
                                </label>
                                <hr style={{ marginTop: '10px' }} className="field-cont-hr" />
                                <div className="checkbox-toggle">
                                    <input
                                        id="allow_payslip_without_tds"
                                        type="checkbox"
                                        name="allow_payslip_without_tds"
                                        checked={formData.allow_payslip_without_tds || false}
                                        onChange={(e) => setFormData({ ...formData, allow_payslip_without_tds: e.target.checked })}
                                    />
                                    <label htmlFor="allow_payslip_without_tds"></label>
                                </div>
                            </div>

                            <div title="Short leave apply enabled" className="flex-row">
                                <label htmlFor="eligible_for_shortleave_credit" className="form-labels font-weight500 font-size-heading">
                                    Short leave enabled
                                </label>
                                <hr style={{ marginTop: '10px' }} className="field-cont-hr" />
                                <div className="checkbox-toggle">
                                    <input
                                        id="eligible_for_shortleave_credit"
                                        type="checkbox"
                                        name="eligible_for_shortleave_credit"
                                        checked={formData.eligible_for_shortleave_credit || false}
                                        onChange={(e) => setFormData({ ...formData, eligible_for_shortleave_credit: e.target.checked })}
                                    />
                                    <label htmlFor="eligible_for_shortleave_credit"></label>
                                </div>
                            </div>

                            <div title="Comp Off auto apply" className="flex-row">
                                <label htmlFor="compoff_auto_apply" className="form-labels font-weight500 font-size-heading">
                                    Comp Off auto apply
                                </label>
                                <hr style={{ marginTop: '10px' }} className="field-cont-hr" />
                                <div className="checkbox-toggle">
                                    <input
                                        id="compoff_auto_apply"
                                        type="checkbox"
                                        name="compoff_auto_apply"
                                        checked={formData.compoff_auto_apply || false}
                                        onChange={(e) => setFormData({ ...formData, compoff_auto_apply: e.target.checked })}
                                    />
                                    <label htmlFor="compoff_auto_apply"></label>
                                </div>
                            </div>

                            {formData.eligible_for_shortleave_credit && (
                                <div title="Short leave auto apply" className="flex-row">
                                    <label htmlFor="shortleave_auto_apply" className="form-labels font-weight500 font-size-heading">
                                        Short leave auto apply {formData.shortleave_auto_apply ? "" : ": Disabled"}
                                    </label>
                                    <hr style={{ marginTop: '10px' }} className="field-cont-hr" />
                                    <div className="checkbox-toggle">
                                        <input
                                            id="shortleave_auto_apply"
                                            type="checkbox"
                                            name="shortleave_auto_apply"
                                            checked={formData.shortleave_auto_apply || false}
                                            onChange={(e) => setFormData({ ...formData, shortleave_auto_apply: e.target.checked })}
                                        />
                                        <label htmlFor="shortleave_auto_apply"></label>
                                    </div>
                                </div>
                            )}

                        </div>

                        <div className="jd-heading-outer heading-bg-color-white">
                            <div className="jd-heading-outer-flex">
                                <h2 className="jd-heading-main font-weight600  font-size-heading">
                                    Leave Increments{" "}
                                </h2>
                                <button type='button' title="Add Document" className="jd-heading-main font-weight600 -right-button" onClick={handleAddIncrementSetting}>
                                    <AddwithBlueCircle />
                                    Add Leaves
                                </button>
                            </div>
                            <div>
                                <div className="jd-heading-bottom-bold"></div>
                                <div className="jd-heading-bottom-light"></div>
                            </div>
                        </div>

                        <div className="form-flex-wrap">
                            <ol>
                                {formData.portal_setting_leave_increment?.map((increment, index) => (
                                    <li>
                                        <div >
                                            <div className="form-flex-wrap" key={index}>
                                                <div className="flex-column">
                                                    <div className="flex-row">
                                                        <div className="flex-column">
                                                            <label htmlFor={`leave_addition_date_${index}`} className="form-labels font-weight500 font-size-heading">
                                                                Leave Addition Day of Month<span className="required">*</span>
                                                            </label>
                                                        </div>
                                                        {(
                                                            <button type='button' title="Remove" className="align-center justify-center" onClick={() => handleRemoveIncrementSetting(index)}>
                                                                <CrosswithGreyCircle />
                                                            </button>
                                                        )}
                                                    </div>
                                                    <input
                                                        id={`leave_addition_date_${index}`}
                                                        type="number"
                                                        name="leave_addition_date"
                                                        placeholder="1-28"
                                                        min={1}
                                                        max={28}
                                                        onChange={(e) => handleIncrementSettingInputChange(index, e)}
                                                        value={increment.leave_addition_date || ""}
                                                        className="form-input"
                                                        onWheel={(e) => e.target.blur()}
                                                    />
                                                    {errors[`leave_addition_date_${index}`] && (
                                                        <span className="error-message">{errors[`leave_addition_date_${index}`]}</span>
                                                    )}
                                                </div>

                                                <div className="flex-column">
                                                    <label htmlFor={`leave_addition_type_${index}`} className="form-labels font-weight500 font-size-heading">
                                                        Leave Addition Type<span className="required">*</span>
                                                    </label>
                                                    <select
                                                        id={`leave_addition_type_${index}`}
                                                        name="leave_addition_type"
                                                        onChange={(e) => handleIncrementSettingInputChange(index, e)}
                                                        value={increment.leave_addition_type || ""}
                                                        className="form-input"
                                                    >
                                                        <option value="">Select Leave Type</option>
                                                        <option value="previous leave">Previous Leave</option>
                                                        <option value="casual leave">Casual Leave</option>
                                                        <option value="sick leave">Sick Leave</option>
                                                        {/* <option value="earn leave">Earn Leave</option> */}
                                                        {/* <option value="short leave">Short Leave</option> */}
                                                    </select>
                                                    {errors[`leave_addition_type_${index}`] && (
                                                        <span className="error-message">{errors[`leave_addition_type_${index}`]}</span>
                                                    )}
                                                </div>

                                                <div className="flex-column">
                                                    <label htmlFor={`leave_addition_amount_${index}`} className="form-labels font-weight500 font-size-heading">
                                                        Leave Addition Amount<span className="required">*</span>
                                                    </label>
                                                    <input
                                                        id={`leave_addition_amount_${index}`}
                                                        type="number"
                                                        name="leave_addition_amount"
                                                        placeholder="0"
                                                        min={0}
                                                        onWheel={(e) => e.target.blur()}
                                                        onChange={(e) => handleIncrementSettingInputChange(index, e)}
                                                        value={increment.leave_addition_amount}
                                                        className="form-input"
                                                    />
                                                    {errors[`leave_addition_amount_${index}`] && (
                                                        <span className="error-message">{errors[`leave_addition_amount_${index}`]}</span>
                                                    )}
                                                </div>

                                                <div className="flex-column">
                                                    <label htmlFor={`employee_type_${index}`} className="form-labels font-weight500 font-size-heading">
                                                        Employee Type<span className="required">*</span>
                                                    </label>
                                                    <select
                                                        id={`employee_type_${index}`}
                                                        name="employee_type"
                                                        onChange={(e) => handleIncrementSettingInputChange(index, e)}
                                                        value={increment.employee_type || ""}
                                                        className="form-input"
                                                    >
                                                        <option value="">Select Employee Type</option>
                                                        <option value="permanent">Permanent</option>
                                                        <option value="temporary">Temporary</option>
                                                        <option value="probation">Probation</option>
                                                        <option value="termination">Termination</option>
                                                        <option value="resigned">Resigned</option>
                                                        <option value="absconding">Absconding</option>
                                                        <option value="healthissue">Health Issue</option>
                                                        <option value="intern">Intern</option>
                                                        <option value="trainee">Trainee</option>
                                                        <option value="transferred">Transferred</option>
                                                    </select>
                                                    {errors[`employee_type_${index}`] && (
                                                        <span className="error-message">{errors[`employee_type_${index}`]}</span>
                                                    )}
                                                </div>
                                            </div>
                                            <div className="form-flex-wrap" key={index}>
                                                <div className="flex-row">
                                                    <label htmlFor={`add_for_fixed_asset_${index}`} className="form-labels font-weight500 font-size-heading">
                                                        {increment.add_for_fixed_asset ? "Add" : "No"} Leave for Fixed Assets
                                                    </label>
                                                    <hr style={{ marginTop: '10px' }} className="field-cont-hr" />
                                                    <div className="checkbox-toggle">
                                                        <input
                                                            id={`add_for_fixed_asset_${index}`}
                                                            type="checkbox"
                                                            name="add_for_fixed_asset"
                                                            checked={increment.add_for_fixed_asset || false}
                                                            onChange={(e) =>
                                                                setFormData((prevFormData) => {
                                                                    const newOthers = [...prevFormData.portal_setting_leave_increment];
                                                                    newOthers[index] = {
                                                                        ...newOthers[index],
                                                                        add_for_fixed_asset: e.target.checked,
                                                                    };
                                                                    return {
                                                                        ...prevFormData,
                                                                        portal_setting_leave_increment: newOthers,
                                                                    };
                                                                })
                                                            }
                                                        />
                                                        <label htmlFor={`add_for_fixed_asset_${index}`}></label>
                                                    </div>
                                                </div>

                                                <div className="flex-row">
                                                    <label htmlFor={`add_for_current_asset_${index}`} className="form-labels font-weight500 font-size-heading">
                                                        {increment.add_for_current_asset ? "Add" : "No"} Leave for Current Assets
                                                    </label>
                                                    <hr style={{ marginTop: '10px' }} className="field-cont-hr" />
                                                    <div className="checkbox-toggle">
                                                        <input
                                                            id={`add_for_current_asset_${index}`}
                                                            type="checkbox"
                                                            name="add_for_current_asset"
                                                            checked={increment.add_for_current_asset || false}
                                                            onChange={(e) =>
                                                                setFormData((prevFormData) => {
                                                                    const newOthers = [...prevFormData.portal_setting_leave_increment];
                                                                    newOthers[index] = {
                                                                        ...newOthers[index],
                                                                        add_for_current_asset: e.target.checked,
                                                                    };
                                                                    return {
                                                                        ...prevFormData,
                                                                        portal_setting_leave_increment: newOthers,
                                                                    };
                                                                })
                                                            }
                                                        />
                                                        <label htmlFor={`add_for_current_asset_${index}`}></label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                ))}
                            </ol>
                        </div>

                        <div className="jd-heading-outer heading-bg-color-white">
                            <div className="jd-heading-outer-flex">
                                <h2 className="jd-heading-main font-weight600  font-size-heading">
                                    Leave Encashment{" "}
                                </h2>
                                <button type='button' title="Add Document" className="jd-heading-main font-weight600 -right-button" onClick={handleAddEncashmentSetting}>
                                    <AddwithBlueCircle />
                                    Add Rules
                                </button>
                            </div>
                            <div>
                                <div className="jd-heading-bottom-bold"></div>
                                <div className="jd-heading-bottom-light"></div>
                            </div>
                        </div>

                        <div className="form-flex-wrap">
                            <ol>
                                {formData.portal_setting_leave_encashment?.map((increment, index) => (
                                    <li>
                                        <div className="form-flex-wrap" key={index}>
                                            <div className="flex-column">
                                                <div className="flex-row">
                                                    <div className="flex-column">
                                                        <label htmlFor={`leave_encashment_date_${index}`} className="form-labels font-weight500 font-size-heading">
                                                            Leave Encashment Date<span className="required">*</span>
                                                        </label>
                                                    </div>
                                                    {(
                                                        <button type='button' title="Remove" className="align-center justify-center" onClick={() => handleRemoveEncashmentSetting(index)}>
                                                            <CrosswithGreyCircle />
                                                        </button>
                                                    )}
                                                </div>
                                                <input
                                                    id={`leave_encashment_date_${index}`}
                                                    type="date"
                                                    name="leave_encashment_date"
                                                    onChange={(e) => handleEncashmentSettingInputChange(index, e)}
                                                    value={increment.leave_encashment_date || ""}
                                                    className="form-input"
                                                    onWheel={(e) => e.target.blur()}
                                                />
                                                {errors[`leave_encashment_date_${index}`] && (
                                                    <span className="error-message">{errors[`leave_encashment_date_${index}`]}</span>
                                                )}
                                            </div>

                                            <div className="flex-column">
                                                <label htmlFor={`leave_encashment_type_${index}`} className="form-labels font-weight500 font-size-heading">
                                                    Leave Encashment Type<span className="required">*</span>
                                                </label>
                                                <select
                                                    id={`leave_encashment_type_${index}`}
                                                    name="leave_encashment_type"
                                                    onChange={(e) => handleEncashmentSettingInputChange(index, e)}
                                                    value={increment.leave_encashment_type || ""}
                                                    className="form-input"
                                                >
                                                    <option value="">Select Leave Type</option>
                                                    <option value="previous leave">Previous Leave</option>
                                                    <option value="casual leave">Casual Leave</option>
                                                    <option value="sick leave">Sick Leave</option>
                                                    <option value="earn leave">Earn Leave</option>
                                                    <option value="short leave">Short Leave</option>
                                                </select>
                                                {errors[`leave_encashment_type_${index}`] && (
                                                    <span className="error-message">{errors[`leave_encashment_type_${index}`]}</span>
                                                )}
                                            </div>
                                        </div>
                                    </li>
                                ))}
                            </ol>
                        </div>

                        <div className="button-models">
                            <button
                                className="model-button model-button-cancel"
                                onClick={handleClose}
                            >
                                Cancel
                            </button>
                            <button
                                type="submit"
                                className="model-button model-button-leave"
                                onClick={handleSubmit}
                                disabled={loading}
                            >
                                {loading ? 'Saving...' : 'Save Settings'}
                            </button>
                        </div>

                        <p className="error-message font-size-text">
                            {isSubmitted && Object.keys(errors).length > 0 && (
                                Object.keys(errors).length > 5 ? (
                                    <h5 className="text-center">Please fill all mandatory fields!</h5>
                                ) : (

                                    <h6 className="text-center">
                                        {Object.keys(errors).map((field) =>
                                            field.charAt(0).toUpperCase() + field.slice(1)
                                        ).join(', ') + ' are required!'}
                                    </h6>
                                )
                            )}
                        </p>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
};


const AddApprovalFormat = ({ existingFormatsList = [], getApprovalFormat, message, SUB_COMPANIES, SUPER_ADMIN }) => {
    const [show, setShow] = useState(false);
    const handleClose = () => {
        setFormData({
            format_for: "",
            sub_company: sessionStorage.getItem('company_id'),
            auto_approve_when_no_stages: false, // ADD THIS
            stages: [
                {
                    role: "",
                    employee: "",
                    level: 1,
                    permissions: "",
                    threshold_approval: false,
                    threshold_amt: 0,
                }
            ],
        })
        setErrors({});
        setInputState({});
        setShow(false)
    };

    const handleShow = () => {
        getEmployee();
        setShow(true)
    };

    const [formData, setFormData] = useState({
        format_for: "",
        sub_company: sessionStorage.getItem('company_id'),
        auto_approve_when_no_stages: false, // ADD THIS
        stages: [
            {
                role: "",
                employee: "",
                level: 1,
                permissions: "",
                threshold_approval: false,
                threshold_amt: 0,
            }
        ],
    });

    //******************Valedation Start********************* */

    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});
    const [isSubmitted, setIsSubmitted] = useState(false);

    const validateForm = () => {
        const newErrors = {};
        const requiredFields = [
            "format_for",
            "sub_company",
        ];
        requiredFields.forEach((field) => {
            if (!formData[field]) {
                newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
                    } is required !`;
            }
        });

        // NEW VALIDATION: Either auto-approve OR at least one stage is required
        if (!formData.auto_approve_when_no_stages) {
            if (!formData.stages || formData.stages.length === 0) {
                newErrors["stages"] = "At least one approval stage is required when auto-approval is disabled";
            }
            else {
                // Validate each stage
                formData.stages.forEach((doc, index) => {
                    const hasEmployee = doc.employee && doc.employee.trim() !== "";
                    const hasRole = doc.role && doc.role.trim() !== "";
                    const isChecked = doc.threshold_approval === true;
                    const isLastStage = index === formData.stages.length - 1;

                    if (!hasEmployee && !hasRole) {
                        const message = `Authority Name or Role ${index + 1} is required`;
                        newErrors[`employee${index}`] = message;
                        newErrors[`role${index}`] = message;
                    }

                    if (isChecked && (!doc.threshold_amt || doc.threshold_amt.toString().trim() === "")) {
                        newErrors[`threshold_amt${index}`] = `Threshold amount ${index + 1} is required `;
                    }

                    if (!doc.permissions || doc.permissions.trim() === "") {
                        newErrors[`permissions${index}`] = `Permission ${index + 1} is required`;
                    }

                    if (
                        isLastStage &&
                        // doc.permissions &&
                        doc.permissions !== "Finalize" &&
                        doc.permissions !== "Finalize-Edit"
                    ) {
                        newErrors[`permissions${index}`] =
                            "Last stage must have 'Finalize' or 'Finalize-Edit' permission";
                    }
                });
            }
        } else {
            // If auto-approve is enabled, stages should be empty
            if (formData.stages && formData.stages.length > 0) {
                newErrors["auto_approve"] = "Cannot have approval stages when auto-approval is enabled";
            }
        }

        console.log('newErrors', newErrors);
        setErrors(newErrors);
        setIsSubmitted(true);
        return Object.keys(newErrors).length === 0;
    };

    const handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;
        const inputValue = type === "checkbox" ? checked : value;

        setInputState({
            ...inputState,
            [name]: value && value.trim() ? "green" : "",
        });
        setFormData({
            ...formData,
            [name]: inputValue,
        });

        // Clear errors when input changes
        if (value && value.trim()) {
            setErrors((prevErrors) => {
                const updatedErrors = { ...prevErrors };
                delete updatedErrors[name];
                return updatedErrors;
            });
        }

        // If auto-approve is enabled, clear stages
        if (name === "auto_approve_when_no_stages" && checked) {
            setFormData(prev => ({
                ...prev,
                stages: []
            }));
        }
    };

    // ADD THIS HANDLER FOR AUTO-APPROVAL TOGGLE
    const handleAutoApproveChange = (e) => {
        const { checked } = e.target;
        setFormData({
            ...formData,
            auto_approve_when_no_stages: checked,
            // Clear stages when auto-approve is enabled
            stages: checked ? [] : [{
                role: "",
                employee: "",
                level: 1,
                permissions: "",
                threshold_approval: false,
                threshold_amt: 0,
            }]
        });

        // Clear related errors
        setErrors((prevErrors) => {
            const updatedErrors = { ...prevErrors };
            delete updatedErrors.stages;
            delete updatedErrors.auto_approve;
            return updatedErrors;
        });
    };

    const handleStagesInputChanges = (e, index) => {
        const { name, value, type, checked } = e.target;
        const inputValue = type === "checkbox" ? checked : value;

        setFormData((prevFormData) => {
            const updatedStages = [...prevFormData.stages];
            updatedStages[index] = {
                ...updatedStages[index],
                [name]: inputValue,
            };
            return { ...prevFormData, stages: updatedStages };
        });

        // Clear errors for this field
        if (value && value.trim()) {
            setErrors((prevErrors) => {
                const updatedErrors = { ...prevErrors };
                delete updatedErrors[`${name}${index}`];
                return updatedErrors;
            });
        }
    };

    const handleOtherInputChange = (index, e) => {
        if (!e || !e.target) {
            console.error("Invalid event object: ", e);
            return;
        }
        const { name, value } = e.target;

        if (name === 'employee') {
            setFormData((prevFormData) => {
                const newOthers = [...prevFormData.stages];
                newOthers[index] = {
                    ...newOthers[index],
                    [name]: value,
                    level: index + 1,
                    role: '',
                };
                return {
                    ...prevFormData,
                    stages: newOthers
                };
            });
        }
        else if (name === 'role') {
            setFormData((prevFormData) => {
                const newOthers = [...prevFormData.stages];
                newOthers[index] = {
                    ...newOthers[index],
                    [name]: value,
                    level: index + 1,
                    employee: '',
                };
                return {
                    ...prevFormData,
                    stages: newOthers
                };
            });
        }
        else {
            setFormData((prevFormData) => {
                const newOthers = [...prevFormData.stages];
                newOthers[index] = {
                    ...newOthers[index],
                    [name]: value,
                    level: index + 1,
                };
                return {
                    ...prevFormData,
                    stages: newOthers
                };
            });
        }

        // Clear errors for this field
        if (value && value.trim()) {
            setErrors((prevErrors) => {
                const updatedErrors = { ...prevErrors };
                delete updatedErrors[`${name}${index}`];
                return updatedErrors;
            });
        }
    };

    const handleAddOthers = () => {
        // Don't allow adding stages if auto-approve is enabled
        if (formData.auto_approve_when_no_stages) {
            return;
        }

        setFormData((prevFormData) => {
            const currentApprovalHeading = Array.isArray(prevFormData.stages)
                ? prevFormData.stages
                : [];

            return {
                ...prevFormData,
                stages: [
                    ...currentApprovalHeading,
                    {
                        level: currentApprovalHeading.length + 1,
                        role: "",
                        employee: "",
                        permissions: "",
                        threshold_approval: false,
                        threshold_amt: 0,
                    },
                ],
            };
        });
    };

    const handleRemoveOthers = (index) => {
        setFormData((prevFormData) => {
            const currentHeadings = Array.isArray(prevFormData.stages)
                ? [...prevFormData.stages]
                : [];

            currentHeadings.splice(index, 1);

            const updatedOthers = currentHeadings.map((item, idx) => ({
                ...item,
                level: idx + 1,
            }));

            return {
                ...prevFormData,
                stages: updatedOthers,
            };
        });
    };



    const formatList = [
        { label: "Leave", value: "leave" },
        { label: "OutDuty", value: "outduty" },
        { label: "Compensatory", value: "compensatory" },
        // { label: "CompOff", value: "compoff" },
        { label: "Imprest", value: "imprest" },
        { label: "Expense", value: "expense" },
        // { label: "Advance", value: "advance" },
        // { label: "Separation", value: "separation" },
        { label: "Employee Details", value: "empDetails" },
        { label: "Bank Details", value: "bankdetails" },
        { label: "Investment Declaration", value: "investment_declaration" },
        { label: "Investment Proof Justification", value: "investment_proof" },
        { label: "Arrear", value: "arrear" },
    ]


    //******************Valedation End*********************** */

    const [loading, setLoading] = useState(false); //loading logic
    const handleFormSubmit = async (e) => {
        e.preventDefault();

        if (validateForm()) {
            setLoading(true); //loading logic
            const loadingToastId = toast.loading("Loading: name wait..."); //toast Logic

            try {
                let res = await axios.post(
                    `${BASE_URL}/wfm/dynamicapprovalscreate/`,
                    formData
                );
                if (res.status === 201) {
                    await getApprovalFormat();
                    handleClose();
                    toast.dismiss(loadingToastId);
                    toast.success("Submitted Successfully")
                }
            } catch (err) {
                console.error(err);

                handleErrorToast(err);
            } finally {
                setLoading(false); //loading logic
                toast.dismiss(loadingToastId);
            }
        }
    };

    const hiddenOptions = message?.map((item) => item.format_for);

    const [empList, setEmpList] = useState([]);
    const [buffer1, setBuffering1] = useState(true);

    const getEmployee = async () => {
        try {
            setBuffering1(true)
            // const res = await axios.get(`${BASE_URL}/siteproject/employeebyfiltersss/null/`);
            const res = await axios.get(`${BASE_URL}/wfm/ourcompanyempdetailsactive/${formData.sub_company}/`);
            const sortedList = customSortByKey(res.data, "emp_code");
            setEmpList(sortedList);
        } catch (error) {
            console.error(error);
        } finally {
            setBuffering1(false)
        }
    };

    const rolesList = [
        { role_name: "ReportingHead", role_value: "ReportingHead" },
        { role_name: "HOD", role_value: "HOD" },
        { role_name: "Account", role_value: "Account" },
        { role_name: "HR", role_value: "HR" },
        { role_name: "Admin", role_value: "Admin" },
        { role_name: "IT", role_value: "IT" },
    ];

    const employeeOptions = [
        ...empList.map((emp) => ({
            value: emp.emp_code,
            label: `${emp.emp_code} - ${emp.name}`,
        })),
    ];

    const options = rolesList
        .sort((a, b) => parseInt(a.label) - parseInt(b.label))
        .map((e) => ({
            value: e.role_value,
            label: e.role_name
        }));

    const usedFormatValues = new Set(
        existingFormatsList.map(item => item.format_for)
    );

    const listopotion = formatList
        .filter(option => !usedFormatValues.has(option.value))
        .sort((a, b) => parseInt(a.label) - parseInt(b.label))
        .map((e) => ({
            value: e.value,
            label: e.label
        }));

    const handleCompanyChange = (selectedOption) => {
        if (!selectedOption) {
            setFormData({
                ...formData,
                sub_company: "",
            })

        } else {
            setFormData({
                ...formData,
                sub_company: selectedOption.value,
            })
        }

        setErrors((prevErrors) => {
            const updatedErrors = { ...prevErrors };
            delete updatedErrors.sub_company;
            return updatedErrors;
        });

    }

    const handleFormatChange = (selectedOption) => {
        if (!selectedOption) {
            setFormData({
                ...formData,
                format_for: "",
            })

        } else {
            setFormData({
                ...formData,
                format_for: selectedOption.value,
            })
        }

        setErrors((prevErrors) => {
            const updatedErrors = { ...prevErrors };
            delete updatedErrors.format_for;
            return updatedErrors;
        });

    }

    const subcompanyOption = SUB_COMPANIES.sort((a, b) => b.title.localeCompare(a.title)).map((i) => ({
        value: i.id,
        label: i.title
    }));


    const permission = [
        { value: "Approve-Reject", label: "Approve-Reject" },
        { value: "Approve-Reject-Edit", label: "Approve-Reject-Edit" },
        { value: "Finalize-Edit", label: "Finalize-Edit" },
        { value: "Finalize", label: "Finalize" },
        // {value:"View-Only", label:"View-Only"},
        // {value:"Auto", label:"Auto"},
    ];

    const permissionOption = permission.map((i) => ({
        value: i.value,
        label: i.label,
    }));




    return (
        <>
            <button title="Add approval Format" className="upload-svg equal-hieght" onClick={handleShow}>
                <AddwithWhiteCircle /> Approval Format
            </button>

            <Modal show={show} onHide={handleClose} dialogClassName="ourcompany-model">
                <Modal.Header closeButton>
                    <Modal.Title>Add Approval Format</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div">
                        <div className="">
                            <div className="form-flex-wrap ">
                                {SUPER_ADMIN &&
                                    <div className="flex-column form-group-selectt">
                                        <label htmlFor="sub_company" className="form-labels font-weight500 font-size-subheading">
                                            Sub Company<span className="required">*</span>
                                        </label>
                                        <Select
                                            id='sub_company'
                                            name='sub_company'
                                            options={subcompanyOption}
                                            isClearable
                                            onChange={handleCompanyChange}
                                            value={subcompanyOption.find(option => option.value === formData.sub_company)}
                                            styles={CSSForSelectSmallWidth}
                                        />

                                        {errors.sub_company && (
                                            <span className="error-message font-size-text">
                                                {errors.sub_company}
                                            </span>
                                        )}
                                    </div>
                                }
                                <div className="flex-column form-group-selectt">
                                    <label htmlFor="format_for" className="form-labels font-weight500 font-size-subheading">
                                        Format For<span className="required">*</span>
                                    </label>
                                    <Select
                                        id='format_for'
                                        name='format_for'
                                        options={listopotion}
                                        isClearable
                                        onChange={handleFormatChange}
                                        value={formatList.find(option => option.value === formData.format_for)}
                                        styles={CSSForSelectSmallWidth}
                                    />

                                    {errors.format_for && (
                                        <span className="error-message font-size-text">
                                            {errors.format_for}
                                        </span>
                                    )}
                                </div>

                            </div>

                            {/* ADD AUTO-APPROVAL TOGGLE SECTION */}
                            <div className="form-flex-wrap">
                                <div className="flex-column">
                                    <div className="flex-row">
                                        <label className="form-labels font-weight500 font-size-subheading">
                                            Auto-approve when no stages
                                            {formData.auto_approve_when_no_stages ? ' (Enabled)' : ' (Disabled)'}
                                        </label>
                                        <hr style={{ marginTop: '10px' }} className="field-cont-hr" />
                                        <div className="checkbox-toggle">
                                            <input
                                                id="auto_approve_when_no_stages"
                                                name="auto_approve_when_no_stages"
                                                type="checkbox"
                                                checked={formData.auto_approve_when_no_stages || false}
                                                onChange={handleAutoApproveChange}
                                            />
                                            <label htmlFor="auto_approve_when_no_stages"></label>
                                        </div>
                                    </div>
                                    <p className="form-help-text">
                                        When enabled, requests will be automatically approved without approval stages
                                    </p>
                                    {errors.auto_approve && (
                                        <span className="error-message font-size-text">
                                            {errors.auto_approve}
                                        </span>
                                    )}
                                </div>
                            </div>

                            <hr />
                            {/* CONDITIONAL RENDERING FOR STAGES */}
                            {!formData.auto_approve_when_no_stages && (
                                <>
                                    {formData.stages?.map((heading, index) => (
                                        <div
                                            key={index}
                                            style={{
                                                position: "relative",
                                                border: "1px solid #e2e2e2",
                                                borderRadius: "10px",
                                                padding: "20px",
                                                marginBottom: (index + 1) == formData?.stages?.length ? "0px" : "25px",
                                                background: "#fff",
                                            }}
                                        >

                                            <div
                                                style={{
                                                    position: "absolute",
                                                    top: "-12px",
                                                    left: "50%",
                                                    transform: "translateX(-50%)",
                                                    background: "white",
                                                    padding: "0px 12px",
                                                    fontWeight: 600,
                                                    color: "#333",
                                                    fontSize: "14px",
                                                }}
                                            >
                                                {heading.level}{getNumberSuffix(heading.level)} Stage
                                            </div>

                                            <button
                                                type="button"
                                                onClick={() => handleRemoveOthers(index)}
                                                style={{
                                                    position: "absolute",
                                                    top: "-13px",
                                                    right: "-10px",
                                                    background: "transparent",
                                                    border: "none",
                                                    cursor: "pointer",

                                                }}
                                            >
                                                <CrosswithRedCircle />
                                            </button>


                                            <div style={{ display: "flex", gap: "20px", marginBottom: "20px" }}>

                                                {heading.employee ? null :
                                                    <div style={{ flex: 1, display: "flex", flexDirection: "column" }}>
                                                        <label className="form-labels font-weight500 font-size-subheading">
                                                            Role<span className="required">*</span>
                                                        </label>

                                                        <Select
                                                            name="role"
                                                            options={options}
                                                            isClearable
                                                            onChange={(selectedOption) => {
                                                                handleOtherInputChange(index, {
                                                                    target: {
                                                                        name: 'role',
                                                                        value: selectedOption ? selectedOption.value : '',
                                                                    }
                                                                });
                                                            }}
                                                            value={options.find(option => option.value === heading.role) || null}
                                                            styles={CSSForSelectSmallWidth}
                                                        />

                                                        {errors[`role${index}`] && (
                                                            <span className="error-message font-size-text">
                                                                {errors[`role${index}`]}
                                                            </span>
                                                        )}
                                                    </div>
                                                }

                                                {heading.employee === "" && heading.role === "" ?
                                                    <div className="flex-row justify-center form-labels font-weight500 font-size-subheading" style={{ marginTop: "30px" }} >
                                                        OR
                                                    </div>
                                                    : null}

                                                {heading.role ? null :
                                                    <div style={{ flex: 1, display: "flex", flexDirection: "column" }}>
                                                        <label htmlFor={`department_${index}`} className="form-labels font-weight500 font-size-subheading">
                                                            Authority Name<span className="required">*</span>
                                                        </label>

                                                        {buffer1 ? (
                                                            <div className="form-loader-date">
                                                                <div className="bar-loader"></div>
                                                            </div>
                                                        ) : (
                                                            <Select
                                                                options={employeeOptions}
                                                                onChange={(selectedOption) => {
                                                                    handleOtherInputChange(index, {
                                                                        target: {
                                                                            name: 'employee',
                                                                            value: selectedOption ? selectedOption.value : '',
                                                                        }
                                                                    });
                                                                }}
                                                                value={employeeOptions.find(option => option.value === heading.employee)}
                                                                placeholder="Select or Search Employee"
                                                                isClearable
                                                                noOptionsMessage={() => "No other options"}
                                                                styles={CSSForSelectSmallWidth}
                                                            />
                                                        )}

                                                        {errors[`employee${index}`] && (
                                                            <span className="error-message font-size-text">
                                                                {errors[`employee${index}`]}
                                                            </span>
                                                        )}
                                                    </div>
                                                }
                                            </div>


                                            <div style={{ display: "flex", gap: "20px", marginBottom: "10px" }}>


                                                <div style={{ flex: 1, display: "flex", flexDirection: "column" }}>
                                                    <label htmlFor="permissions" className="form-labels font-weight500 font-size-subheading">
                                                        Permission<span className="required">*</span>
                                                    </label>

                                                    <Select
                                                        id='permissions'
                                                        name="permissions"
                                                        options={permissionOption}
                                                        isClearable
                                                        onChange={(selectedOption) => {
                                                            handleOtherInputChange(index, {
                                                                target: {
                                                                    name: "permissions",
                                                                    value: selectedOption ? selectedOption.value : "",
                                                                }
                                                            });
                                                        }}
                                                        value={permissionOption.find(option => option.value === heading.permissions) || null}
                                                        styles={CSSForSelectSmallWidth}
                                                    />

                                                    {errors[`permissions${index}`] && (
                                                        <span className="error-message font-size-text">
                                                            {errors[`permissions${index}`]}
                                                        </span>
                                                    )}
                                                </div>



                                                <div style={{ flex: 1, display: "flex", flexDirection: "column" }}>
                                                    <div className='flex-row gap-2'>
                                                        <label className="form-labels font-weight500 font-size-subheading">
                                                            Threshold Amount {heading.threshold_approval ? "Enabled" : "Disabled"}
                                                        </label>

                                                        {/* <hr style={{ marginTop: '10px' }} className="field-cont-hr" /> */}
                                                        <div className="checkbox-toggle" style={{ display: "flex", alignItems: "center" }}>

                                                            <input
                                                                type="checkbox"
                                                                id={`threshold_approval${index}`}
                                                                name="threshold_approval"
                                                                checked={heading.threshold_approval || false}
                                                                onChange={(e) => handleStagesInputChanges(e, index)}

                                                            />
                                                            <label htmlFor={`threshold_approval${index}`}></label>
                                                        </div>
                                                    </div>


                                                    {heading.threshold_approval && (
                                                        <input
                                                            type="number"
                                                            id={`threshold_amt${index}`}
                                                            name="threshold_amt"
                                                            placeholder="Threshold Amount"
                                                            value={heading.threshold_amt}
                                                            min={0}
                                                            onWheel={(e) => e.target.blur()}
                                                            onChange={(e) => handleStagesInputChanges(e, index)}
                                                            className='form-input'
                                                        />
                                                    )}

                                                    {errors[`threshold_amt${index}`] && (
                                                        <span className="error-message font-size-text">
                                                            {errors[`threshold_amt${index}`]}
                                                        </span>
                                                    )}

                                                </div>
                                            </div>
                                        </div>
                                    ))}


                                    {errors.stages && (
                                        <div className="error-message font-size-text text-center">
                                            {errors.stages}
                                        </div>
                                    )}

                                    <div className="flex-row">
                                        <hr className="line" />
                                        <div className='flex-row justify-end '>
                                            <button
                                                type='button'
                                                title="Add Stages"
                                                className="flex-row jd-heading-main font-weight600 gap-2"
                                                onClick={handleAddOthers}
                                            >
                                                <AddwithBlueCircle />
                                                <span className='w-max-content'>
                                                    Add More Stages
                                                </span>
                                            </button>
                                        </div>
                                    </div>
                                </>
                            )}


                            <div className="button-models">
                                <button className="model-button model-button-cancel font-weight500" onClick={handleClose}>
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    className="model-button font-weight500 model-button-leave font-size-heading"
                                    onClick={handleFormSubmit}
                                    disabled={loading}
                                >
                                    Add
                                </button>
                            </div>
                        </div>
                        <p className="error-message font-size-text">
                            {isSubmitted && Object.keys(errors).length > 0 && (
                                Object.keys(errors).length > 5 ? (
                                    <h5 className="error-message text-center">Please fill all mandatory fields!</h5>
                                ) : (
                                    <h6 className="error-message text-center">
                                        {Object.keys(errors).map((field) =>
                                            field.charAt(0).toUpperCase() + field.slice(1)
                                        ).join(', ') + ' are required!'}
                                    </h6>
                                )
                            )}
                        </p>
                    </div>

                    <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
                </Modal.Body>
            </Modal >
        </>
    );
};


const getStageFlowPreview = (stages, auto_approve) => {

    if ((!stages || stages.length === 0) && auto_approve) {
        return "No stages (Auto-approve)";
    }
    if (!stages || stages.length === 0) {
        return "No stages configured";
    }

    return stages.map(stage => {
        if (stage.role === "ReportingHead") {
            return "Reporting Head";
        } else if (stage.employee) {
            return stage.employee_name || stage.employee_code || stage.employee || "Employee";
        } else if (stage.role) {
            return stage.role;
        }
        return "Approver";
    }).join(" → ");
};

const UpdateApprovalFormat = ({ getApprovalFormat, message, i, SUPER_ADMIN, SUB_COMPANIES }) => {
    const [show, setShow] = useState(false);
    const [showRevertModal, setShowRevertModal] = useState(false);
    const [matchingVersion, setMatchingVersion] = useState(null);
    const [showRevertSuggestion, setShowRevertSuggestion] = useState(false);
    const [loading, setLoading] = useState(false);
    const [empList, setEmpList] = useState([]);
    const [buffer1, setBuffering1] = useState(false);
    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});
    const [isSubmitted, setIsSubmitted] = useState(false);

    const [formData, setFormData] = useState({
        format_for: "",
        sub_company_id: sessionStorage.getItem('company_id'),
        auto_approve_when_no_stages: false,
        stages: [
            {
                role: "",
                employee: "",
                level: 1,
                permissions: "",
                threshold_approval: false,
                threshold_amt: 0,
            }
        ],
    });

    const handleClose = () => {
        setFormData({
            format_for: "",
            sub_company_id: sessionStorage.getItem('company_id'),
            stages: [
                {
                    role: "",
                    employee: "",
                    level: 1,
                    permissions: "",
                    threshold_approval: false,
                    threshold_amt: 0,
                }
            ],
        });
        setErrors({});
        setInputState({});
        setShow(false);
        setShowRevertModal(false);
        setMatchingVersion(null);
        setShowRevertSuggestion(false);
    };

    const handleShow = () => {
        getEmployee();
        setFormData(i);
        console.log('i', i);
        setShow(true);
    };

    // Enhanced function to compare approval configurations
    const areConfigurationsEqual = (config1, config2) => {
        // Check if both have auto_approve_when_no_stages enabled and no stages

        const isBothAutoApproveNoStages =
            config1.auto_approve_when_no_stages &&
            config2.auto_approve_when_no_stages &&
            (!config1.stages || config1.stages.length === 0) &&
            (!config2.stages || config2.stages.length === 0);

        if (isBothAutoApproveNoStages) {
            return true;
        }

        // If not both auto-approve with no stages, check stage equality
        if (!config1.stages || !config2.stages || config1.stages.length !== config2.stages.length) {
            return false;
        }

        const normalizeStage = (stage) => ({
            role: stage.role || '',
            employee: stage.employee || '',
            level: stage.level || 0,
            permissions: stage.permissions || '',
            threshold_approval: Boolean(stage.threshold_approval),
            threshold_amt: Number(stage.threshold_amt) || 0
        });

        const normalized1 = config1.stages.map(normalizeStage);
        const normalized2 = config2.stages.map(normalizeStage);
        const sorted1 = [...normalized1].sort((a, b) => a.level - b.level);
        const sorted2 = [...normalized2].sort((a, b) => a.level - b.level);

        return sorted1.every((stage1, index) => {
            const stage2 = sorted2[index];
            return (
                stage1.role === stage2.role &&
                stage1.employee === stage2.employee &&
                stage1.permissions === stage2.permissions &&
                stage1.threshold_approval === stage2.threshold_approval &&
                stage1.threshold_amt === stage2.threshold_amt
            );
        });
    };


    // Check for matching version when form data changes
    useEffect(() => {
        if (
            (
                (formData.stages && formData.stages.length > 0) ||
                (formData.auto_approve_when_no_stages && formData.stages.length == 0)
            )
            && i.all_versions
        ) {
            const matching = i.all_versions.find(version =>
                version.version !== i.version && // Don't match with current version
                areConfigurationsEqual(
                    {
                        stages: version.stages,
                        auto_approve_when_no_stages: version.auto_approve_when_no_stages
                    },
                    {
                        stages: formData.stages,
                        auto_approve_when_no_stages: formData.auto_approve_when_no_stages
                    }
                )
            );
            setMatchingVersion(matching);
            setShowRevertSuggestion(!!matching);
        } else {
            setMatchingVersion(null);
            setShowRevertSuggestion(false);
        }
    }, [formData.stages, formData.auto_approve_when_no_stages, i.all_versions, i.version]);

    // Add revert functionality
    const handleRevertToVersion = async (versionId) => {
        const loadingToastId = toast.loading("Reverting to version...");
        try {
            let res = await axios.post(
                `${BASE_URL}/wfm/dynamicapprovalformatstages-revertversion/`,
                {
                    current_format_id: i.format_id,
                    target_version_id: versionId
                }
            );
            if (res.status === 200) {
                await getApprovalFormat();
                handleClose();
                toast.dismiss(loadingToastId);
                toast.success(res.data.message || "Successfully reverted to previous version");
            }
        } catch (err) {
            handleErrorToast(err);
        } finally {
            toast.dismiss(loadingToastId);
        }
    };

    const handleRevertSuggestion = () => {
        if (matchingVersion) {
            handleRevertToVersion(matchingVersion.format_id);
        }
    };

    //******************Validation Start********************* */
    const validateForm = () => {
        const newErrors = {};
        const requiredFields = [
            "format_for",
            "sub_company_id"
        ];
        requiredFields.forEach((field) => {
            if (!formData[field]) {
                newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)} is required !`;
            }
        });

        if (!formData.auto_approve_when_no_stages) {
            if (!formData.stages || formData.stages.length === 0) {
                newErrors["stages"] = "At least one approval stage is required when auto-approval is disabled";
            } else {
                formData.stages?.forEach((doc, index) => {
                    const hasEmployee = doc.employee && doc.employee.trim() !== "";
                    const hasRole = doc.role && doc.role.trim() !== "";
                    const isChecked = doc.threshold_approval === true;
                    const isLastStage = index === formData.stages.length - 1;


                    if (!hasEmployee && !hasRole) {
                        newErrors[`employee${index}`] = `Authority Name or Role ${index + 1} is required`;
                        newErrors[`role${index}`] = `Authority Name or Role ${index + 1} is required`;
                    }

                    if (isChecked && (!doc.threshold_amt || doc.threshold_amt.toString().trim() === "")) {
                        newErrors[`threshold_amt${index}`] = `Threshold amount ${index + 1} is required `;
                    }

                    if (!doc.permissions || doc.permissions.trim() === "") {
                        newErrors[`permissions${index}`] = `Permission ${index + 1} is required`;
                    }

                    if (
                        isLastStage &&
                        // doc.permissions &&
                        doc.permissions !== "Finalize" &&
                        doc.permissions !== "Finalize-Edit"
                    ) {
                        newErrors[`permissions${index}`] =
                            "Last stage must have 'Finalize' or 'Finalize-Edit' permission";
                    }
                });
            }
        } else {
            if (formData.stages && formData.stages.length > 0) {
                newErrors["auto_approve"] = "Cannot have approval stages when auto-approval is enabled";
            }
        }

        console.log('newErrors', newErrors);
        setErrors(newErrors);
        setIsSubmitted(true);
        return Object.keys(newErrors).length === 0;
    };

    const handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;
        setInputState({
            ...inputState,
            [name]: value.trim() ? "green" : "",
        });
        setFormData({
            ...formData,
            [name]: value,
        });
        if (value && value.trim()) {
            setErrors((prevErrors) => {
                const updatedErrors = { ...prevErrors };
                delete updatedErrors[name];
                return updatedErrors;
            });
        }
        if (name === "auto_approve_when_no_stages" && checked) {
            setFormData(prev => ({
                ...prev,
                stages: []
            }));
        }
    };

    const handleAutoApproveChange = (e) => {
        const { checked } = e.target;
        setFormData({
            ...formData,
            auto_approve_when_no_stages: checked,
            stages: checked ? [] : [{
                role: "",
                employee: "",
                level: 1,
                permissions: "",
                threshold_approval: false,
                threshold_amt: 0,
            }]
        });

        setErrors((prevErrors) => {
            const updatedErrors = { ...prevErrors };
            delete updatedErrors.stages;
            delete updatedErrors.auto_approve;
            return updatedErrors;
        });
    };

    const handleStagesInputChanges = (e, index) => {
        const { name, value, type, checked } = e.target;
        const inputValue = type === "checkbox" ? checked : value;

        setFormData((prevFormData) => {
            const updatedStages = [...prevFormData.stages];
            updatedStages[index] = {
                ...updatedStages[index],
                [name]: inputValue,
            };
            return { ...prevFormData, stages: updatedStages };
        });

        if (value && value.trim()) {
            setErrors((prevErrors) => {
                const updatedErrors = { ...prevErrors };
                delete updatedErrors[`${name}${index}`];
                return updatedErrors;
            });
        }
    };

    const handleOtherInputChange = (index, e) => {
        if (!e || !e.target) {
            console.error("Invalid event object: ", e);
            return;
        }
        const { name, value } = e.target;

        if (name === 'employee') {
            setFormData((prevFormData) => {
                const newOthers = [...prevFormData.stages];
                newOthers[index] = {
                    ...newOthers[index],
                    [name]: value,
                    level: index + 1,
                    role: '',
                };
                return {
                    ...prevFormData,
                    stages: newOthers
                };
            });
        } else if (name === 'role') {
            setFormData((prevFormData) => {
                const newOthers = [...prevFormData.stages];
                newOthers[index] = {
                    ...newOthers[index],
                    [name]: value,
                    level: index + 1,
                    employee: '',
                };
                return {
                    ...prevFormData,
                    stages: newOthers
                };
            });
        } else {
            setFormData((prevFormData) => {
                const newOthers = [...prevFormData.stages];
                newOthers[index] = {
                    ...newOthers[index],
                    [name]: value,
                    level: index + 1,
                };
                return {
                    ...prevFormData,
                    stages: newOthers
                };
            });
        }
        if (value && value.trim()) {
            setErrors((prevErrors) => {
                const updatedErrors = { ...prevErrors };
                delete updatedErrors[`${name}${index}`];
                return updatedErrors;
            });
        }
    };

    const handleAddOthers = () => {
        if (formData.auto_approve_when_no_stages) {
            return;
        }
        setFormData((prevFormData) => {
            const currentApprovalHeading = Array.isArray(prevFormData.stages)
                ? prevFormData.stages
                : [];

            return {
                ...prevFormData,
                stages: [
                    ...currentApprovalHeading,
                    {
                        level: currentApprovalHeading.length + 1,
                        role: "",
                        employee: "",
                    },
                ],
            };
        });
    };

    const handleRemoveOthers = (index) => {
        setFormData((prevFormData) => {
            const currentHeadings = Array.isArray(prevFormData.stages)
                ? [...prevFormData.stages]
                : [];

            currentHeadings.splice(index, 1);

            const updatedOthers = currentHeadings.map((item, idx) => ({
                ...item,
                level: idx + 1,
            }));

            return {
                ...prevFormData,
                stages: updatedOthers,
            };
        });
    };

    const handleFormSubmit = async (e) => {
        e.preventDefault();

        // If there's a matching version, show suggestion instead of creating new version
        if (showRevertSuggestion && matchingVersion) {
            if (window.confirm(`This flow matches version ${matchingVersion.version}. Would you like to revert to that version instead of creating a new one?`)) {
                handleRevertToVersion(matchingVersion.format_id);
                return;
            }
        }

        if (validateForm()) {
            setLoading(true);
            const loadingToastId = toast.loading("Loading: please wait...");
            console.log("formData:", formData);

            try {
                let res = await axios.put(
                    `${BASE_URL}/wfm/dynamicapprovalformatstages-updateversion/${i.format_id}/`,
                    formData
                );
                if (res.status === 200) {
                    await getApprovalFormat();
                    handleClose();
                    toast.dismiss(loadingToastId);
                    toast.success(res.data.message || "New version created successfully");
                } else {
                    console.log("res:", res);
                }
            } catch (err) {
                handleErrorToast(err);
            } finally {
                setLoading(false);
                toast.dismiss(loadingToastId);
            }
        }
    };

    const getEmployee = async () => {
        try {
            setBuffering1(true);
            const res = await axios.get(`${BASE_URL}/wfm/ourcompanyempdetailsactive/${formData.sub_company_id}/`);
            const sortedList = customSortByKey(res.data, "emp_code");
            setEmpList(res.data);
        } catch (error) {
            console.error(error);
        } finally {
            setBuffering1(false);
        }
    };

    const formatList = [
        { label: "Leave", value: "leave" },
        { label: "OutDuty", value: "outduty" },
        { label: "Compensatory", value: "compensatory" },
        { label: "Imprest", value: "imprest" },
        { label: "Expense", value: "expense" },
        // { label: "Separation", value: "separation" },
        { label: "Employee Details", value: "empDetails" },
        { label: "Bank Details", value: "bankdetails" },
        { label: "Investment Declaration", value: "investment_declaration" },
        { label: "Investment Proof Justification", value: "investment_proof" },
        { label: "Arrear", value: "arrear" },
    ];

    const hiddenOptions = message?.map((item) => item.format_for);

    const rolesList = [
        { role_name: "ReportingHead", role_value: "ReportingHead" },
        { role_name: "HOD", role_value: "HOD" },
        { role_name: "Account", role_value: "Account" },
        { role_name: "HR", role_value: "HR" },
        { role_name: "Admin", role_value: "Admin" },
        { role_name: "IT", role_value: "IT" },
    ];

    const employeeOptions = [
        ...empList.map((emp) => ({
            value: emp.emp_code,
            label: `${emp.emp_code} - ${emp.name}`,
        })),
    ];

    const options = rolesList
        .sort((a, b) => parseInt(a.label) - parseInt(b.label))
        .map((e) => ({
            value: e.role_value,
            label: e.role_name
        }));

    const listopotion = formatList
        .sort((a, b) => parseInt(a.label) - parseInt(b.label))
        .map((e) => ({
            value: e.value,
            label: e.label
        }));

    const handleCompanyChange = (selectedOption) => {
        if (!selectedOption) {
            setFormData({
                ...formData,
                sub_company_id: "",
            });
        } else {
            setFormData({
                ...formData,
                sub_company_id: selectedOption.value,
            });
        }

        setErrors((prevErrors) => {
            const updatedErrors = { ...prevErrors };
            delete updatedErrors.sub_company_id;
            return updatedErrors;
        });
    };

    const handleFormatChange = (selectedOption) => {
        if (!selectedOption) {
            setFormData({
                ...formData,
                format_for: "",
            });
        } else {
            setFormData({
                ...formData,
                format_for: selectedOption.value,
            });
        }

        setErrors((prevErrors) => {
            const updatedErrors = { ...prevErrors };
            delete updatedErrors.format_for;
            return updatedErrors;
        });
    };

    const subcompanyOption = SUB_COMPANIES.sort((a, b) => b.title.localeCompare(a.title)).map((i) => ({
        value: i.id,
        label: i.title
    }));

    const permission = [
        { value: "Approve-Reject", label: "Approve-Reject" },
        { value: "Approve-Reject-Edit", label: "Approve-Reject-Edit" },
        { value: "Finalize-Edit", label: "Finalize-Edit" },
        { value: "Finalize", label: "Finalize" },
    ];

    const permissionOption = permission.map((i) => ({
        value: i.value,
        label: i.label,
    }));

    return (
        <>
            {/* <div style={{ display: 'flex', gap: '5px' }}> */}
            <div className='flex-row'>
                <button title="Update Approval Format" className="model-edit-button" onClick={handleShow}>
                    <UpdatePencil />
                </button>
                {/* 
                {i.previous_versions_count > 0 && <button
                    title="Revert to Previous Version"
                    className="model-edit-button"
                    onClick={() => setShowRevertModal(true)}
                >
                    <PreviousIcon color={'#145650'} />
                </button>} */}
            </div>

            <Modal show={show} onHide={handleClose} dialogClassName="ourcompany-model">
                <Modal.Header closeButton className='flex-row justify-between'>
                    <Modal.Title>Update Approval Format of
                        "{formatList.find(f => f.value === i.format_for)?.label || i.format_for}"
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div">
                        <div className="">
                            <div className="form-flex-wrap ">
                                {SUPER_ADMIN &&
                                    <div className="flex-column form-group-selectt">
                                        <label htmlFor="sub_company_id" className="form-labels font-weight500 font-size-subheading">
                                            Sub Company<span className="required">*</span>
                                        </label>
                                        <Select
                                            id='sub_company_id'
                                            name='sub_company_id'
                                            options={subcompanyOption}
                                            isClearable
                                            onChange={handleCompanyChange}
                                            value={subcompanyOption.find(option => option.value === formData.sub_company_id)}
                                            styles={CSSForSelectSmallWidth}
                                        />
                                        {errors.sub_company_id && (
                                            <span className="error-message font-size-text">
                                                {errors.sub_company_id}
                                            </span>
                                        )}
                                    </div>
                                }
                                <div className="flex-column form-group-selectt">
                                    <label htmlFor="format_for" className="form-labels font-weight500 font-size-subheading">
                                        Format For<span className="required">*</span>
                                    </label>
                                    <Select
                                        id='format_for'
                                        name='format_for'
                                        options={listopotion}
                                        // isClearable
                                        // onChange={handleFormatChange}
                                        isDisabled
                                        value={formatList.find(option => option.value === formData.format_for)}
                                        styles={CSSForSelectSmallWidth}
                                    />
                                    {errors.format_for && (
                                        <span className="error-message font-size-text">
                                            {errors.format_for}
                                        </span>
                                    )}
                                </div>
                            </div>

                            {/* ADD AUTO-APPROVAL TOGGLE SECTION */}
                            <div className="form-flex-wrap">
                                <div className="flex-column">
                                    <div className="flex-row">
                                        <label className="form-labels font-weight500 font-size-subheading">
                                            Auto-approve when no stages
                                            {formData.auto_approve_when_no_stages ? ' (Enabled)' : ' (Disabled)'}
                                        </label>
                                        <hr style={{ marginTop: '10px' }} className="field-cont-hr" />
                                        <div className="checkbox-toggle">
                                            <input
                                                id="auto_approve_when_no_stages"
                                                name="auto_approve_when_no_stages"
                                                type="checkbox"
                                                checked={formData.auto_approve_when_no_stages || false}
                                                onChange={handleAutoApproveChange}
                                            />
                                            <label htmlFor="auto_approve_when_no_stages"></label>
                                        </div>
                                    </div>
                                    <p className="form-help-text">
                                        When enabled, requests will be automatically approved without approval stages
                                    </p>
                                    {errors.auto_approve && (
                                        <span className="error-message font-size-text">
                                            {errors.auto_approve}
                                        </span>
                                    )}
                                </div>
                                <div className='flex-column'>
                                    <div className='flex-row justify-end'>
                                        {i.previous_versions_count > 0 &&
                                            <button
                                                title="Revert to Previous Version"
                                                // className="model-edit-button"
                                                className="model-button model-button-success"
                                                onClick={() => setShowRevertModal(true)}
                                            >
                                                <PreviousIcon color={'#145650'} /> Revert Version
                                            </button>
                                        }

                                    </div>
                                </div>
                            </div>
                            <hr />
                            {!formData.auto_approve_when_no_stages && (
                                <>

                                    {formData.stages?.map((heading, index) => (
                                        <div
                                            style={{
                                                position: "relative",
                                                border: "1px solid #e2e2e2",
                                                borderRadius: "10px",
                                                padding: "20px",
                                                marginBottom: (index + 1) == formData?.stages?.length ? "0px" : "25px",
                                                background: "#fff",
                                            }}
                                            key={index}>
                                            <div
                                                style={{
                                                    position: "absolute",
                                                    top: "-12px",
                                                    left: "50%",
                                                    transform: "translateX(-50%)",
                                                    background: "white",
                                                    padding: "0px 12px",
                                                    fontWeight: 600,
                                                    color: "#333",
                                                    fontSize: "14px",
                                                }}
                                            >
                                                {heading.level}{getNumberSuffix(heading.level)} Stage
                                            </div>

                                            <button
                                                type="button"
                                                onClick={() => handleRemoveOthers(index)}
                                                style={{
                                                    position: "absolute",
                                                    top: "-13px",
                                                    right: "-10px",
                                                    background: "transparent",
                                                    border: "none",
                                                    cursor: "pointer",
                                                }}
                                            >
                                                <CrosswithRedCircle />
                                            </button>

                                            <div style={{ display: "flex", gap: "20px", marginBottom: "20px" }}>
                                                {heading.employee ? null :
                                                    <div style={{ flex: 1, display: "flex", flexDirection: "column" }}>
                                                        <label htmlFor="person" className="form-labels font-weight500 font-size-subheading">
                                                            Role<span className="required">*</span>
                                                        </label>
                                                        <Select
                                                            id='role'
                                                            name='role'
                                                            options={options}
                                                            isClearable
                                                            onChange={(selectedOption) => {
                                                                handleOtherInputChange(index, {
                                                                    target: {
                                                                        name: 'role',
                                                                        value: selectedOption ? selectedOption.value : '',
                                                                    }
                                                                });
                                                            }}
                                                            value={options.find(option => option.value === heading.role) || null}
                                                            styles={CSSForSelectSmallWidth}
                                                        />
                                                        {errors[`role_${index}`] && (
                                                            <span className="error-message font-size-text">
                                                                {errors[`role_${index}`]}
                                                            </span>
                                                        )}
                                                    </div>
                                                }

                                                {heading.employee === "" && heading.role === "" ?
                                                    <div className="flex-row justify-center form-labels font-weight500 font-size-subheading" style={{ marginTop: "30px" }} >
                                                        OR
                                                    </div>
                                                    : null}

                                                {heading.role ? null :
                                                    <div style={{ flex: 1, display: "flex", flexDirection: "column" }}>
                                                        <label htmlFor={`department_${index}`} className="form-labels font-weight500 font-size-subheading">
                                                            Authority Name<span className="required">*</span>
                                                        </label>
                                                        {buffer1 ?
                                                            <div className="form-loader-date">
                                                                <div className="bar-loader"></div>
                                                            </div> :
                                                            <Select
                                                                options={employeeOptions}
                                                                onChange={(selectedOption) => {
                                                                    if (selectedOption) {
                                                                        handleOtherInputChange(index, {
                                                                            target: {
                                                                                name: 'employee',
                                                                                value: selectedOption.value,
                                                                            }
                                                                        });
                                                                    } else {
                                                                        handleOtherInputChange(index, {
                                                                            target: {
                                                                                name: 'employee',
                                                                                value: '',
                                                                            }
                                                                        });
                                                                    }
                                                                }}
                                                                value={employeeOptions.find(option => option.value === heading.employee)}
                                                                placeholder="Select or Search Employee"
                                                                isClearable
                                                                noOptionsMessage={() => "No other options"}
                                                                styles={CSSForSelectSmallWidth}
                                                            />
                                                        }
                                                        {errors[`employee${index}`] && (
                                                            <span className="error-message font-size-text">
                                                                {errors[`employee${index}`]}
                                                            </span>
                                                        )}
                                                    </div>
                                                }
                                            </div>
                                            <div style={{ display: "flex", gap: "20px", marginBottom: "10px" }}>
                                                <div style={{ flex: 1, display: "flex", flexDirection: "column" }}>
                                                    <label htmlFor="permissions" className="form-labels font-weight500 font-size-subheading">
                                                        Permission<span className="required">*</span>
                                                    </label>
                                                    <Select
                                                        id='permissions'
                                                        name='permissions'
                                                        options={permissionOption}
                                                        isClearable
                                                        onChange={(selectedOption) => {
                                                            handleOtherInputChange(index, {
                                                                target: {
                                                                    name: 'permissions',
                                                                    value: selectedOption ? selectedOption.value : '',
                                                                }
                                                            });
                                                        }}
                                                        value={permissionOption.find(option => option.value === heading.permissions) || null}
                                                        styles={CSSForSelectSmallWidth}
                                                    />
                                                    {errors[`permissions${index}`] && (
                                                        <span className="error-message font-size-text">
                                                            {errors[`permissions${index}`]}
                                                        </span>
                                                    )}
                                                </div>

                                                <div style={{ flex: 1, display: "flex", flexDirection: "column" }}>
                                                    <div className="flex-row gap-2">
                                                        <label className="form-labels font-weight500 font-size-subheading">
                                                            Threshold Amount
                                                            {heading.threshold_approval ? ' Enabled ' : ' Disabled '}
                                                        </label>
                                                        <div className="checkbox-toggle" style={{ display: "flex", alignItems: "center" }}>
                                                            <input
                                                                id={`threshold_approval${index}`}
                                                                name={`threshold_approval`}
                                                                type="checkbox"
                                                                checked={heading.threshold_approval}
                                                                onChange={(e) => {
                                                                    handleStagesInputChanges(e, index)
                                                                    setFormData((prevFormData) => {
                                                                        const updatedStages = [...prevFormData.stages];
                                                                        updatedStages[index] = {
                                                                            ...updatedStages[index],
                                                                            threshold_amt: 0,
                                                                        };
                                                                        return { ...prevFormData, stages: updatedStages };
                                                                    })
                                                                }}
                                                            />
                                                            <label htmlFor={`threshold_approval${index}`}></label>
                                                        </div>
                                                    </div>
                                                    {heading.threshold_approval &&
                                                        <input
                                                            type="number"
                                                            id={`threshold_amt${index}`}
                                                            name={`threshold_amt`}
                                                            placeholder={"Threshold Amount"}
                                                            value={heading.threshold_amt}
                                                            min={0}
                                                            onWheel={(e) => e.target.blur()}
                                                            onChange={(e) => handleStagesInputChanges(e, index)}
                                                            className="form-input width-20vw" />}
                                                    {errors[`threshold_amt${index}`] && (
                                                        <span className="error-message font-size-text">{errors[`threshold_amt${index}`]}</span>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    ))}

                                    {errors.stages && (
                                        <div className="error-message font-size-text text-center">
                                            {errors.stages}
                                        </div>
                                    )}

                                    <div className="flex-row">
                                        <hr className="line" />
                                        <div className='flex-row justify-end '>
                                            <button
                                                type='button'
                                                title="Add Stages"
                                                className="flex-row jd-heading-main font-weight600 gap-2"
                                                onClick={handleAddOthers}
                                            >
                                                <AddwithBlueCircle />
                                                <span className='w-max-content'>
                                                    Add More Stages
                                                </span>
                                            </button>
                                        </div>
                                    </div>
                                </>
                            )}



                            {/* Revert Suggestion Banner */}
                            {showRevertSuggestion && matchingVersion && (
                                <div className="notice-badge color-badge-warning">
                                    <div className='flex-row justify-between'>
                                        <strong>⚠️ Matching Flow Found!</strong>
                                        <button
                                            // className="btn btn-sm btn-outline-dark"
                                            className="priority-button color-tab-yellow"
                                            onClick={() => setShowRevertSuggestion(false)}
                                        >
                                            Continue with new version
                                        </button>
                                    </div>
                                    {/* <br /> */}
                                    Your current flow matches version {matchingVersion.version}'s flow: <small>{getStageFlowPreview(matchingVersion.stages, matchingVersion.auto_approve_when_no_stages)}</small>
                                </div>
                            )}
                            <div className="button-models">
                                <button className="model-button model-button-cancel font-weight500" onClick={handleClose}>
                                    Cancel
                                </button>


                                {showRevertSuggestion && matchingVersion ?
                                    <button
                                        className="model-button font-weight500 model-button-pending font-size-heading"
                                        onClick={handleRevertSuggestion}
                                    >
                                        Revert to Version {matchingVersion.version}
                                    </button>
                                    :
                                    <button
                                        type="submit"
                                        className="model-button font-weight500 model-button-submit font-size-heading"
                                        onClick={handleFormSubmit}
                                        disabled={loading}
                                    >
                                        Update
                                    </button>
                                }
                            </div>
                        </div>

                        <p className="error-message font-size-text">
                            {isSubmitted && Object.keys(errors).length > 0 && (
                                Object.keys(errors).length > 5 ? (
                                    <h5 className="text-center">Please fill all mandatory fields!</h5>
                                ) : (
                                    <h6 className="text-center">
                                        {Object.keys(errors).map((field) =>
                                            field.charAt(0).toUpperCase() + field.slice(1)
                                        ).join(', ') + ' are required!'}
                                    </h6>
                                )
                            )}
                        </p>
                    </div>
                </Modal.Body >
                <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
            </Modal >

            {/* Revert Version Modal */}
            <Modal Modal show={showRevertModal} onHide={() => setShowRevertModal(false)} dialogClassName="request-leave" >
                <Modal.Header closeButton>
                    <Modal.Title>Revert to Previous Version</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div">
                        <p>Select a version to revert to:</p>
                        {i.all_versions && i.all_versions
                            .filter(version => version.version !== i.version) // Exclude current version
                            .map(version => (
                                <div key={version.format_id} className="version-option p-2 border rounded mb-2">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <div>
                                            <strong>Version {version.version}</strong>
                                            <div className="small text-muted">
                                                Stages: {version.stages_count} <br />
                                                <small>Flow: {getStageFlowPreview(version.stages, version.auto_approve_when_no_stages)}</small> <br />
                                                Existing Requests: {version.requests_count?.total || 0}
                                            </div>
                                        </div>
                                        <button
                                            className="priority-button model-button-submit"
                                            onClick={() => handleRevertToVersion(version.format_id)}
                                        >
                                            Revert to V{version.version}
                                        </button>
                                    </div>
                                </div>
                            ))
                        }
                        {(!i.all_versions || i.all_versions.filter(v => v.version !== i.version).length === 0) && (
                            <p className="text-muted">No previous versions available</p>
                        )}
                    </div>
                </Modal.Body>
            </Modal >
        </>
    );
};


const DeleteApprovalFormatBackup = ({ i, getApprovalFormat }) => {
    const [show, setShow] = useState(false);

    const handleClose = () => {
        setShow(false);
    }
    const handleShow = () => {
        setShow(true);
    };

    const handleFormSubmitDelete = async (e) => {
        e.preventDefault();
        const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

        try {
            let res = await axios.delete(`${BASE_URL}/wfm/dynamicapprovalformatstagesupdate/${i.format_id}/`);

            if (res.status === 200) {
                await getApprovalFormat();
                handleClose();
                toast.dismiss(loadingToastId);
                toast.success("Submitted Successfully")
            }
        } catch (err) {
            //toast Logic
            handleErrorToast(err)
        } finally {
            toast.dismiss(loadingToastId);
        }
    };

    const formatList = [
        { label: "Leave Request", value: "leave" },
        { label: "OutDuty Request", value: "outduty" },
        // { label: "CompOff Request", value: "compoff" },
        { label: "Imprest Request", value: "imprest" },
        { label: "Expense Request", value: "expense" },
        // { label: "Advance", value: "advance" },
        { label: "Separation Request", value: "separation" },
        { label: "Employee Details Change Request", value: "empDetails" },
        { label: "Bank Details Change Request", value: "bankdetails" },
        { label: "Investment Declaration", value: "investment_declaration" },
        { label: "Investment Proof Justification", value: "investment_proof" },
    ]


    return (
        <>
            <button title="Delete Format" className="model-delete-button" onClick={handleShow}>
                <DeleteDustbin />
            </button>

            <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
                <Modal.Header closeButton>
                    <Modal.Title>Delete {formatList.find(f => f.value === i.format_for)?.label || i.format_for} Format </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div">
                        Are You Sure You Want to delete {formatList.find(f => f.value === i.format_for)?.label || i.format_for}'s flow format data?
                        <br />
                        <b>This will also remove from all its previous {i?.previous_versions_count} versions.</b>
                        <div className="button-models">
                            <button className="model-button   font-weight500   model-button-cancel " onClick={handleClose}>
                                Cancel
                            </button>
                            <button
                                onClick={handleFormSubmitDelete}
                                className="model-button   font-weight500    model-button-delete"
                            >
                                Delete
                            </button>
                        </div>
                    </div>
                    <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
                </Modal.Body>
            </Modal>
        </>
    );
};


const DeleteApprovalFormat = ({ i, getApprovalFormat }) => {
    const [show, setShow] = useState(false);
    const [deleteAllToggle, setDeleteAllToggle] = useState(false); // false = delete-current, true = delete-all
    const [stagesWithRequests, setStagesWithRequests] = useState([]);
    const [stagesWithoutRequests, setStagesWithoutRequests] = useState([]);
    const [selectedVersions, setSelectedVersions] = useState([]); // Array of format_ids to delete

    const handleClose = () => {
        setShow(false);
        setDeleteAllToggle(false);
        setStagesWithRequests([]);
        setStagesWithoutRequests([]);
        setSelectedVersions([]);
    }

    const handleShow = () => {
        setShow(true);
        // Analyze which versions have requests
        analyzeVersions();
    };

    const analyzeVersions = () => {
        if (i.all_versions) {
            const withRequests = [];
            const withoutRequests = [];

            i.all_versions.forEach(version => {
                const hasRequests = version.requests_count?.total > 0;
                if (hasRequests) {
                    withRequests.push(version);
                } else {
                    withoutRequests.push(version);
                }
            });

            setStagesWithRequests(withRequests);
            setStagesWithoutRequests(withoutRequests);
            // Auto-select all available versions initially
            setSelectedVersions(withoutRequests.map(v => v.format_id));
        }
    };

    const handleFormSubmitDelete = async (e) => {
        e.preventDefault();
        const loadingToastId = toast.loading("Loading: Please wait...");

        try {
            let res = await axios.delete(`${BASE_URL}/wfm/dynamicapprovalformatstages/custom-delete/${i.format_id}/`, {
                data: {
                    delete_option: deleteAllToggle ? 'delete-all' : 'delete-current',
                    make_previous_active: !deleteAllToggle
                }
            });

            if (res.status === 200) {
                toast.dismiss(loadingToastId);
                toast.success(res.data.message || "Deleted Successfully")
                await getApprovalFormat();
                handleClose();
            }
        } catch (err) {
            handleErrorToast(err)
        } finally {
            toast.dismiss(loadingToastId);
        }
    };

    const handleDeleteSelectiveStages = async () => {
        if (selectedVersions.length === 0) {
            toast.error("Please select at least one version to delete");
            return;
        }

        const loadingToastId = toast.loading("Loading: Deleting selective stages...");

        try {
            let res = await axios.post(`${BASE_URL}/wfm/dynamicapprovalformatstages/bulk-delete/`, {
                format_ids: selectedVersions,
                delete_option: 'delete-selected'
            });

            if (res.status === 200) {
                toast.dismiss(loadingToastId);
                toast.success(res.data.message || "Selected stages deleted successfully")
                await getApprovalFormat();
                handleClose();
            }
        } catch (err) {
            handleErrorToast(err)
        } finally {
            toast.dismiss(loadingToastId);
        }
    };

    // Handle checkbox selection
    const handleVersionSelect = (formatId, isSelected) => {
        if (isSelected) {
            setSelectedVersions(prev => [...prev, formatId]);
        } else {
            setSelectedVersions(prev => prev.filter(id => id !== formatId));
        }
    };

    // Select/Deselect all available versions
    const handleSelectAll = (selectAll) => {
        if (selectAll) {
            setSelectedVersions(stagesWithoutRequests.map(v => v.format_id));
        } else {
            setSelectedVersions([]);
        }
    };

    const formatList = [
        { label: "Leave Request", value: "leave" },
        { label: "OutDuty Request", value: "outduty" },
        { label: "Imprest Request", value: "imprest" },
        { label: "Expense Request", value: "expense" },
        { label: "Separation Request", value: "separation" },
        { label: "Employee Details Change Request", value: "empDetails" },
        { label: "Bank Details Change Request", value: "bankdetails" },
        { label: "Investment Declaration", value: "investment_declaration" },
        { label: "Investment Proof Justification", value: "investment_proof" },
    ]

    const formatLabel = formatList.find(f => f.value === i.format_for)?.label || i.format_for;
    const hasRequests = stagesWithRequests.length > 0;
    const allSelected = selectedVersions.length === stagesWithoutRequests.length && stagesWithoutRequests.length > 0;
    const someSelected = selectedVersions.length > 0 && selectedVersions.length < stagesWithoutRequests.length;

    // Helper function to display stage flow in short


    return (
        <>
            <button title="Delete Format" className="model-delete-button" onClick={handleShow}>
                <DeleteDustbin />
            </button>

            <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-70vw">
                <Modal.Header closeButton>
                    <Modal.Title>Delete {formatLabel} Format</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div">
                        {/* Current Version Info */}
                        <div className="notice-badge color-tab-grey">
                            <strong>Current Version: {i.version}</strong><br />
                            <small>Flow: {getStageFlowPreview(i.stages, i.auto_approve_when_no_stages)}</small><br />
                            <small>Stages: {i.stages_count} | Requests: {i.requests_count?.total || 0}</small>
                        </div>

                        <hr />

                        {/* Delete Option Toggle */}
                        <div className="flex-column">
                            <div className="flex-row">
                                <label className="font-weight500 font-size-subheading">
                                    Delete Option:
                                </label>
                                <hr className="field-cont-hr" />
                                <div className="d-flex align-items-center gap-3">
                                    <span className={`font-weight500 ${!deleteAllToggle ? 'text-danger' : 'text-muted'}`}>
                                        Delete Current Version
                                    </span>

                                    <div className="checkbox-toggle">
                                        <input
                                            type="checkbox"
                                            name="delete_all_check"
                                            checked={deleteAllToggle}
                                            onChange={(e) => setDeleteAllToggle(e.target.checked)}
                                            id="delete_all_toggle"
                                        />
                                        <label htmlFor="delete_all_toggle"></label>
                                    </div>

                                    <span className={`font-weight500 ${deleteAllToggle ? 'text-danger' : 'text-muted'}`}>
                                        Delete All Versions
                                    </span>
                                </div>
                            </div>
                        </div>

                        <hr />

                        {/* Warning Messages */}
                        {!deleteAllToggle && (
                            <div className="notice-badge color-badge-danger">
                                <strong>Current Version Deletion:</strong><br />
                                • This will delete the current active version ({i.version})<br />
                                • Previous version will be automatically activated<br />
                                {/* • Forms using this version will continue to reference it */}
                            </div>
                        )}

                        {deleteAllToggle && hasRequests && (
                            <div className="">
                                {/* Versions with requests (cannot be deleted) */}
                                <div className="">
                                    <strong className="text-danger">Versions with active requests (Cannot be Deleted):</strong>
                                    {stagesWithRequests.map(version => (
                                        <div key={version.format_id} className="mt-2 p-2  color-tab-red rounded">
                                            <div className="flex-row justify-between align-start">
                                                <div>
                                                    <strong>Version {version.version} {version.is_active && "(Active)"}</strong>
                                                    <div className="small text-muted">
                                                        Flow: {getStageFlowPreview(version.stages, version.auto_approve_when_no_stages)}
                                                    </div>
                                                    <div className="small">
                                                        Stages: {version.stages_count} |
                                                        Requests: {version.requests_count?.total || 0}
                                                    </div>
                                                </div>
                                                <span className="badge bg-danger-color">Cannot be Deleted</span>
                                            </div>
                                        </div>
                                    ))}
                                </div>

                                <hr />

                                {/* Versions without requests (can be deleted) */}
                                {stagesWithoutRequests.length > 0 && (
                                    <div className="">
                                        <div className="flex-row justify-between align-start">
                                            <strong className="text-success-color">Versions available for deletion:</strong>
                                            <div className="flex-row">
                                                <label className="checkbox-click">
                                                    <input
                                                        // className="form-check-input"
                                                        type="checkbox"
                                                        id="selectAllVersions"
                                                        checked={allSelected}
                                                        ref={input => {
                                                            if (input) {
                                                                input.indeterminate = someSelected;
                                                            }
                                                        }}
                                                        onChange={(e) => handleSelectAll(e.target.checked)}
                                                    />
                                                    <div className="checkmark-medium"></div>
                                                </label>
                                                <label className="form-check-label small" htmlFor="selectAllVersions">
                                                    {" "}{allSelected ? ' Deselect All' : ' Select All'} ({selectedVersions.length}/{stagesWithoutRequests.length} selected)
                                                </label>
                                            </div>
                                        </div>

                                        {stagesWithoutRequests.map(version => {
                                            const isSelected = selectedVersions.includes(version.format_id);
                                            return (
                                                <label
                                                    key={version.format_id}
                                                    className={`mt-2 p-2 border rounded ${isSelected ? 'border-success bg-light' : 'border-success'} d-block version-select-item`}
                                                    style={{ cursor: 'pointer', marginBottom: 0 }}
                                                    htmlFor={`version_${version.format_id}`}
                                                >
                                                    <div className="d-flex justify-content-between align-items-start">
                                                        <div className="d-flex align-items-start gap-3" style={{ flex: 1 }}>
                                                            <label className="checkbox-click">
                                                                <input
                                                                    type="checkbox"
                                                                    id={`version_${version.format_id}`}
                                                                    checked={isSelected}
                                                                    onChange={(e) => handleVersionSelect(version.format_id, e.target.checked)}
                                                                    className="version-checkbox"
                                                                />
                                                                <div className="checkmark-medium"></div>
                                                            </label>
                                                            <div style={{ flex: 1 }}>
                                                                <strong>Version {version.version} {version.is_active && "(Active)"}</strong>
                                                                <div className="small text-muted">
                                                                    Flow: {getStageFlowPreview(version.stages, version.auto_approve_when_no_stages)}
                                                                </div>
                                                                <div className="small">
                                                                    Stages: {version.stages_count} |
                                                                    Requests: {version.requests_count?.total || 0}
                                                                    {/* Created: {new Date(version.created_at).toLocaleDateString()} */}
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <span className={`badge ${isSelected ? 'bg-danger-color' : 'bg-secondary-color'}`}>
                                                            {isSelected ? 'Selected' : 'Available for Delete'}
                                                        </span>
                                                    </div>
                                                </label>
                                            )
                                        })}
                                    </div>
                                )}

                                {stagesWithoutRequests.length === 0 && (
                                    <div className="align-center">
                                        <strong className="text-warning-color">No versions available for deletion.</strong><br />
                                        All versions have active requests.
                                        {/* All versions have active requests. Please wait for requests to complete before deleting. */}
                                    </div>
                                )}
                            </div>
                        )}

                        {deleteAllToggle && !hasRequests && (
                            <div className="notice-badge color-badge-danger">
                                <strong> Permanent Deletion</strong><br />
                                This will permanently delete ALL {i.all_versions?.length || 0} versions of this format.<br />
                                <b>- This action cannot be undone.</b>

                                {/* Show all versions that will be deleted */}
                                <div className="mt-3">
                                    <strong>Versions that will be deleted:</strong>
                                    {i.all_versions?.map(version => (
                                        <div key={version.format_id} className="mt-2 p-2 color-border-red rounded">
                                            <div className="d-flex justify-content-between align-items-start">
                                                <div>
                                                    <strong>Version {version.version} {version.is_active && "(Active)"}</strong>
                                                    <div className="small text-muted">
                                                        Flow: {getStageFlowPreview(version.stages, version.auto_approve_when_no_stages)}
                                                    </div>
                                                    <div className="small">
                                                        Stages: {version.stages_count} |
                                                        Requests: {version.requests_count?.total || 0}
                                                    </div>
                                                </div>
                                                <span className="badge bg-danger-color">Will be Deleted</span>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}

                        {/* Action Buttons */}
                        <div className="button-models mt-4">
                            <button className="model-button font-weight500 model-button-cancel" onClick={handleClose}>
                                Cancel
                            </button>

                            {/* Show delete button only when allowed */}
                            {(!deleteAllToggle || (deleteAllToggle && !hasRequests)) && (
                                <button
                                    onClick={handleFormSubmitDelete}
                                    className="model-button font-weight500 model-button-delete"
                                >
                                    {deleteAllToggle ? 'Delete All Versions' : 'Delete Current Version'}
                                </button>
                            )}

                            {
                                deleteAllToggle && hasRequests && stagesWithoutRequests.length > 0 &&
                                <div className="align-center">
                                    <button
                                        className={`model-button font-weight500 ${selectedVersions.length !== 0 ? 'model-button-delete' : 'model-button-inactive'}`}
                                        onClick={handleDeleteSelectiveStages}
                                        disabled={selectedVersions.length === 0}
                                    >
                                        Delete {selectedVersions.length} Selected Version(s)
                                    </button>
                                    <small className="d-block text-muted mt-1">
                                        {selectedVersions.length === 0
                                            ? 'Please select versions to delete'
                                            : `This will delete ${selectedVersions.length} selected version(s)`
                                        }
                                    </small>
                                </div>}
                        </div>
                    </div>
                    <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
                </Modal.Body>
            </Modal>
        </>
    );
};

const ViewApprovalFormatFlow = ({ i }) => {
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const formatList = [
        { label: "Leave Request", value: "leave" },
        { label: "OutDuty Request", value: "outduty" },
        // { label: "CompOff Request", value: "compoff" },
        { label: "Imprest Request", value: "imprest" },
        { label: "Expense Request", value: "expense" },
        // { label: "Advance", value: "advance" },
        { label: "Separation Request", value: "separation" },
        { label: "Employee Details Change Request", value: "empDetails" },
        { label: "Bank Details Change Request", value: "bankdetails" },
        { label: "Investment Declaration", value: "investment_declaration" },
        { label: "Investment Proof Justification", value: "investment_proof" },
    ]

    return (
        <>
            {/* <button title="View approval Flow" className="" onClick={handleShow}>
                <Eye />
            </button> */}
            <button title="View approval Flow" className="document-download-button  width-5vw  width-5vw" onClick={handleShow}>
                View
            </button>

            <Modal show={show} onHide={handleClose} dialogClassName="four-fifth-modal">
                <Modal.Header closeButton>
                    <Modal.Title>Approval Process Flow of "
                        {formatList.find(f => f.value === i.format_for)?.label || i.format_for}
                        {/* {i.format_for} */}
                        "</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div">
                        <div className="bdy-div approval-flow-container">
                            {i.stages?.length > 0 ? (
                                <ul className="approval-steps">
                                    {i.stages
                                        .sort((a, b) => a.level - b.level)
                                        .map((stage) => (
                                            <li key={stage.id} className="approval-step stage-card">
                                                <div className="flex-column mb-3">
                                                    <div className='stage-header'>
                                                        <label className="font-weight500 announce-date">
                                                            Stage {stage.level}
                                                        </label>
                                                    </div>
                                                    <div className="stage-details">
                                                        <div className="detail-item">
                                                            <span className="detail-label">Assigned To {stage.employee_name ? 'Employee' : 'Role'}:</span>
                                                            <span span className="detail-value">
                                                                {stage.role || stage.employee_name || 'Not assigned'}
                                                            </span>
                                                        </div>
                                                        <div className="detail-item">
                                                            <span className="detail-label">Permissions:</span>
                                                            <span className="detail-value">
                                                                {stage.permissions || 'N/A'}
                                                            </span>
                                                        </div>
                                                        <div className="detail-item">
                                                            <span className="detail-label">Threshold Amount:</span>
                                                            <span className="detail-value">
                                                                {stage.threshold_amt ? `₹${stage.threshold_amt}` : 'Not specified'}
                                                            </span>
                                                        </div>
                                                        <div className="detail-item">
                                                            <span className="detail-label">Threshold Approval:</span>
                                                            <span className="detail-value">
                                                                {stage.threshold_approval ? 'Required' : 'Not required'}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </li>
                                        ))}
                                </ul>
                            ) : (
                                // <p>No stages defined.</p>
                                <p>Direct Approval - No Stages</p>
                            )}
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
};

const ViewVersionHistory = ({ formatData, formatList }) => {
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    if (!formatData.all_versions || formatData.all_versions.length <= 1) {
        return (
            <button
                className="btn-disabled width-5vw"
                disabled
                title="No previous versions"
            >
                No History
            </button>
        );
    }

    return (
        <>
            <button
                title="View version history"
                className="document-download-button width-5vw"
                onClick={handleShow}
            >
                History ({formatData.previous_versions_count})
            </button>

            <Modal show={show} onHide={handleClose} dialogClassName="four-fifth-modal">
                <Modal.Header closeButton>
                    <Modal.Title>
                        Version History - "{formatList.find(f => f.value === formatData.format_for)?.label || formatData.format_for}"
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div">
                        <div className="bdy-div approval-flow-container">
                            <div className="version-info mb-4 p-3" style={{ backgroundColor: '#f8f9fa', borderRadius: '8px' }}>
                                <div className="row">
                                    <div className="col-md-6">
                                        <p className="mb-1"><strong>Sub Company:</strong> {formatData.sub_company_title}</p>
                                        <p className="mb-1"><strong>Total Versions:</strong> {formatData.all_versions.length}</p>
                                        <p className="mb-1"><strong>No. of Older Versions:</strong> {formatData.previous_versions_count}</p>
                                        {/* <p className="mb-1"><strong>Total no. of Older Versions:</strong> {formatData.previous_versions_count}</p> */}
                                    </div>
                                </div>
                            </div>
                            <hr className='line' />
                            <div className="versions-list">
                                {formatData.all_versions
                                    .sort((a, b) => b.version - a.version)
                                    // .filter((n) => !n.is_active)
                                    .map((version, index) => (
                                        <div key={version.format_id} className="version-section mb-4">
                                            <div className={`version-header p-3 ${version.is_active ? 'bg-primary-color text-white' : 'bg-light'}`} style={{ borderRadius: '8px' }}>
                                                <div className="d-flex justify-content-between align-items-center">
                                                    <div>
                                                        <h5 className="mb-0">
                                                            Version {version.version}
                                                            {version.is_active && (
                                                                <span className="badge bg-dark text-white  ms-2">Current Active</span>
                                                            )}
                                                        </h5>
                                                        <small>
                                                            Created: {new Date(version.created_at).toLocaleDateString()} • {version.stages_count} Stages
                                                        </small>
                                                    </div>
                                                    <div className="text-end">
                                                        <small>Status: {version.is_active ? 'Active' : 'Inactive'}</small>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="version-stages mt-3">
                                                <h6 className="mb-3">Approval Stages:</h6>
                                                <ul className="approval-steps">
                                                    {version.stages
                                                        .sort((a, b) => a.level - b.level)
                                                        .map((stage) => (
                                                            <li key={stage.id} className="approval-step stage-card">
                                                                <div className="flex-column mb-3">
                                                                    <div className='stage-header'>
                                                                        <label className="font-weight500 announce-date">
                                                                            Stage {stage.level}
                                                                        </label>
                                                                    </div>
                                                                    <div className="stage-details">
                                                                        <div className="detail-item">
                                                                            <span className="detail-label">Assigned To {stage.employee_name ? 'Employee' : 'Role'}:</span>
                                                                            <span className="detail-value">
                                                                                {stage.role || stage.employee_name || 'Not assigned'}
                                                                                {stage.role === "ReportingHead" && " (Dynamic)"}
                                                                            </span>
                                                                        </div>
                                                                        <div className="detail-item">
                                                                            <span className="detail-label">Permissions:</span>
                                                                            <span className="detail-value">
                                                                                {stage.permissions || 'N/A'}
                                                                            </span>
                                                                        </div>
                                                                        <div className="detail-item">
                                                                            <span className="detail-label">Threshold Amount:</span>
                                                                            <span className="detail-value">
                                                                                {stage.threshold_amt ? `₹${stage.threshold_amt}` : 'Not specified'}
                                                                            </span>
                                                                        </div>
                                                                        <div className="detail-item">
                                                                            <span className="detail-label">Threshold Approval:</span>
                                                                            <span className="detail-value">
                                                                                {stage.threshold_approval ? 'Required' : 'Not required'}
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </li>
                                                        ))}
                                                    {version?.stages?.length == 0 && 'Direct Approval - No Stages'}
                                                </ul>
                                            </div>
                                            <hr className='line' />
                                        </div>
                                    ))}
                            </div>
                        </div>
                    </div>
                </Modal.Body>

            </Modal>
        </>
    );
};


const AddDefaultImprestType = ({ getImprestTypeFormat, SUB_COMPANIES, SUPER_ADMIN }) => {
    const [show, setShow] = useState(false)
    const handleShow = () => {
        setShow(true);
    }

    const handleClose = () => {
        setShow(false);
        setFormData({
            other_name: "",
            sub_company: sessionStorage.getItem('company_id'),
        })
    }

    const [formData, setFormData] = useState({
        other_name: "",
        sub_company: sessionStorage.getItem('company_id'),
    });

    const [errors, setErrors] = useState({});

    const validateForm = () => {
        const newErrors = {};
        let requiredFields = [
            "other_name",
            "sub_company",
        ]

        requiredFields.forEach((field) => {
            if (!formData[field]) {
                newErrors[field] = `${field.charAt(0).toUpperCase() + field.slice(1)} is required!`;
            }
        })

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;

    };

    const [loading, setLoading] = useState(false);

    const handleSubmitData = async (e) => {
        e.preventDefault();
        if (validateForm()) {
            const loadingToastId = toast.loading("Loading Data Please Wait....");
            setLoading(true);
            try {
                let res = await axios.post(`${BASE_URL}/wfm/imprest_type_format/`, formData);
                if (res.status === 200) {
                    await getImprestTypeFormat();
                    toast.success("Data Uploaded Successfully!")
                    toast.dismiss(loadingToastId);
                    handleClose();
                }
            } catch (error) {
                handleErrorToast(error);
            } finally {
                setLoading(false);
                toast.dismiss(loadingToastId);
            }
        }
    }

    const subcompanyOption = SUB_COMPANIES.sort((a, b) => b.title.localeCompare(a.title)).map((i) => ({
        value: i.id,
        label: i.title
    }))

    const handleCompanyChange = (selectedOption) => {
        if (!selectedOption) {
            setFormData({
                ...formData,
                sub_company: "",
            })

        } else {
            setFormData({
                ...formData,
                sub_company: selectedOption.value,
            })
        }

        setErrors((prevErrors) => {
            const updatedErrors = { ...prevErrors };
            delete updatedErrors.sub_company;
            return updatedErrors;
        });

    }

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setFormData({
            ...formData,
            [name]: value,
        });

        if (value.trim()) {
            setErrors((prevErrors) => {
                const updatedErrors = { ...prevErrors };
                delete updatedErrors[name];
                return updatedErrors;
            });
        }
    };

    return (
        <>
            <button className='upload-svg' title='Add Role' onClick={handleShow}>
                <AddwithWhiteCircle /> Imprest Type
            </button>
            <Modal show={show} onHide={handleClose} dialogClassName='request-leave width-40vw'>
                <Modal.Header className='justify-center task-Tab-heading font-weight500    font-size-heading ' closeButton>
                    <Modal.Title>
                        Add a Default Imprest Type
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div>
                        <div>
                            {SUPER_ADMIN && <div className="flex-column">
                                <div>
                                    <label htmlFor="sub_company">Select Sub Company</label>
                                    <Select
                                        options={subcompanyOption}
                                        onChange={handleCompanyChange}
                                        value={subcompanyOption.find(option => option.value === formData.sub_company)}
                                        placeholder="Select SubCompany"
                                        isSearchable
                                        isClearable
                                        noOptionsMessage={() => "No other options"}
                                        styles={CSSForSelect}
                                    />
                                </div>
                                {errors.sub_company && (
                                    <div className="error-message font-size-text">{errors.sub_company}</div>

                                )}
                            </div>}
                            <div className="flex-column">
                                <div>
                                    <label htmlFor="other_name">Select Imprest Type Name</label>
                                    <input
                                        id="other_name"
                                        type="text"
                                        name="other_name"
                                        placeholder="Imprest Type Name"
                                        onChange={handleInputChange}
                                        value={formData.other_name}
                                        className={`form-input`}
                                    />
                                </div>
                                {errors.other_name && (
                                    <div className="error-message font-size-text">{errors.other_name}</div>

                                )}
                            </div>
                            <div className="button-models">
                                <button
                                    type="button"
                                    className="model-button model-button-cancel font-weight500"
                                    onClick={handleClose}>
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    className="model-button model-button-leave font-weight500 font-size-heading"
                                    onClick={handleSubmitData}
                                    disabled={loading}
                                >
                                    Submit
                                </button>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
            <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
        </>
    )

}

const UpdateDefaultImprestType = ({ i, getImprestTypeFormat, SUB_COMPANIES }) => {
    const [show, setShow] = useState(false);

    const handleShow = () => {
        setFormData(i);
        setShow(true);
    }

    const handleClose = () => {
        setShow(false);
    }


    const [formData, setFormData] = useState({
        other_name: "",
        sub_company: "",

    });

    const [errors, setErrors] = useState({});

    const validateForm = () => {

        const newErrors = {};
        const requiredFields = [
            "other_name", "sub_company"
        ]

        requiredFields.forEach((field) => {
            if (!formData[field]) {
                newErrors[field] = `${field.charAt(0).toUpperCase() + field.slice(1)} is required!`;
            }
        })

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const [loading, setLoading] = useState(false);

    const handleSubmitData = async (e) => {
        e.preventDefault();
        if (validateForm()) {
            const loadingToastId = toast.loading("Loading Data Please Wait....");
            setLoading(true);
            try {
                let res = await axios.put(`${BASE_URL}/wfm/imprest_type_format_updateAPI/${i.id}/`, formData);
                if (res.status === 200) {
                    await getImprestTypeFormat();
                    toast.success("Data Updated Successfully!")
                    toast.dismiss(loadingToastId);
                    handleClose();
                }
            } catch (error) {
                handleErrorToast(error);
            } finally {
                setLoading(false);
                toast.dismiss(loadingToastId);
            }
        }
    }

    const subcompanyOption = SUB_COMPANIES.sort((a, b) => b.title.localeCompare(a.title)).map((i) => ({
        value: i.id,
        label: i.title
    }))

    const handleCompanyChange = (selectedOption) => {
        if (!selectedOption) {
            setFormData({
                ...formData,
                sub_company: "",
            })

        } else {
            setFormData({
                ...formData,
                sub_company: selectedOption.value,
            })
        }

        setErrors((prevErrors) => {
            const updatedErrors = { ...prevErrors };
            delete updatedErrors.sub_company;
            return updatedErrors;
        });

    }

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setFormData({
            ...formData,
            [name]: value,
        });

        if (value.trim()) {
            setErrors((prevErrors) => {
                const updatedErrors = { ...prevErrors };
                delete updatedErrors[name];
                return updatedErrors;
            });
        }
    };

    return (
        <>
            <button className='model-edit-button-ml' title='Update Role' onClick={handleShow}>
                <UpdatePencil />
            </button>
            <Modal show={show} onHide={handleClose} dialogClassName='request-leave width-40vw'>
                <Modal.Header className='justify-center task-Tab-heading font-weight500    font-size-heading ' closeButton>
                    <Modal.Title>
                        Update Employee Role
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div>
                        <div>

                            <div className="flex-column">
                                <div>
                                    <label htmlFor="sub_company">Select Sub Company</label>
                                    <Select
                                        options={subcompanyOption}
                                        onChange={handleCompanyChange}
                                        value={subcompanyOption.find(option => option.value === formData.sub_company)}
                                        placeholder="Select SubCompany"
                                        isSearchable
                                        isClearable
                                        noOptionsMessage={() => "No other options"}
                                        styles={CSSForSelect}
                                    />
                                </div>
                                {errors.sub_company && (
                                    <div className="error-message font-size-text">{errors.sub_company}</div>

                                )}
                            </div>
                            <div className="flex-column">
                                <div>
                                    <label htmlFor="other_name">Select Imprest Type Name</label>
                                    <input
                                        id="other_name"
                                        type="text"
                                        name="other_name"
                                        placeholder="Imprest Type Name"
                                        onChange={handleInputChange}
                                        value={formData.other_name}
                                        className={`form-input`}
                                    />
                                </div>
                                {errors.other_name && (
                                    <div className="error-message font-size-text">{errors.other_name}</div>

                                )}
                            </div>
                            <div className="button-models">
                                <button
                                    type="button"
                                    className="model-button model-button-cancel font-weight500"
                                    onClick={handleClose}>
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    className="model-button model-button-leave font-weight500 font-size-heading"
                                    onClick={handleSubmitData}
                                    disabled={loading}
                                >
                                    Update
                                </button>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
            </Modal>
        </>
    )
}

const DeleteDefaultImprestType = ({ i, getImprestTypeFormat }) => {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => {
        setShow(true);
    };
    const [loading, setLoading] = useState(false);

    const handleFormSubmitDelete = async (e) => {
        e.preventDefault();
        const loadingToastId = toast.loading("Deleting: Please wait..."); //toast Logic
        setLoading(true);

        try {
            let res = await axios.delete(
                `${BASE_URL}/wfm/imprest_type_format_updateAPI/${i.id}/`
            );

            if (res.status === 200) {
                await getImprestTypeFormat();
                toast.success("Data Deleted Successfully");
                toast.dismiss(loadingToastId);
                setShow(false);
            } else {
                alert(res);
            }
        } catch (err) {
            //toast Logic
            handleErrorToast(err);
        } finally {
            toast.dismiss(loadingToastId);
            setLoading(false);
        }
    };

    return (
        <>
            <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
            <button
                title="Delete Insurance"
                className="model-delete-button"
                onClick={handleShow}
            >
                <DeleteDustbin />
            </button>
            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="request-leave width-40vw"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Delete a Default Imprest Type</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div">
                        Are You Sure You Want to delete the default Imprest Type "{i.other_name}" of {i.sub_company_title}
                        <div className="button-models">
                            <button
                                className="model-button model-button-cancel font-weight500"
                                onClick={handleClose}
                            >
                                Cancel
                            </button>
                            <button
                                onClick={handleFormSubmitDelete}
                                className="model-button model-button-delete font-weight500"
                                disabled={loading}
                            >
                                Delete
                            </button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>

        </>
    );
};

export {
    PayrollCycleRow,
    SettingRow,
    SettingListRow,
    EditSettingButton,

    SetupAllSettingsButton,
    EditAllSettingButton,

    RunManualLeaveEncashment,

    AddApprovalFormat,
    ViewApprovalFormatFlow,
    ViewVersionHistory,

    UpdateApprovalFormat,

    DeleteApprovalFormatBackup,
    DeleteApprovalFormat,

    AddDefaultImprestType,
    UpdateDefaultImprestType,
    DeleteDefaultImprestType,

    SandwichRuleExplanation,
}